import { CreateUpdateTBSCategory } from "../interface/tbs-category";
import axios, { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import {
  ChangePasswordReqEntity,
  CreateReportFieldsMappingReqEntity,
  CreateTrackerReportFieldsMappingReqEntity,
  CreateUpdateGlassSolutionReqPayloadEntity,
  CreateUpdateSolutionReqPayloadEntity,
  CreateUserStateMappingReqEntity,
  DesginReqEntity,
  DownloadReqBodyEntity,
  FetchOrderConfigurationReq,
  FetchOrientationSubOrientationReq,
  FirstTimeChangePasswordReqEntity,
  FrameColorsReqEntity,
  GetAllDesignReqEntity,
  GetAllModelsReqEntity,
  GetAllRolesReqEntity,
  GetAllStatesResEntity,
  GetAllSystemReqEntity,
  GetAllUsersReqEntity,
  GetAllWaltzFinishReqEntity,
  GetAllWaltzSubCategoriesReqEntity,
  GetAllWaltzVariantReqEntity,
  GlassCategoryReqEntity,
  GlassFinishesReqEntity,
  GlassMappingEntity,
  GlassSubCategoryReqEntity,
  GlassVariantsReqEntity,
  GoodsDeleveryEntity,
  GridReqEntity,
  HandlesReqEntity,
  LockReqEntity,
  ModelsReqEntity,
  PaginateReqEntity,
  RolesReqEntity,
  SaveUserMappingReqBodyEntity,
  SignInReqEntity,
  StatesReqEntity,
  SubSystemReqEntity,
  SystemReqEntity,
  SystemTypeReqEntity,
  UsersDetailsReqEntity,
  WorkflowRouteReqEntity
} from "../interface";
import {
  ApproveArchitectDetailsReqBodyEntity,
  GetAllArchitectDetailsReqEntity,
} from "../interface/architect-details";
import {
  AutoCompleteCityReqEntity,
  CityReqEntity,
  CountryStateCityToggleChangeStatusReqEntity,
  GetAllCitiesResEntity,
} from "../interface/cities";

import {
  DashboardFiltersEntity,
  TrafficLightDashboardFiltersEntity,
} from "../interface/dashboard";

import {
  AddressMapboxDetailsReqEntity,
  CustomerBillingInformationReqBodyEntity,
  LedgerReqEntity,
} from "../interface/ledger-form";
import { CreateUpdateOfficeReqEntity } from "../interface/offices";
import {
  CreateOrderReqEntity,
  GenerateOrderReqEntity,
  GetAllOrdersReqEntityV1,
  MarkAsFeasibleSolutionReqEntity,
  OrderComparisonsPdfEntity,
  PreClosureOrderStatusCommercialWinReqEntity,
  SearchArchitectFirmNameReqEntity,
  UpdateOrderReqEntity,
  UpdateOrderStatusCommercialWinReqEntity,
  UpdateOrderStatusHandoverReq,
  UpdateOrderStatusPreclosureReq
} from "../interface/order";

import { CreateUpdateInvoiceTermsAndCondition } from "../interface/Invoice-terms-condition";
import { AccessoryOnlyReqEntity } from "../interface/accessory-only";
import { AddressesProviderAutoCompleteAPI, GeolocationDetailsReqEntity } from "../interface/address-form";
import {
  AlbumAccessibility,
  CreateUpdateAlbumEntity,
  HideShowAlbum,
} from "../interface/albums";
import { APIResponseEntity } from "../interface/api-responce";
import { DownloadCSStickerReqEntity } from "../interface/location-tracker";
import { ProjectTrackerDetailReqEntity, ProjectTrackerDocumentFlagCloseReqEntity, ProjectTrackerDocumentFlagReplyReqEntity, ProjectTrackerDocumentFlagReqEntity, ProjectTrackerFlagExportReqEntity, ProjectTrackerFlagListReqEntity, ProjectTrackerNextActionReqEntity } from "../interface/project-tracker";
import {
  CampaignReqEntity,
  GetAllCampaignReqEntity,
  ImportFilterValueEntity,
} from "../interface/campaign";
import {
  AddCompanyDirectoryMasterReqEntity,
  DirectoryMasterUserAndCompanyPaginateReqEntity,
  DirectoryReqEntityArchitectUser,
} from "../interface/directory-master";
import { DrawingReqEntity } from "../interface/drawing";
import {
  EducationAssetsCompleteMultipartReqEntity,
  EducationAssetsMultipartInitiateReqEntity,
  UpdateEducationFieldsReqEntity,
} from "../interface/education-module/education-assets-multipart-chunk-interface";
import { EducationAssetsListingReqEntity } from "../interface/education-module/education-module";
import { FetchAllEmailQueueReqEntity } from "../interface/email-history";
import { ConfigReqBodyEntity } from "../interface/glass-order";
import { ComnonIndiaDesignFilterReqEntity } from "../interface/india-design/india-design-event";
import { FilterAgentReqEntity } from "../interface/insurance-agents";
import {
  InsurancePolicyReqEntity,
  InsurancePolicyReqFormEntity,
} from "../interface/insurance-policy";
import { InsuranceAgentReqEntity } from "../interface/insurence-agent.interface";
import {
  CreateUpdateMeetingConfiguration,
  GetAllB2BReqEntity,
  GetAllMeetingsReqEntity,
  SendMessage,
} from "../interface/jb-connect/meetings";
import {
  AssignLeadRequest,
  ConvertToOrderRequest,
  CreateLeadRequest,
  DisqualifyLeadRequest,
  ExportLeadsRequest,
  GetAllLeadsRequest,
  UpdateLeadRequest,
} from "../interface/leads";
import { GetAllLeadsSharedDetailsReqEntity } from "../interface/leads-shared";
import { AutoCompleteAddressReqEntity } from "../interface/mapbox";
import {
  FetchErrorsListsReqEntity,
  MarkErrorReadyForReviewReqBody,
  ObservationSaveProductionTeamDetailsEntity,
} from "../interface/observation-error";
import {
  AdditionalPanelOnlyDetailEntity,
  SaveAdditionalOffersForPanelOnlyReqEntity,
  SaveAdditionalOffersReqEntity,
} from "../interface/office-additional-dealer-discount";
import { OnlineUsersEntity } from "../interface/online-users";
import { PanelOnlyReqEntity } from "../interface/panel-only";
import {
  CreateRefundPaymentReqPayloadEntity,
  GeneratePaymentLinkReqEntity,
  GetAllPaymentRefundHistoryReqEntity,
  GetAllSettlementsReqEntity,
  SaveAsDraftTransactionReqEntity,
  SaveVoucherNumberReqEntity,
  VerifyRefundOTPReqEntity,
} from "../interface/payment";
import { GetAllPaymentHistoryReqEntity } from "../interface/payment-history";
import {
  APIMoveAlbumsImagesReqBody,
  APIUpdateTagsAndFileDisplayNameEntity,
  APIUpdateTagsForMultiplePhotosEntity,
  photoShowHideAPIEntity,
} from "../interface/photos-grid";
import { ReleaseNewPricingVersionReqEntity } from "../interface/pricing-version";
import { FetchDraftWorkOrdersReqEntity } from "../interface/production-planning/DraftWorkOrderEntity";
import { MakeWOAsDeliveredReqEntity } from "../interface/production-planning/dispatch-manager";
import {
  FetchSolutionDetailsRequestBodyEntity,
  GenerateWorkOrderReq,
  MarkWOSolutionAsReadyPackageDetailEntity,
} from "../interface/production-planning/execution-order-detail";
import {
  ProjectManagerBICListreqFilterEntity,
  reassignmentOfSMAndDMReqEntity,
} from "../interface/production-planning/project-manager";
import {
  SD_StampApproveSolutionEntity,
  SubmitLinkedShopDrawingEntity,
} from "../interface/production-planning/shop-drawing.interface";
import {
  CreateDeliveryAdviceReqEntity,
  DeliveryAdviceListReqEntity,
  GenerateEWayBillForWorkOrderInvoiceDistanceReqEntity,
  GenerateEWayBillForWorkOrderInvoiceReqEntity,
  GenerateInvoiceForWorkOrderReqEntity,
  MasterDeliveryAdviceListReqEntity,
  PlanDispatchRequestEntity,
  UpdateDeliveryAdviceReqEntity,
  UpdateFullDispatchValue,
  UpdateInvoiceDetailsReqEntity,
  UploadedDrawingFileEntity,
} from "../interface/production-planning/work-order-details";
import { RedFlagRecordsEntity } from "../interface/red-flag";
import { SaveRefundVoucherReqEntity } from "../interface/refund-payment";
import { CreateTagEntity } from "../interface/tags";
import { SaveModelSelectionReqEntity, SendForTBSFilterReq } from "../interface/tbs-tracker/send-tbs";
import {
  GetAllTraderBySocialDetailsReqEntity,
  TraderContactEntity,
} from "../interface/trader-by-social";
import {
  AddDriverDetailsInTransporterContactDetailReqEntity,
  FilterTransporterReqEntity,
  TransporterReqEntity,
  UpdateDriverMobileNumberInTransporterReqEntity,
} from "../interface/transporter";
import { UserSignInTrackingEntity } from "../interface/user-sign-in-tracking";
import { FetchAllWhatsAppQueueReqEntity } from "../interface/whatsapp-history";
import {
  DeliveryAdviceDetailV2ReqEntity,
  GenerateInvoiceForWorkOrderReqV2Entity,
} from "../pages/production-planning/components/delivery-advice/v2/interface/delivery-advice-steps.interface";
import { FilterTrustSealDetailEntity } from "../pages/trust-seal/interface/trust-seal.interface";
import { BaseEndpoints } from "../utils/base-endpoints";
import { toastOptObj } from "../utils/constants";
import {
  InvoiceSendEventEnumEntity,
  OrderStatusEnumEntity,
  StorageKeyEnum,
  UserSignInTrackEnumEntity,
  TBSTypeEnumEntity,
} from "../utils/enum";
import {
  IsNullOrUndefined,
  IsStringNullEmptyOrUndefined
} from "../utils/null-check";
import { getLocalStorageItem } from "./storage-service";
import { SaveAssignLocationsReqEntity } from "../interface/tbs-tracker/send-tbs"
import { IssueMaterialReq, ReturnExtraItemsReq, SaveHandleFabricationCodesReq, TBSStoreFilterReq, VerificationReqEntity } from "../interface/tbs-tracker/tbs-store";
import { CreateUpdateDepartmentMaster, CreateUpdateMasterTrack, CreateUpdateNamedTrack, CreateUpdateSalesHeadHoldReason, CreateUpdateWorkCenter, CreateUpdateWorkOrderHoldReason, CreateUpdateWorkStation, UserWorkStationMappingReqEntity } from "../interface/production-master";
import { CreateUpdateCSMasterTypesReq } from "../interface/settings/cs-master-types";
import { CreateUpdateBOMUOMReq } from "../interface/settings/bom-uom";
import { BOMModelCascadeEntity, BOMModelWiseMappingCopyReqEntity, BOMModelWiseMappingCreateReqEntity, BOMModelWiseMappingListReqEntity, BOMModelWiseMappingUpdateReqEntity, BOMOrientationDDLReqEntity, BOMReferenceModulesDDLReqEntity } from "../interface/settings/bom-mapping";
import { CSMasterFormulaMappingReqEntity, CSMasterFormulaRemoveReqEntity, CSMasterFrameColorMappingReqEntity, CSMasterFrameColorRemoveReqEntity, CSMasterListReqEntity, CSMasterTypeMappingReqEntity } from "../interface/settings/cs-master";
import { RMProjectionDetailsExportReqEntity, RMProjectionDetailsReqEntity, RMProjectionListExportReqEntity, RMProjectionListReqEntity } from "../interface/production-planning/rm-projection";

export const APIURL = process.env.REACT_APP_API_URL;

export const APIURL_CONNECT = process.env.REACT_APP_CONNECT_URL;

const axiosConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

const pendingRequests = new Set<AbortController>();

export const addPendingRequest = (controller: AbortController) =>
  pendingRequests.add(controller);
export const cancelAllPendingRequests = () => {
  pendingRequests.forEach((c) => c.abort());
  pendingRequests.clear();
};
let isSessionExpired = false;

axios.interceptors.request.use(
  (config) => {
    if (isSessionExpired) {
      const cancelController = new AbortController();
      cancelController.abort();
      throw new axios.Cancel("Session expired — no further requests allowed");
    }
    const controller = new AbortController();
    config.signal = controller.signal;
    addPendingRequest(controller);
    if (axiosConfig.headers) {
      axiosConfig.headers["authorization"] = `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`;
    }
    config.headers = axiosConfig.headers as AxiosHeaders;
    let signInFrom = UserSignInTrackEnumEntity.WEBSITE;
    config.headers["x-signin-from"] = signInFrom;
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let message =
      "A small error has occurred, causing an interruption of service. Please try again";

    console.log("Error\n", error);

    if (axios.isAxiosError(error) && error.code === "ERR_NETWORK") {
      message =
        "We're having trouble connecting to the network. Please try again later.";
    }

    if (error && error.response) {
      const errResp: AxiosResponse = error.response;

      if (errResp && errResp.data && !errResp.data.status) {
        message =
          errResp.data &&
            errResp.data.statusCode &&
            errResp.data.statusCode === 400
            ? errResp.data.message
            : error.response.data.message;

        if (!(error.config as AxiosRequestConfig & { skipGlobalErrorToast?: boolean })?.skipGlobalErrorToast) {
          toast.error(message, { ...toastOptObj, toastId: "error" });
        }

        if (error.response.data && error.response.data.statusCode === 440) {
          isSessionExpired = true;
          cancelAllPendingRequests();
          // window.location.href = "/";
          localStorage.removeItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN);
          localStorage.removeItem(StorageKeyEnum.JB_GLASS_USER_PROFILE_PICTURE);
          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        }

        setTimeout(() => {
          if (
            error.response.data &&
            error.response.data.data &&
            !IsNullOrUndefined(error.response.data.data) &&
            error.response.data.data.orderStatus ===
            OrderStatusEnumEntity.SYSTEM_ERROR
          ) {
            window.location.href =
              error.response.data.data.redirectTo === "waltz-order"
                ? "/wall-orders"
                : "/work-order-details";
          }

          if (error.response.data && error.response.data.statusCode === 503) {
            window.location.href = "/under-maintenance";
            localStorage.removeItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN);
            localStorage.removeItem(
              StorageKeyEnum.JB_GLASS_USER_PROFILE_PICTURE,
            );
          }
        }, 3000);
      }
    }

    // toast.error(message, { ...toastOptObj, toastId: "error" });
    // Promise.reject(error);
  },
);

export const APIUpdateUserActivity = async (
  isActiveNow: boolean,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.onlineUsers}/create-update-current-users`,
    {
      isActiveNow,
    },
  );
};

export const APIActiveUsers = async (
  filterReq: OnlineUsersEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.userName && !IsStringNullEmptyOrUndefined(filterReq.userName)) {
    query = query.concat(`&userName=${filterReq.userName}`);
  }

  if (
    filterReq.emailAddress &&
    !IsStringNullEmptyOrUndefined(filterReq.emailAddress)
  ) {
    query = query.concat(`&emailAddress=${filterReq.emailAddress}`);
  }

  if (filterReq.mobileNo && !IsStringNullEmptyOrUndefined(filterReq.mobileNo)) {
    query = query.concat(`&mobileNo=${filterReq.mobileNo}`);
  }

  if (
    filterReq.officeName &&
    !IsStringNullEmptyOrUndefined(filterReq.officeName)
  ) {
    query = query.concat(`&officeName=${filterReq.officeName}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&createFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&createToDate=${filterReq.createToDate}`);
  }

  if (
    filterReq.signInFrom &&
    !IsStringNullEmptyOrUndefined(filterReq.signInFrom)
  ) {
    query = query.concat(`&signInFrom=${filterReq.signInFrom}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.onlineUsers}/active-user?${query}`,
  );
};

export const APIFetchOrdersForPyamentAutoSuggestion =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.order}/v1.0/fetch-orders-for-payment-auto-suggestion-request`,
    );
  };

export const APIFetchOrdersForPyamentAutoSuggestionV2 = async (
  format: "xlsx" | "json",
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v2.0/fetch-orders-for-payment-auto-suggestion-request?format=${format}`,
  );
};

export const APIFetchLatestSettledTXN = async (
  orderReferenceNumber: string,
  overDue: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.payment}/get-latest-TXN-from-order-no/${orderReferenceNumber}/${overDue}`,
  );
};

export const APIGeneratePaymentLink = async (
  body: GeneratePaymentLinkReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.payment}/generate-payment-link`,
    body,
  );
};

export const APISaveTransactionAsDraft = async (
  body: SaveAsDraftTransactionReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.payment}/save-as-draft`,
    body,
  );
};

export const APIGetAllPaymentHistory = async (
  body: GetAllPaymentHistoryReqEntity,
): Promise<AxiosResponse> => {
  let queryParams: string = `pageSize=${body.pageSize}&pageNumber=${body.pageNumber + 1
    }&sortColumn=${body.sortColumn}&sortOrder=${body.sortOrder}`;

  if (body.startDate && !IsStringNullEmptyOrUndefined(body.startDate)) {
    queryParams = queryParams.concat(`&startDate=${body.startDate}`);
  }

  if (body.endDate && !IsStringNullEmptyOrUndefined(body.endDate)) {
    queryParams = queryParams.concat(`&endDate=${body.endDate}`);
  }

  if (
    body.settlementStartDate &&
    !IsStringNullEmptyOrUndefined(body.settlementStartDate)
  ) {
    queryParams = queryParams.concat(
      `&settlementStartDate=${body.settlementStartDate}`,
    );
  }

  if (
    body.settlementEndDate &&
    !IsStringNullEmptyOrUndefined(body.settlementEndDate)
  ) {
    queryParams = queryParams.concat(
      `&settlementEndDate=${body.settlementEndDate}`,
    );
  }

  if (
    body.searchTransactionReferenceId &&
    !IsStringNullEmptyOrUndefined(body.searchTransactionReferenceId)
  ) {
    queryParams = queryParams.concat(
      `&searchTransactionReferenceId=${body.searchTransactionReferenceId}`,
    );
  }

  if (
    body.searchByEazypayTXNId &&
    !IsStringNullEmptyOrUndefined(body.searchByEazypayTXNId)
  ) {
    queryParams = queryParams.concat(
      `&searchByEazypayTXNId=${body.searchByEazypayTXNId}`,
    );
  }

  if (
    body.searchOfficeName &&
    !IsStringNullEmptyOrUndefined(body.searchOfficeName)
  ) {
    queryParams = queryParams.concat(
      `&searchOfficeName=${body.searchOfficeName}`,
    );
  }

  if (
    body.searchPaymentMode &&
    !IsStringNullEmptyOrUndefined(body.searchPaymentMode)
  ) {
    queryParams = queryParams.concat(
      `&searchPaymentMode=${body.searchPaymentMode}`,
    );
  }

  if (body.status && !IsStringNullEmptyOrUndefined(body.status)) {
    queryParams = queryParams.concat(`&status=${body.status}`);
  }

  return await axios.get(
    // `${APIURL}/${BaseEndpoints.paymentHistory}/get-all?${queryParams}`
    `${APIURL}/${BaseEndpoints.paymentHistory}/v1.0/get-all?${queryParams}`,
  );
};

export const APIFetchTransactionSummary = async (
  transactionReferenceId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.payment}/get-transaction-summary/${transactionReferenceId}`,
  );
};

export const APIFetchRefundPaymentSummary = async (
  ezpaytranid: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.refundPayment}/get-refund-history-by-eazypay-id/${ezpaytranid}`,
  );
};

export const APIFetchRefundSummary = async (
  recordId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.refundPaymentV2}/get-refund-summary-by-id/${recordId}`,
  );
};

export const APIFetchRefundDetailsById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.refundPayment}/get-details/${id}`,
  );
};

export const APICreateRefundPayment = async (
  reqBody: CreateRefundPaymentReqPayloadEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.refundPayment}/create`,
    reqBody,
  );
};

export const APICreateRefundPaymentV2 = async (reqBody: CreateRefundPaymentReqPayloadEntity): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.refundPaymentV2}/create`, reqBody);
};

export const APIRefundPaymentSendOTP = async (
  reqBody: CreateRefundPaymentReqPayloadEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.refundPayment}/send-OTP`,
    reqBody,
  );
};

export const APIRefundPaymentVerifyOTP = async (
  reqBody: VerifyRefundOTPReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.refundPayment}/verify-OTP`,
    reqBody,
  );
};

export const APIGetAllRefundPaymentHistory = async (
  body: GetAllPaymentRefundHistoryReqEntity,
): Promise<AxiosResponse> => {
  let queryParams: string = `pageSize=${body.pageSize}&pageNumber=${body.pageNumber + 1}`;

  if (
    body.searchTransactionReferenceId &&
    !IsStringNullEmptyOrUndefined(body.searchTransactionReferenceId)
  ) {
    queryParams = queryParams.concat(
      `&searchTransactionReferenceId=${body.searchTransactionReferenceId}`,
    );
  }

  if (body.status && !IsStringNullEmptyOrUndefined(body.status)) {
    queryParams = queryParams.concat(`&status=${body.status}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.refundPayment}/get-all-history?${queryParams}`,
  );
};

export const APIGetAllRefundPaymentHistoryV2 = async (
  body: GetAllPaymentRefundHistoryReqEntity,
): Promise<AxiosResponse> => {
  let queryParams: string = `pageSize=${body.pageSize}&pageNumber=${body.pageNumber + 1}`;

  if (
    body.searchTransactionReferenceId &&
    !IsStringNullEmptyOrUndefined(body.searchTransactionReferenceId)
  ) {
    queryParams = queryParams.concat(
      `&searchTransactionReferenceId=${body.searchTransactionReferenceId}`,
    );
  }

  if (
    body.searchEazypayTXNId &&
    !IsStringNullEmptyOrUndefined(body.searchEazypayTXNId)
  ) {
    queryParams = queryParams.concat(
      `&searchEazypayTXNId=${body.searchEazypayTXNId}`,
    );
  }

  if (body.status && !IsStringNullEmptyOrUndefined(body.status)) {
    queryParams = queryParams.concat(`&refundProcessStatus=${body.status}`);
  }

  if (body.sortColumn && !IsStringNullEmptyOrUndefined(body.sortColumn)) {
    queryParams = queryParams.concat(`&sortColumn=${body.sortColumn}`);
  }

  if (body.sortOrder && !IsStringNullEmptyOrUndefined(body.sortOrder)) {
    queryParams = queryParams.concat(`&sortOrder=${body.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.refundPaymentV2}/get-refunds?${queryParams}`,
  );
};

export const APICheckAndAdjustInitiatedTransactions = async (
  transactionReferenceId: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.payment}/check-and-adjust-initiated-transactions/${transactionReferenceId}`,
  );
};

export const APISimulatePaymentSuccess = async (
  transactionReferenceId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/payment-utilities/simulate-payment-to-success`,
    { transactionReferenceId },
  );
};

export const APIExportPaymentHistoryTransaction =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.paymentHistory}/export-transaction`,
    );
  };

export const APIExportRefundPaymentHistory =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.refundPayment}/export-refund-history`,
    );
  };

export const APIExportSettlements = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.payment}/export-settlements`,
  );
};

export const APIExportOrderDues = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.order}-dues/export-dues`);
};

export const APIExportFeedback = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.order}/export-feedback`);
};

export const APISaveVoucherNumber = async (
  reqBody: SaveVoucherNumberReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.payment}/save-voucher-number`,
    reqBody,
  );
};

export const APISaveRefundVoucherNumber = async (
  reqBody: SaveRefundVoucherReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.refundPayment}/save-voucher-number`,
    reqBody,
  );
};

export const APIGetAllSettlements = async (
  body: GetAllSettlementsReqEntity,
): Promise<AxiosResponse> => {
  let queryParams: string = `pageSize=${body.pageSize}&pageNumber=${body.pageNumber + 1
    }`;

  if (
    body.settlementStartDate &&
    !IsStringNullEmptyOrUndefined(body.settlementStartDate)
  ) {
    queryParams = queryParams.concat(
      `&settlementStartDate=${body.settlementStartDate}`,
    );
  }

  if (
    body.settlementEndDate &&
    !IsStringNullEmptyOrUndefined(body.settlementEndDate)
  ) {
    queryParams = queryParams.concat(
      `&settlementEndDate=${body.settlementEndDate}`,
    );
  }

  if (body.sortOrder && !IsStringNullEmptyOrUndefined(body.sortOrder)) {
    queryParams = queryParams.concat(`&sortOrder=${body.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.payment}/get-all-settlements?${queryParams}`,
  );
};

export const APIGetAllDraftTransactions = async (body: {
  pageSize: number;
  pageNumber: number;
  sortOrder?: "asce" | "desc";
}): Promise<AxiosResponse> => {
  let queryParams: string = `pageSize=${body.pageSize}&pageNumber=${body.pageNumber + 1
    }`;

  if (body.sortOrder && !IsStringNullEmptyOrUndefined(body.sortOrder)) {
    queryParams = queryParams.concat(`&sortOrder=${body.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.payment}/get-all-draft?${queryParams}`,
  );
};

export const APIDeleteDraftTransaction = async (
  draftNo: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.payment}/delete-draft-transaction/${draftNo}`,
  );
};

export const APIExportErrors = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.observationError}/export-errors`,
  );
};

export const APIErrorsListing = async (
  reqBody: FetchErrorsListsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.observationError}/fetch-errors-listing`,
    reqBody,
  );
};
export const APIErrorDueToDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.observationError}/fetch-errorDueto-ddl`,);
};

export const APIFetchErrorDetailsById = async (
  errorId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.observationError}/fetch-error-details-by-Id/${errorId}`,
  );
};
export const APIFetchErrorDetailsByIdV2 = async (errorId: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.observationError}/v2/fetch-error-details-by-Id/${errorId}`);
};

export const APIMarkErrorForClosed = async (reqBody: {
  errorId: string;
  closeReason: string;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.observationError}/close-error`,
    reqBody,
  );
};

export const APIMarkErrorForReturned = async (reqBody: { errorId: string; returnedReason: string; }): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.observationError}/v2/return-error`, reqBody);
};

export const APICreateErrorWorkOrder = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.observationError}/generate-error-work-order`,
    data,
  );
};

export const APIMarkReadyForReviewed = async (
  reqBody: MarkErrorReadyForReviewReqBody,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.observationError}/mark-error-ready-for-reviewed`,
    reqBody,
  );
};

export const APIFetchOrderDues = async (
  searchOrderNumber: string | null,
): Promise<AxiosResponse> => {
  let query = "";

  if (
    searchOrderNumber &&
    !IsNullOrUndefined(searchOrderNumber) &&
    !IsStringNullEmptyOrUndefined(searchOrderNumber)
  ) {
    query = query.concat(`searchOrderNumber=${searchOrderNumber}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}-dues/get-all?${query}`,
  );
};

export const APIAnalyticsDDList = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/report/get-orders-report`, reqObj);
};

export const APICreateSystemType = async (
  reqObj: SystemTypeReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.systemTypeSetting}/create`,
    reqObj,
  );
};

export const APIFetchDetailsSystemType = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.systemTypeSetting}/get-all?${query}`,
  );
};

export const APIUpdateSystemType = async (
  reqObj: SystemTypeReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.systemTypeSetting}/update/${id}`,
    reqObj,
  );
};

export const APIDeleteSystemType = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.systemTypeSetting}/delete/${id}`,
  );
};

export const APICreateSubSystem = async (
  reqObj: SubSystemReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.subSystemSetting}/create`,
    reqObj,
  );
};

export const APIFetchDetailsSubSystem = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.subSystemSetting}/get-all?${query}`,
  );
};

export const APIFetchPMBICLists = async (
  filterReq: ProjectManagerBICListreqFilterEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/v1.0/fetch-PM-BIC-lists`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIUpdateSubSystem = async (
  reqObj: SubSystemReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.subSystemSetting}/update/${id}`,
    reqObj,
  );
};

export const APIDeleteSubSystem = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.subSystemSetting}/delete/${id}`,
  );
};

export const APICreateSystem = async (
  reqObj: SystemReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.systemSetting}/create`,
    reqObj,
  );
};

export const APIGetSystemTypeDDL = async (
  ids: string[] | [] = [],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.systemTypeSetting}/get-ddl`,
    { ids },
  );
};

export const APIGetSubSystemTypeDDL = async (
  subSystemIds: string[] | [] = [],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.subSystemSetting}/get-ddl`,
    { ids: subSystemIds },
  );
};

export const APIGetSystemDDL = async (
  systemId: string | undefined = "",
  subSystemId: string | undefined = "",
  systemTypeId: string | undefined = "",
  forFilter: boolean,
  isRoleBasedSystemCheck: string | undefined = "NO",
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.systemSetting}/get-ddl?systemId=${systemId}&subSystemId=${subSystemId}&systemTypeId=${systemTypeId}&forFilter=${forFilter}&isRoleBasedSystemCheck=${isRoleBasedSystemCheck}`,
  );
};

export const APIFetchDetailsSystem = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  return await axios.get(
    `${APIURL}/${BaseEndpoints.systemSetting}/get-all?${query}`,
  );
};

export const APIDeleteSystem = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.systemSetting}/delete/${id}`,
  );
};

export const APIUpdateSystem = async (
  reqObj: SystemReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.systemSetting}/update/${id}`,
    reqObj,
  );
};

export const APIGetSystemById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.systemSetting}/get-system/${id}`,
  );
};

export const APIGetWaltzFinishDDL = async (data: {
  ids: string[] | [];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/get-ddl`,
    data,
  );
};

export const APIGetUserRolesDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.role}/get-ddl`);
};

export const APIGetSystemDefineRoleCategoryDDL = async (includeRoleData: boolean = false): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.role}/get-system-define-role-category-ddl`,
    {
      params: {
        includeRoleData
      }
    }
  );
};

export const APIGetSystemDefinedRoles = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.role}/get-system-define-roles`);
};

export const APICreateUser = async (
  reqObj: UsersDetailsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.user}/create`, reqObj);
};

export const APIUpdateUser = async (
  reqObj: UsersDetailsReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.user}/update/${id}`,
    reqObj,
  );
};

export const APIFetchUsers = async (
  filterReq: GetAllUsersReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.userName && !IsStringNullEmptyOrUndefined(filterReq.userName)) {
    query = query.concat(`&userName=${filterReq.userName}`);
  }

  if (filterReq.mobileNo && !IsStringNullEmptyOrUndefined(filterReq.mobileNo)) {
    query = query.concat(`&mobileNo=${filterReq.mobileNo}`);
  }

  if (
    filterReq.emailAddress &&
    !IsStringNullEmptyOrUndefined(filterReq.emailAddress)
  ) {
    query = query.concat(`&emailAddress=${filterReq.emailAddress}`);
  }

  if (
    filterReq.userFullName &&
    !IsStringNullEmptyOrUndefined(filterReq.userFullName)
  ) {
    query = query.concat(`&userFullName=${filterReq.userFullName}`);
  }

  if (
    filterReq.officeName &&
    !IsStringNullEmptyOrUndefined(filterReq.officeName)
  ) {
    query = query.concat(`&officeName=${filterReq.officeName}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&createFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&createToDate=${filterReq.createToDate}`);
  }

  if (filterReq.roleId && !IsStringNullEmptyOrUndefined(filterReq.roleId)) {
    query = query.concat(`&roleId=${filterReq.roleId}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (filterReq.teamCategory) {
    query = query.concat(`&teamCategory=${filterReq.teamCategory}`);
  }

  if (filterReq.systemRoleCategory) {
    query = query.concat(
      `&systemRoleCategory=${filterReq.systemRoleCategory}`
    );
  }

  if (filterReq.platformAccess) {
    query = query.concat(`&platformAccess=${filterReq.platformAccess}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-all?${query}`);
};

export const APIDeleteUser = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.user}/delete/${id}`);
};

export const APIFetchUsersByRoleName = async (
  roleName: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.user}/fetch-users-by-role?role=${roleName}`,
  );
};

export const APIFetchUserById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-user/${id}`);
};

export const APICreateModel = async (
  reqObj: ModelsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.modelSetting}/create`,
    reqObj,
  );
};

export const APIUpdateModel = async (
  reqObj: ModelsReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.modelSetting}/update/${id}`,
    reqObj,
  );
};

export const APIUplodeMediaModels = async (
  data: FormData,
  id: string,
  fieldName: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      fieldName: fieldName,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.modelSetting}/upload-media/${id}`,
    data,
  );
};

export const APIUploadModelAttachment = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.modelSetting}/upload-attachment/${id}`,
    data,
  );
};

export const APIFetchDetailsAllNewSystem = async (
  filterReq: GetAllSystemReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.systemId && !IsStringNullEmptyOrUndefined(filterReq.systemId)) {
    query = query.concat(`&systemId=${filterReq.systemId}`);
  }

  if (
    filterReq.subSystemId &&
    !IsStringNullEmptyOrUndefined(filterReq.subSystemId)
  ) {
    query = query.concat(`&subSystemId=${filterReq.subSystemId}`);
  }

  if (
    filterReq.systemTypeId &&
    !IsStringNullEmptyOrUndefined(filterReq.systemTypeId)
  ) {
    query = query.concat(`&systemTypeId=${filterReq.systemTypeId}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.systemSetting}/get-all-new?${query}`,
  );
};

export const APIFetchDetailsModel = async (
  filterReq: GetAllModelsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.orientation &&
    !IsStringNullEmptyOrUndefined(filterReq.orientation)
  ) {
    query = query.concat(`&orientation=${filterReq.orientation}`);
  }

  if (
    filterReq.subOrientation &&
    !IsStringNullEmptyOrUndefined(filterReq.subOrientation)
  ) {
    query = query.concat(`&subOrientation=${filterReq.subOrientation}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&createFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&createToDate=${filterReq.createToDate}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.systemId && !IsStringNullEmptyOrUndefined(filterReq.systemId)) {
    query = query.concat(`&systemId=${filterReq.systemId}`);
  }

  if (
    filterReq.subSystemId &&
    !IsStringNullEmptyOrUndefined(filterReq.subSystemId)
  ) {
    query = query.concat(`&subSystemId=${filterReq.subSystemId}`);
  }

  if (
    filterReq.systemTypeId &&
    !IsStringNullEmptyOrUndefined(filterReq.systemTypeId)
  ) {
    query = query.concat(`&systemTypeId=${filterReq.systemTypeId}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-all?${query}`,
  );
};

export const APIGetModelById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-model/${id}`,
  );
};

export const APIDownloadCSCodeBOMMappingPDF = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.modelSetting}/download-cscode-bom-mapping-pdf/${id}`,
  );
};

export const APIDeleteModel = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.modelSetting}/delete/${id}`,
  );
};

export const APIGlassSubCategoriesSaveCatalogueAbout = async (
  data: FormData,
  customHeaders?: Record<string, string>,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      "Custom-Multipart-Header": "true",
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/save-sub-category-catalogue-about-details`,
    data,
    {
      headers: {
        ...(customHeaders || {}),
      },
    },
  );
};

export const APIGlassSubCategoriesSaveCatalogueApplication = async (
  data: FormData,
  customHeaders?: Record<string, string>,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      "Custom-Multipart-Header": "true",
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/save-sub-category-catalogue-applications-details`,
    data,
    {
      headers: {
        ...(customHeaders || {}),
      },
    },
  );
};

export const APIFetchCatalogueAboutList = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/get-all-catalogue-about/${id}`,
  );
};

export const APIFetchCatalogueApplicationList = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/get-all-catalogue-application/${id}`,
  );
};

export const APIGlassSubCategoriesDDL = async (data: {
  ids: string[] | [];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/get-ddl`,
    data,
  );
};

export const APICreateGlassSubCategory = async (
  reqPayload: GlassSubCategoryReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/create`,
    reqPayload,
  );
};

export const APIUpdateGlassSubCategory = async (
  id: string,
  reqPayload: GlassSubCategoryReqEntity,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/update/${id}`,
    reqPayload,
  );
};

export const APIDeleteGlassSubCategory = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/delete/${id}`,
  );
};

export const APIFetchSubCategorty = async (
  filterReq: GetAllWaltzSubCategoriesReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (
    filterReq.searchFinishName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchFinishName)
  ) {
    query = query.concat(`&searchFinishName=${filterReq.searchFinishName}`);
  }

  if (
    filterReq.searchSubCategoryName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchSubCategoryName)
  ) {
    query = query.concat(
      `&searchSubCategoryName=${filterReq.searchSubCategoryName}`,
    );
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassSubCategoriesSettings}/get-all?${query}`,
  );
};

export const APICreateGlassCategory = async (
  reqPayload: GlassCategoryReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/create`,
    reqPayload,
  );
};

export const APIAddressesProviderAutoComplete = async (
  reqBody: AddressesProviderAutoCompleteAPI,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.addressesProvider}/autoComplete`,
    reqBody,
  );
};

export const APIAddressesProviderGetDetailsByID = async (
  providerID: string,
  providerName: string,
  searchOn: string,
): Promise<AxiosResponse> => {
  let query = `?searchOn=${searchOn}`;
  return await axios.get(
    `${APIURL}/${BaseEndpoints.addressesProvider}/fetch-provider-details/${providerID}/${providerName}${query}`,
  );
};

export const APIAddressesProviderGetDetailsByIDV1 = async (
  providerID: string,
  providerName: string,
  searchOn: string,
): Promise<AxiosResponse> => {
  let query = `?searchOn=${searchOn}`;
  return await axios.get(
    `${APIURL}/${BaseEndpoints.addressesProvider}/v1.0/fetch-provider-details/${providerID}/${providerName}${query}`,
  );
};

export const APIUpdateGlassCategory = async (
  id: string,
  reqPayload: GlassCategoryReqEntity,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/update/${id}`,
    reqPayload,
  );
};

export const APIDeleteGlassCategory = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/delete/${id}`,
  );
};

export const APIFetchCategorty = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/get-all?${query}`,
  );
};

export const APIHandlesSettingsDDL = async (
  handleIds: [] | string[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.handlesSettings}/get-ddl`,
    { ids: handleIds },
  );
};

export const APIFrameColorsDDL = async (
  ids: string[] | [] = [],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.frameColorsSettings}/get-ddl`,
    { ids },
  );
};

export const APICSMasterDDL = async (): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/get-ddl`, {});
};

export const APIToGetFrameColorFilterDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.csMasterSettings}/frame-color-ddl`
  );
};

export const APIToGetCSMasters = async (
  reqObj: CSMasterListReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.csMasterSettings}/get-all`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToGetActiveCSMasterTypes = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/get-active-types`, {});
};

export const APIToGetMappedCSMasterTypes = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/get-mapped-types`, {});
};

export const APIToGetCSMasterUnits = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/get-units`, {});
};

export const APIToMapCSMasterType = async (
  reqObj: CSMasterTypeMappingReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/map-type`, reqObj);
};

export const APIToMapCSMasterFrameColor = async (
  reqObj: CSMasterFrameColorMappingReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/map-frame-color`, reqObj);
};

export const APIToRemoveCSMasterFrameColor = async (
  reqObj: CSMasterFrameColorRemoveReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/remove-frame-color`, reqObj);
};

export const APIToMapCSMasterFormula = async (
  reqObj: CSMasterFormulaMappingReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/map-formula`, reqObj);
};

export const APIToRemoveCSMasterFormula = async (
  reqObj: CSMasterFormulaRemoveReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.csMasterSettings}/remove-formula`, reqObj);
};

export const APIToExportCSMaster = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.csMasterSettings}/export`
  );
};

export const APIToGetCSSyncStatus = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.csMasterSettings}/get-sync-status`
  );
};

export const APIGridDDL = async (data: {
  ids: string[] | [];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.gridSettings}/get-ddl`,
    data,
  );
};

export const APIGridDesignStructure = async (modelId?: string): Promise<AxiosResponse> => {
  const params = modelId ? { id: modelId } : {};
  return await axios.get(
    `${APIURL}/${BaseEndpoints.gridSettings}/get-grid-design-structure`,
    { params }
  );
};

export const APILockDDL = async (
  ids: string[] | [] = [],
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.lockSettings}/get-ddl`, {
    ids,
  });
};

export const APIGlassCategoriesDDL = async (
  glassMapping: GlassMappingEntity[] | undefined | [],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/get-ddl`,
    { mapping: glassMapping },
  );
};

export const APIGetSourceDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.source}/get-ddl`);
};

export const APICreateOrder = async (
  reqObj: CreateOrderReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/create-order`,
    reqObj,
  );
};

export const APIUpdateOrderStatusCommercialWin = async (
  reqObj: UpdateOrderStatusCommercialWinReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/update-order-status-commercial-win`,
    reqObj,
  );
};

export const APIUpdateOrderStatusHandover = async (
  reqObj: UpdateOrderStatusHandoverReq,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/update-order-status-handover`,
    reqObj,
  );
};

export const APIGetOrderDetailsById = async (
  orderId: string,
  skipCS: boolean,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/fetch-order-details/${orderId}?skipCS=${skipCS}`,
  );
};

export const APIGetOrientationsDetails = async (
  reqObj: FetchOrientationSubOrientationReq,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-orientations-details`,
    reqObj,
  );
};

export const APIGetOrderConfigurationDetails = async (
  reqObj: FetchOrderConfigurationReq,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-order-configuration`,
    reqObj,
  );
};

export const APICreateSolution = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/create-solution`,
    reqObj,
  );
};

export const APIEditSolution = async (
  orderId: string,
  solutionId: string,
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.order}/update-solution/${orderId}/${solutionId}`,
    reqObj,
  );
};

export const APIGetSolution = async (
  orderId: string,
  solutionId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/get-solution/${orderId}/${solutionId}`,
  );
};

export const APIFetchAllOrderDetails = async (
  filterReq: GetAllOrdersReqEntityV1,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.orderStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.orderStatus)
  ) {
    query = query.concat(`&orderStatus=${filterReq.orderStatus}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.searchByOrderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByOrderNumber)
  ) {
    query = query.concat(
      `&searchByOrderNumber=${filterReq.searchByOrderNumber}`,
    );
  }

  if (
    filterReq.searchByProjectName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByProjectName)
  ) {
    query = query.concat(
      `&searchByProjectName=${filterReq.searchByProjectName}`,
    );
  }

  if (
    filterReq.searchByClientName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByClientName)
  ) {
    query = query.concat(`&searchByClientName=${filterReq.searchByClientName}`);
  }

  // if (filterReq.searchByLocation && !IsStringNullEmptyOrUndefined(filterReq.searchByLocation)) {
  //     query = query.concat(`&searchByLocation=${filterReq.searchByLocation}`);
  // }

  if (
    filterReq.searchByCountry &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByCountry)
  ) {
    query = query.concat(`&searchByCountry=${filterReq.searchByCountry}`);
  }

  if (
    filterReq.searchByState &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByState)
  ) {
    query = query.concat(`&searchByState=${filterReq.searchByState}`);
  }

  if (
    filterReq.searchByCity &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByCity)
  ) {
    query = query.concat(`&searchByCity=${filterReq.searchByCity}`);
  }

  if (
    filterReq.orderFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.orderFromDate)
  ) {
    query = query.concat(`&orderFromDate=${filterReq.orderFromDate}`);
  }

  if (
    filterReq.orderToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.orderToDate)
  ) {
    query = query.concat(`&orderToDate=${filterReq.orderToDate}`);
  }

  if (
    filterReq.orderAmountFrom &&
    !IsStringNullEmptyOrUndefined(filterReq.orderAmountFrom)
  ) {
    query = query.concat(`&orderAmountFrom=${filterReq.orderAmountFrom}`);
  }

  if (
    filterReq.orderAmountTo &&
    !IsStringNullEmptyOrUndefined(filterReq.orderAmountTo)
  ) {
    query = query.concat(`&orderAmountTo=${filterReq.orderAmountTo}`);
  }

  if (filterReq.createdBy && !IsNullOrUndefined(filterReq.createdBy)) {
    query = query.concat(`&createdBy=${JSON.stringify(filterReq.createdBy)}`);
  }

  if (filterReq.source && !IsStringNullEmptyOrUndefined(filterReq.source)) {
    query = query.concat(`&sourceId=${filterReq.source}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v1.0/get-all?${query}`,
  );
};

export const APIFetchAllOrderDetailsV2 = async (
  filterReq: GetAllOrdersReqEntityV1,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.orderStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.orderStatus)
  ) {
    query = query.concat(`&orderStatus=${filterReq.orderStatus}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.searchByOrderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByOrderNumber)
  ) {
    query = query.concat(
      `&searchByOrderNumber=${filterReq.searchByOrderNumber}`,
    );
  }

  if (
    filterReq.searchByProjectName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByProjectName)
  ) {
    query = query.concat(
      `&searchByProjectName=${filterReq.searchByProjectName}`,
    );
  }

  if (
    filterReq.searchByClientName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByClientName)
  ) {
    query = query.concat(`&searchByClientName=${filterReq.searchByClientName}`);
  }

  // if (filterReq.searchByLocation && !IsStringNullEmptyOrUndefined(filterReq.searchByLocation)) {
  //     query = query.concat(`&searchByLocation=${filterReq.searchByLocation}`);
  // }

  if (
    filterReq.searchByCountry &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByCountry)
  ) {
    query = query.concat(`&searchByCountry=${filterReq.searchByCountry}`);
  }

  if (
    filterReq.searchByState &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByState)
  ) {
    query = query.concat(`&searchByState=${filterReq.searchByState}`);
  }

  if (
    filterReq.searchByCity &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByCity)
  ) {
    query = query.concat(`&searchByCity=${filterReq.searchByCity}`);
  }

  if (
    filterReq.orderFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.orderFromDate)
  ) {
    query = query.concat(`&orderFromDate=${filterReq.orderFromDate}`);
  }

  if (
    filterReq.orderToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.orderToDate)
  ) {
    query = query.concat(`&orderToDate=${filterReq.orderToDate}`);
  }

  if (
    filterReq.orderAmountFrom &&
    !IsStringNullEmptyOrUndefined(filterReq.orderAmountFrom)
  ) {
    query = query.concat(`&orderAmountFrom=${filterReq.orderAmountFrom}`);
  }

  if (
    filterReq.orderAmountTo &&
    !IsStringNullEmptyOrUndefined(filterReq.orderAmountTo)
  ) {
    query = query.concat(`&orderAmountTo=${filterReq.orderAmountTo}`);
  }

  if (filterReq.createdBy && !IsNullOrUndefined(filterReq.createdBy)) {
    query = query.concat(`&createdBy=${JSON.stringify(filterReq.createdBy)}`);
  }

  if (filterReq.source && !IsStringNullEmptyOrUndefined(filterReq.source)) {
    query = query.concat(`&sourceId=${filterReq.source}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v2.0/get-all?${query}`,
  );
};

export const APIDeleteSoloution = async (
  orderId: string,
  solutionId: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.order}/delete-solution/${orderId}/${solutionId}`,
  );
};

export const APIGenerateOrder = async (
  reqObj: GenerateOrderReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/generate-order`,
    reqObj,
  );
};

export const APICreateframeColors = async (
  reqObj: FrameColorsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.frameColorsSettings}/create`,
    reqObj,
  );
};

export const APIFetchAllFrameColorsDetails = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.frameColorsSettings}/get-all?${query}`,
  );
};

export const APIDeleteFrameColor = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.frameColorsSettings}/delete/${id}`,
  );
};

export const APIUpdateFrameColor = async (
  reqObj: FrameColorsReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.frameColorsSettings}/update/${id}`,
    reqObj,
  );
};

export const APICreateDesgins = async (
  reqObj: DesginReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.desginSettings}/create`,
    reqObj,
  );
};

export const APIFetchAllDesginsDetails = async (
  filterReq: GetAllDesignReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (
    filterReq.searchDesignName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchDesignName)
  ) {
    query = query.concat(`&searchDesignName=${filterReq.searchDesignName}`);
  }

  if (
    filterReq.baseFactoryLeadDays &&
    !IsStringNullEmptyOrUndefined(filterReq.baseFactoryLeadDays)
  ) {
    query = query.concat(`&baseFactoryLeadDays=${filterReq.baseFactoryLeadDays}`);
  }

  if (
    filterReq.glassOnePercent &&
    !IsStringNullEmptyOrUndefined(filterReq.glassOnePercent)
  ) {
    query = query.concat(`&glassOnePercent=${filterReq.glassOnePercent}`);
  }

  if (
    filterReq.glassTwoPercent &&
    !IsStringNullEmptyOrUndefined(filterReq.glassTwoPercent)
  ) {
    query = query.concat(`&glassTwoPercent=${filterReq.glassTwoPercent}`);
  }

  if (
    filterReq.glassPatternCostFrom &&
    !IsStringNullEmptyOrUndefined(filterReq.glassPatternCostFrom)
  ) {
    query = query.concat(
      `&glassPatternCostFrom=${filterReq.glassPatternCostFrom}`,
    );
  }

  if (
    filterReq.glassPatternCostTo &&
    !IsStringNullEmptyOrUndefined(filterReq.glassPatternCostTo)
  ) {
    query = query.concat(`&glassPatternCostTo=${filterReq.glassPatternCostTo}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.glassCount &&
    !IsStringNullEmptyOrUndefined(filterReq.glassCount)
  ) {
    query = query.concat(`&glassCount=${filterReq.glassCount}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.desginSettings}/get-all?${query}`,
  );
};

export const APIDeleteDesgins = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.desginSettings}/delete/${id}`,
  );
};

export const APIGetDesginById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.desginSettings}/get-design/${id}`,
  );
};

export const APIUpdateDesgins = async (
  reqObj: DesginReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.desginSettings}/update/${id}`,
    reqObj,
  );
};

export const APICreateGrid = async (reqObj: any): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.gridSettings}/create`,
    reqObj,
  );
};

export const APIDesginDDL = async (data: {
  ids: string[] | [];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.desginSettings}/get-ddl`,
    data,
  );
};

export const APIFetchAllGridDetails = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.gridSettings}/get-all?${query}`,
  );
};

export const APIDeleteGrid = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.gridSettings}/delete/${id}`,
  );
};

export const APIGridById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.gridSettings}/get-grid/${id}`,
  );
};

export const APIUpdateGrid = async (
  reqObj: GridReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.gridSettings}/update/${id}`,
    reqObj,
  );
};

export const APIUplodeFrameColorImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.frameColorsSettings}/upload-media/${id}`,
    data,
  );
};

export const APIUplodeDesginsImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.desginSettings}/upload-media/${id}`,
    data,
  );
};

export const APICreateGlassVariants = async (
  reqObj: GlassVariantsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/create`,
    reqObj,
  );
};

export const APIFetchAllGlassVariants = async (
  filterReq: GetAllWaltzVariantReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&createFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&createToDate=${filterReq.createToDate}`);
  }

  if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
    query = query.concat(`&name=${filterReq.name}`);
  }

  if (
    filterReq.printName &&
    !IsStringNullEmptyOrUndefined(filterReq.printName)
  ) {
    query = query.concat(`&printName=${filterReq.printName}`);
  }

  if (
    filterReq.baseFactoryLeadDays &&
    !IsStringNullEmptyOrUndefined(filterReq.baseFactoryLeadDays)
  ) {
    query = query.concat(`&baseFactoryLeadDays=${filterReq.baseFactoryLeadDays}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.fromAmount &&
    !IsStringNullEmptyOrUndefined(filterReq.fromAmount)
  ) {
    query = query.concat(`&fromAmount=${filterReq.fromAmount}`);
  }

  if (filterReq.toAmount && !IsStringNullEmptyOrUndefined(filterReq.toAmount)) {
    query = query.concat(`&toAmount=${filterReq.toAmount}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/get-all?${query}`,
  );
};

export const APIDeleteGlassVariants = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/delete/${id}`,
  );
};

export const APIGlassVariantById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/get-variant/${id}`,
  );
};

export const APIUpdateGlassVariants = async (
  reqObj: GlassVariantsReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/update/${id}`,
    reqObj,
  );
};

export const APIUplodeGlassVariantImage = async (
  data: FormData,
  id: string,
  fieldName: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      fieldName: fieldName,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/upload-media/${id}`,
    data,
  );
};

export const APICreateGlassFinishes = async (
  reqObj: GlassFinishesReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/create`,
    reqObj,
  );
};

export const APIGlassVariantsDDL = async (data: {
  ids: string[] | [];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.glassVariantSettings}/get-ddl`,
    data,
  );
};

export const APIUplodeGlassFinishesImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/upload-media/${id}`,
    data,
  );
};

export const APIFetchAllGlassFinishes = async (
  filterReq: GetAllWaltzFinishReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (
    filterReq.searchFinishName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchFinishName)
  ) {
    query = query.concat(`&searchFinishName=${filterReq.searchFinishName}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.baseFactoryLeadDays &&
    !IsStringNullEmptyOrUndefined(filterReq.baseFactoryLeadDays)
  ) {
    query = query.concat(`&baseFactoryLeadDays=${filterReq.baseFactoryLeadDays}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/get-all?${query}`,
  );
};

export const APIDeleteGlassFinishes = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/delete/${id}`,
  );
};

export const APIGlassFinishesById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/get-finish/${id}`,
  );
};

export const APIUpdateGlassFinishes = async (
  reqObj: GlassFinishesReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.glassFinishSettings}/update/${id}`,
    reqObj,
  );
};

export const APIDownloadWaltzOrderOldPDF = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/create-waltz-order-pdf/${orderId}`,
  );
};

export const APIDownloadWaltzOrderNewPDF = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.waltzOder}/v1.0/waltz-order-new-pdf/${orderId}`,
  );
};

export const APICreateHandles = async (
  reqObj: HandlesReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.handlesSettings}/create`,
    reqObj,
  );
};

export const APIUplodeHandlesImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.handlesSettings}/upload-media/${id}`,
    data,
  );
};

export const APIFetchAllHandles = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.searchText &&
    !IsStringNullEmptyOrUndefined(filterReq.searchText)
  ) {
    query = query.concat(`&searchText=${filterReq.searchText}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.handlesSettings}/get-all?${query}`,
  );
};

export const APIDeleteHandles = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.handlesSettings}/delete/${id}`,
  );
};

export const APIUpdateHandles = async (
  reqObj: HandlesReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.handlesSettings}/update/${id}`,
    reqObj,
  );
};

export const APICreateLock = async (
  reqObj: LockReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.lockSettings}/create`,
    reqObj,
  );
};

export const APIFetchAllLock = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.searchText &&
    !IsStringNullEmptyOrUndefined(filterReq.searchText)
  ) {
    query = query.concat(`&searchText=${filterReq.searchText}`);
  }

  if (filterReq.status) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.lockSettings}/get-all?${query}`,
  );
};

export const APIDeleteLock = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.lockSettings}/delete/${id}`,
  );
};

export const APIUpdateLock = async (
  reqObj: LockReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.lockSettings}/update/${id}`,
    reqObj,
  );
};

export const APIUplodeLockImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.lockSettings}/upload-media/${id}`,
    data,
  );
};

export const APISignInUser = async (
  reqObj: SignInReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/user/sign-in`, reqObj);
};

export const APIGetGeneralSettings = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.generalSettings}/get`);
};

export const APIGetTbsContactUsersDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.generalSettings}/get-tbs-contact-users-ddl`,
  );
};

export const APIUpdateGeneralSettings = async (
  reqObj: any,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.generalSettings}/update/${id}`,
    reqObj,
  );
};

export const APIGetHNSCodeGSTMapping = async (
  filterReq: PaginateReqEntity = { pageNumber: 0, pageSize: 1000 },
): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.HsnCodeGstMapping}/get`, {
    params: {
      pageNumber: (filterReq.pageNumber ?? 0) + 1,
      pageSize: filterReq.pageSize ?? 1000,
    },
  });
};

export const APICreateUpdateHNSCodeGSTMapping = async (
  reqObj?: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.HsnCodeGstMapping}/Create-update`,
    reqObj,
  );
};

export const APIDeleteHNSCodeGSTMapping = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.HsnCodeGstMapping}/delete/${id}`,
  );
};

export const APIExportHNSCodeGSTMapping = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.HsnCodeGstMapping}/export`);
};

// export const APIHSNWiseExportInvoice = async (
//   reqObj: { startDate: string | null; endDate: string | null },
// ): Promise<AxiosResponse> => {
//   return await axios.post(
//     `${APIURL}/${BaseEndpoints.HsnCodeGstMapping}/invoice-wise-HSN-export`,
//     reqObj,
//   );
// };


export const APISaveLedgerDetails = async (
  reqObj: LedgerReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/save-ledger-details`,
    reqObj,
  );
};

export const APIGetUserDDl = async (
  teamCategory: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.user}/get-ddl/${teamCategory}`,
  );
};

export const APIFetchUserByRoleIdUsers = async (
  roleCategory: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.user}/fetch-users/${roleCategory}`,
  );
};

export const APIGetUserV1DDl = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/v2/get-ddl`);
};
export const APIGetSelectedUserV1DDl = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/v2/get-selected-ddl`);
};

export const APIGetSelectedUserV3DDl = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/v3/get-selected-ddl`);
};

export const APIGetUserV3DDl = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/v3/get-ddl`);
};
export const APIGetUserForProductionDDl = async (
  status: string[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.user}/get-user-for-production-ddl`,
    { status },
  );
};

export const APIGetSchedulerTime = async (
  schedulerName: string,
): Promise<AxiosResponse> => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.analytics}/get-scheduler-time/${schedulerName}`,
  );
};

export const APIGetOptimizeAnalytics = async (
  reqObj: DownloadReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.analytics}/v3.0/optimize-analytics-report`,
    reqObj,
  );
};

export const APIGetGlassSolution = async (
  orderId: string,
  solutionId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/get-glass-solution/${orderId}/${solutionId}`,
  );
};

export const APIGetWaltzOrderForGlassOrder =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.order}/fetch-waltz-order-for-glass-order`,
    );
  };

export const APIFetchAllEducationAssetsListing = async (
  filterReq: EducationAssetsListingReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);
  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  query = query.concat(`&sortOrder=${filterReq.sortOrder}`);

  if (
    filterReq.searchBySubject &&
    !IsStringNullEmptyOrUndefined(filterReq.searchBySubject)
  ) {
    query = query.concat(`&searchBySubject=${filterReq.searchBySubject}`);
  }

  if (
    filterReq.searchFileType &&
    !IsStringNullEmptyOrUndefined(filterReq.searchFileType)
  ) {
    query = query.concat(`&searchFileType=${filterReq.searchFileType}`);
  }

  if (
    filterReq.searchByCreator &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByCreator)
  ) {
    query = query.concat(`&searchByCreator=${filterReq.searchByCreator}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.educationModule}/get-list?${query}`,
  );
};

export const APIDeleteEducationAsset = async (
  assetId: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.educationModule}/delete/${assetId}`,
  );
};

export const APIFetchEducationAssetById = async (
  assetId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.educationModule}/fetchById/${assetId}`,
  );
};

// Education module - initiate multipart
export const APIEducationAssetsInitiateMultipart = async (
  body: EducationAssetsMultipartInitiateReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.educationModule}/multipart/initiate`,
    body,
  );
};

// Education module - chunk uploads
export const APIEducationAssetsChunkMultiPart = async (
  formData: FormData,
  uid: string,
  uploadId: string,
  key: string,
  partNumber: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.educationModule}/multipart/part?uid=${uid}&uploadId=${uploadId}&key=${key}&partNumber=${partNumber}`,
    formData,
  );
};

export const APIEducationAssetsCompleteMultipart = async (
  body: EducationAssetsCompleteMultipartReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.educationModule}/multipart/complete`,
    body,
  );
};

export const APIEducationTextFieldsOnly = async (
  body: UpdateEducationFieldsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.educationModule}/update-education-text-fields-only`,
    body,
  );
};

export const APIDownloadCustomerFeedbackFormPDF = async (
  orderId: string,
  keyName: string,
): Promise<AxiosResponse> => {
  const query = `keyName=${keyName}`;
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/customer-feedback-form-new-pdf/${orderId}?${query}`,
  );
};

export const APIDownloadMeasurementSheetPDF = async (
  orderId: string,
  keyName: string,
): Promise<AxiosResponse> => {
  const query = `keyName=${keyName}`;
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/measurement-sheet-new-pdf/${orderId}?${query}`,
  );
};

export const APICreateGoodsDeliveryNote = async (
  reqObj: GoodsDeleveryEntity & {
    orderId: string;
    orderNumber: string;
    dateSent: string;
    formatedDate: string;
  },
): Promise<AxiosResponse> => {
  // return await axios.post(
  //   `${APIURL}/${BaseEndpoints.download}/create/goods-delivery-note`,
  //   reqObj
  // );
  return await axios.post(
    `${APIURL}/${BaseEndpoints.download}/v1.0/create/goods-delivery-note-new-pdf`,
    reqObj,
  );
};
export const APIDownloadWorkCompletionNotePDF = async (
  orderId: string,
  keyName: string,
): Promise<AxiosResponse> => {
  const query = `keyName=${keyName}`;
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/work-completion-note-new-pdf/${orderId}?${query}`,
  );
};

export const APIGetWaltzOrderNumber = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/fetch-waltz-order-number-DDL`,
  );
};

export const APIDownloadExcelReportForAnalyticsOptimized = async (
  reqObj: DownloadReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.analytics}/v2.0/download-excel-report`,
    reqObj,
  );
};

export const APIDownloadLedgerExcel = async (
  reqObj: DownloadReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.analytics}/download-ledger-excel`,
    reqObj,
  );
};

export const APIDownloadSurveyReportExcel =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.workOrder}/download-survey-report-excel`,
    );
  };

export const APIDownloadSurveyReportExcelv2 =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.workOrder}/v2.0/download-optimized-survey-report-excel`,
    );
  };

export const APIDownloadSurveyReportExcelV1 =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.workOrder}/v1.0/download-survey-report-excel`,
    );
  };

export const APIDownloadLeaderboardReportExcel =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.workOrder}/download-leaderboard-report-excel`,
    );
  };

export const APIDownloadIncentiveReport = async (
  reqObj: DownloadReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.analytics}/download-incentive-report`,
    reqObj,
  );
};

export const APIGetModuleName = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.modules}/get-module-name`);
};

export const APIGetAllModules = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.modules}/get-all`);
};

export const ApiCreateRole = async (
  reqObj: RolesReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.role}/create`, reqObj);
};

export const APIUpdateRole = async (
  reqObj: RolesReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.role}/update/${id}`,
    reqObj,
  );
};

export const APIDeleteRole = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.role}/delete/${id}`);
}

export const APIDuplicateRole = async (id: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.role}/duplicate/${id}`);
};

export const APIGetAllRoles = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.role}/get-all`);
};

export const APIGetSelectedRoles = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.role}/get-selected-roles`);
};

export const APIFetchRoles = async (
  filterReq: GetAllRolesReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  if (filterReq.roleName && !IsStringNullEmptyOrUndefined(filterReq.roleName)) {
    query = query.concat(`roleName=${filterReq.roleName}`);
  }
  if (filterReq.sortColumn) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }
  if (filterReq.sortOrder) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }
  if (filterReq.pageNumber !== undefined && filterReq.pageSize !== undefined) {
    query = query.concat(
      `&pageNumber=${filterReq.pageNumber + 1}&pageSize=${filterReq.pageSize}`,
    );
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.role}/get-all${query ? `?${query}` : ""}`,
  );
};

export const APIGetRoleById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.role}/get-role/${id}`);
};

export const APIRedRibbonFetchCounts = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.RedRibbon}/fetch-counts`);
};

export const APIDownloadCommercialHoldOrderDetails = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.RedRibbon}/download-payment-details-pdf/${orderId}`,
  );
};

export const APICommericalHoldOrderDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-commercial-hold-order-details`,
    );
  };

export const APIFetchFeedbackPendingOrderDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-feedback-pending-order-details`,
    );
  };

export const APIProductionHoldOrderDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-commercial-hold-solution-details`,
    );
  };

export const APIGetLedgerDetailsByOrderId = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/view-ledger-details/${orderId}`,
  );
};

export const APICalculateSolutionFeatures = async (
  body: CreateUpdateSolutionReqPayloadEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/calculate-solution-features`,
    body,
  );
};

export const APICheckAllowSMAssignmentForHandoverOrder = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/check-allow-SM-assignment-for-handover-order/${orderId}`,
  );
};

export const APIAddSmForHandoverOrders = async (body: {
  orders: { orderId: string; smUserId: string }[];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/add-SM-for-handover-orders`,
    body,
  );
};

export const APIFetchOrdersCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v1.0/dump-orders-csv`,
  );
};

export const APIFetchOptimizedOrdersCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/order-export-cache/v1.0/queue-download`,
  );
};

export const APIFetchModelsCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-model-csv`,
  );
};

export const APIFetchWaltzVariantsCsvDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.glassVariantSettings}/get-waltz-variant-csv`,
    );
  };

export const APIFetchWaltzFinishesCsvDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.glassFinishSettings}/get-waltz-finishes-csv`,
    );
  };

export const APIFetchUsersCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-users-csv`);
};

export const APIFetchLocksCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.lockSettings}/get-locks-csv`,
  );
};

export const APIFetchHandlesCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.handlesSettings}/get-hanldes-csv`,
  );
};

export const APIFetchWaltzCategoriesCsvDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/get-waltz-category-csv`,
    );
  };

export const APIFetchWaltzCategoriesCsvInDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/get-waltz-category-in-details-csv`,
    );
  };

export const ApiChangePassword = async (
  reqObj: ChangePasswordReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.user}/change-password`,
    reqObj,
  );
};

export const ApiFirstTimeChangePassword = async (
  reqObj: FirstTimeChangePasswordReqEntity,
  signToken: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${signToken}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.user}/set-password-first-time`,
    reqObj,
  );
};

export const APIUpdateOrderBasicDetails = async (
  reqObj: UpdateOrderReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.order}/update-order-basic-details/${id}`,
    reqObj,
  );
};

export const APIFetchImpactedValues = async (
  reqPayload: ReleaseNewPricingVersionReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.priceVersion}/fetch-impacted-values`,
    reqPayload,
  );
};

export const APIReleaseNewVersion = async (
  reqPayload: ReleaseNewPricingVersionReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.priceVersion}/release-new`,
    reqPayload,
  );
};

export const APIExportPriceVersion = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/export-price-version/${id}`);
};

export const APIFetchPricingVersion = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.priceVersion}/get-all`);
};

export const APIDeleteDraft = async (
  draftVersionId: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.priceVersion}/delete-draft/${draftVersionId}`,
  );
};

export const APIFetchChangeLogs = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.priceVersion}/get-change-logs/${id}`,
  );
};

export const APISaveAsDraft = async (
  reqPayload: ReleaseNewPricingVersionReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.priceVersion}/save-as-draft`,
    reqPayload,
  );
};

export const APIGetStateDDL = async (
  stateId: number = 0,
  countryId: string = "",
): Promise<AxiosResponse> => {
  let query = "";

  if (!IsStringNullEmptyOrUndefined(countryId)) {
    query = query.concat(`?countryIds=${countryId}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.states}/get-ddl/${stateId}${query}`,
  );
};

export const APIGetCountryDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.countries}/get-ddl`);
};

export const APIGetStateForWorkOrderDDL = async (
  status: string[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.states}/get-state-for-workorder-ddl`,
    { status: status },
  );
};

export const APIGetStateForB2bDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.states}/get-state-for-B2b`);
};
export const APIGetStateForMeetingsDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.states}/get-states-with-meetings-ddl`,
  );
};

export const APIGetStateForStateLeadsDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.states}/get-states-for-social-leads-ddl`,
  );
};

export const APIGetStateForOrdersDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.states}/get-states-for-order-ddl`,
  );
};

export const APIGetCityDDL = async (
  stateId: number,
  cityId: number = 0,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-ddl/${stateId}/${cityId}`,
  );
};

export const APIGetCityForB2bDDL = async (
  stateId: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-city-for-B2b/${stateId}`,
  );
};

export const APIGetCitiesForMeetingsDDl = async (
  stateId: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-cities-meeting-ddl/${stateId}`,
  );
};

export const APIGetCitiesForSocialLeadsDDL = async (
  stateId: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-cities-social-leads-ddl/${stateId}`,
  );
};

export const APIGetCitiesForOrdersDDL = async (
  stateId: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-cities-order-ddl/${stateId}`,
  );
};

export const APIFetchCitiesCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.cities}/get-cities-csv`);
};

export const APIFetchStatesCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.states}/get-state-csv`);
};

export const APICreateStates = async (
  reqPayload: StatesReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.states}/create`,
    reqPayload,
  );
};

export const APIFetchAllStates = async (
  filterReq: GetAllStatesResEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.searchText &&
    !IsStringNullEmptyOrUndefined(filterReq.searchText)
  ) {
    query = query.concat(`&searchText=${filterReq.searchText}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.usedInModule &&
    !IsStringNullEmptyOrUndefined(filterReq.usedInModule)
  ) {
    query = query.concat(`&usedInModule=${filterReq.usedInModule}`);
  }

  if (
    filterReq.usedReference &&
    !IsStringNullEmptyOrUndefined(filterReq.usedReference)
  ) {
    query = query.concat(`&usedReference=${filterReq.usedReference}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.states}/get-all?${query}`);
};

export const APIUpdateStates = async (
  reqObj: StatesReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.states}/update/${id}`,
    reqObj,
  );
};

export const APIDeleteStates = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.states}/delete/${id}`);
};

export const APIFetchPricingVersionOrderWiseCount =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.priceVersion}/fetch-pricing-versions-order-wise-counts`,
    );
  };

export const APIGetSamplePriceVersion = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/sample-pricing-version-file`);
};

export const APICreateCities = async (
  reqPayload: CityReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.cities}/create`,
    reqPayload,
  );
};

export const APIFetchAllCities = async (
  filterReq: GetAllCitiesResEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.searchText &&
    !IsStringNullEmptyOrUndefined(filterReq.searchText)
  ) {
    query = query.concat(`&searchText=${filterReq.searchText}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.usedInModule &&
    !IsStringNullEmptyOrUndefined(filterReq.usedInModule)
  ) {
    query = query.concat(`&usedInModule=${filterReq.usedInModule}`);
  }

  if (
    filterReq.usedReference &&
    !IsStringNullEmptyOrUndefined(filterReq.usedReference)
  ) {
    query = query.concat(`&usedReference=${filterReq.usedReference}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.cities}/get-all?${query}`);
};

export const APIUpdateCities = async (
  reqObj: CityReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.cities}/update/${id}`,
    reqObj,
  );
};

export const APIDeleteCity = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.cities}/delete/${id}`);
};

export const APICreateOffice = async (
  reqObj: CreateUpdateOfficeReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.office}/create`, reqObj);
};

export const APIGetOfficeById = async (
  id: string,
  discardNonDistrubutionRegion: boolean,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(
    `discardNonDistrubutionRegion=${discardNonDistrubutionRegion}`,
  );

  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/get-office/${id}?${query}`,
  );
};

export const APIGetOfficeDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.office}/get-ddl`);
};
export const APIGetOfficeDDLV2 = async (
  status: string[],
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.office}/get-ddlv2`, {
    status: status,
  });
};

export const APIUpdateOffice = async (
  reqObj: CreateUpdateOfficeReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.office}/update/${id}`,
    reqObj,
  );
};

export const APIFetchOffices = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  // query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.office}/get-all?${query}`);
};

export const APIDeleteOffice = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.office}/delete/${id}`);
};

export const APIGetOfficedistribution = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/distribution/${id}`,
  );
};

export const APIUplodeImportOrderMapping = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/import-order-mapping`,
    data,
  );
};

export const APIUplodeImportModelMapping = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.modelSetting}/import-handle-lock-mapping`,
    data,
  );
};

export const APIUplodeImportHsnCodeModel = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.ImportModelHsn}/upload-model-hsn`,
    data,
  );
};

export const APIConfirmPanelHSN = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ImportPanelHsn}/confirm-panel-only-import-hsn/${id}`,
  );
};

export const APIUplodePanelHsnCode = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.ImportPanelHsn}/upload-panel-only-hsn`,
    data,
  );
};

export const APIConfirmAccessoryHSN = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ImportAccessoryHsn}/confirm-accessory-only-import-hsn/${id}`,
  );
};

export const APIUplodeAccessoryHsnCode = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.ImportAccessoryHsn}/upload-accessory-only-hsn`,
    data,
  );
};

export const APIProvideFileUploadId = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ImportModelHsn}/confirm-import-hsn/${id}`,
  );
};

export const APIGetUnMappedUser = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.office}/get-unmapped-user`);
};

export const APISaveUserMapping = async (
  data: SaveUserMappingReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.office}/save-user-mapping`,
    data,
  );
};

export const APISaveRegionsMapping = async (
  data: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.office}/save-regions-mapping`,
    data,
  );
};

export const APIGetLostReason = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.order}/v1.0/lost-reason`);
};

export const APIUpdateLostReason = async (obj: {
  orderId: string;
  reasonId: string;
}): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/order-lost-reason`,
    obj,
  );
};

export const APIFetchUnMappedCityByStateId = async (
  stateId: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-unmapped-city/${stateId}`,
  );
};

export const APIGetReportFields = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.analytics}/get-report-fields`);
};

export const APICreateReportFieldsMapping = async (
  obj: CreateReportFieldsMappingReqEntity,
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.analytics}/create-report-fields-mapping`,
    obj,
  );
};

export const APIGetReportFieldsMapping = async (id: string) => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.analytics}/get-report-fields-mapping/${id}`,
  );
};

export const APIUpdateReportFieldsMapping = async (
  obj: CreateReportFieldsMappingReqEntity,
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.analytics}/update-report-fields-mapping`,
    obj,
  );
};

// Tracker column permissions ("Column Permissions" in Role Management) — mirrors the Analytics
// report's get-report-fields / get-report-fields-mapping / create-/update-report-fields-mapping
// wrappers above exactly, scoped per tracker via `trackerType` on each call.
export const APIGetTrackerReportFields = async (): Promise<AxiosResponse> => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/get-tracker-report-fields`,
  );
};

export const APIGetTrackerReportFieldsMapping = async (
  roleId: string,
): Promise<AxiosResponse> => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/get-tracker-report-fields-mapping/${roleId}`,
  );
};

export const APICreateTrackerReportFieldsMapping = async (
  obj: CreateTrackerReportFieldsMappingReqEntity,
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/create-tracker-report-fields-mapping`,
    obj,
  );
};

export const APIUpdateTrackerReportFieldsMapping = async (
  obj: CreateTrackerReportFieldsMappingReqEntity,
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/update-tracker-report-fields-mapping`,
    obj,
  );
};

export const APIExportOffice = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.office}/export-office`);
};

export const APIIdentifySecondaryFector = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.order}/identify-secondary-factor`,
    reqObj,
  );
};

export const APIGetGlassOnlyCategoryDDl = async (
  reqBody: ConfigReqBodyEntity | null = null,
): Promise<AxiosResponse> => {
  return (await !IsNullOrUndefined(reqBody))
    ? axios.post(
      `${APIURL}/${BaseEndpoints.panelOnly}/get-panel-config`,
      reqBody,
    )
    : axios.post(`${APIURL}/${BaseEndpoints.panelOnly}/get-panel-config`);
};

export const APISearchArchitectFirmName = async (reqBody?: {
  view?: string;
}): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.order}/get-architect-firm-name`,
    reqBody ? reqBody : {},
  );
};

export const APISearchArchitectFirmNameAndCity = async (
  reqObj: SearchArchitectFirmNameReqEntity,
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.order}/search-architect-firm-name`,
    reqObj,
  );
};

export const APIFetchOfficeAndUsers = async (
  teamCategory: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.dashboard}/get-offices-users-ddl/${teamCategory}`,
  );
};

export const APIFetchWonAndTotalProjects = async (
  body: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  // let reqQueryParams: string = "";
  // if (
  //   queryParams.officeId &&
  //   !IsStringNullEmptyOrUndefined(queryParams.officeId)
  // ) {
  //   reqQueryParams = reqQueryParams.concat(`&officeId=${queryParams.officeId}`);
  // }
  // if (queryParams.userId && !IsStringNullEmptyOrUndefined(queryParams.userId)) {
  //   reqQueryParams = reqQueryParams.concat(`&userId=${queryParams.userId}`);
  // }
  // // if (
  // //   queryParams.startDate &&
  // //   !IsStringNullEmptyOrUndefined(queryParams.startDate)
  // // ) {
  // //   reqQueryParams = reqQueryParams.concat(
  // //     `&startDate=${queryParams.startDate}`
  // //   );
  // // }
  // // if (
  // //   queryParams.endDate &&
  // //   !IsStringNullEmptyOrUndefined(queryParams.endDate)
  // // ) {
  // //   reqQueryParams = reqQueryParams.concat(`&endDate=${queryParams.endDate}`);
  // // }
  // if( queryParams.dateRange && !IsNullOrEmptyArray(queryParams.dateRange))
  // {

  //     reqQueryParams = reqQueryParams.concat(
  //       `&dateRange=${queryParams.dateRange}`
  //     );

  // }
  // if (
  //   queryParams.financialYear &&
  //   !IsStringNullEmptyOrUndefined(queryParams.financialYear)
  // ) {
  //   reqQueryParams = reqQueryParams.concat(
  //     `&financialYear=${queryParams.financialYear}`
  //   );
  // }

  return await axios.post(
    `${APIURL}/${BaseEndpoints.dashboard}/get-revenue-chart-data`,
    body,
  );
};

export const APIFetchProductByAmount = async (
  body: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.dashboard}/get-product-chart-data-total-amount`,
    body,
  );
};

export const APIFetchProductBySquarFeet = async (
  body: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.dashboard}/get-product-chart-data-total-sqaure-feet`,
    body,
  );
};

export const APIFetchTrafficLightData = async (
  queryParams: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  let reqQueryParams: string = "";
  const officeId = Array.isArray(queryParams.officeId)
    ? queryParams.officeId.join(",")
    : queryParams.officeId;

  if (queryParams.pageSize) {
    reqQueryParams = reqQueryParams.concat(`&pageSize=${queryParams.pageSize}`);
  }
  if (queryParams.viewMore) {
    reqQueryParams = reqQueryParams.concat(`&viewMore=${queryParams.viewMore}`);
  }
  if (queryParams && queryParams.pageNumber !== undefined) {
    reqQueryParams = reqQueryParams.concat(
      `&pageNumber=${queryParams.pageNumber + 1}`,
    );
  }

  if (
    officeId &&
    !IsStringNullEmptyOrUndefined(officeId)
  ) {
    reqQueryParams = reqQueryParams.concat(`&officeId=${officeId}`);
  }

  if (queryParams.stateId && !IsNullOrUndefined(queryParams.stateId)) {
    reqQueryParams = reqQueryParams.concat(
      `&searchByState=${queryParams.stateId}`,
    );
  }

  if (queryParams.cityId && !IsNullOrUndefined(queryParams.cityId)) {
    reqQueryParams = reqQueryParams.concat(
      `&searchByCity=${queryParams.cityId}`,
    );
  }

  if (queryParams.countryId && !IsNullOrUndefined(queryParams.countryId)) {
    reqQueryParams = reqQueryParams.concat(
      `&searchByCountry=${queryParams.countryId}`,
    );
  }

  if (
    queryParams.searchByCompanyName &&
    !IsStringNullEmptyOrUndefined(queryParams.searchByCompanyName)
  ) {
    reqQueryParams = reqQueryParams.concat(
      `&searchByCompanyName=${queryParams.searchByCompanyName}`,
    );
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.dashboard}/get-traffic-light-chart-data?${reqQueryParams}`,
  );
};

export const APIExportMasterTrafficLight = async (
  queryParams: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  let reqQueryParams: string = "";
  const officeId = Array.isArray(queryParams.officeId)
    ? queryParams.officeId.join(",")
    : queryParams.officeId;
  if (
    officeId &&
    !IsStringNullEmptyOrUndefined(officeId)
  ) {
    reqQueryParams = reqQueryParams.concat(`&officeId=${officeId}`);
  }
  return await axios.get(
    `${APIURL}/${BaseEndpoints.dashboard}/get-traffic-light-chart-export-master?${reqQueryParams}`,
  );
};
export const APIExportAllFirmsTrafficLight = async (
  queryParams: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  let reqQueryParams: string = "";
  const officeId = Array.isArray(queryParams.officeId)
    ? queryParams.officeId.join(",")
    : queryParams.officeId;
  if (
    officeId &&
    !IsStringNullEmptyOrUndefined(officeId)
  ) {
    reqQueryParams = reqQueryParams.concat(`&officeId=${officeId}`);
  }
  return await axios.get(
    `${APIURL}/${BaseEndpoints.dashboard}/get-traffic-light-chart-export-allFirms?${reqQueryParams}`,
  );
};

export const APIFetchTrafficLightDataById = async (
  queryParams: TrafficLightDashboardFiltersEntity,
): Promise<AxiosResponse> => {
  let reqQueryParams: string = "";

  console.log("queryParams", queryParams);

  if (queryParams.architectId && !IsNullOrUndefined(queryParams.architectId)) {
    reqQueryParams = reqQueryParams.concat(
      `&architectId=${queryParams.architectId}`,
    );
  }

  if (queryParams.orderStatus && !IsNullOrUndefined(queryParams.orderStatus)) {
    reqQueryParams = reqQueryParams.concat(
      `&orderStatus=${queryParams.orderStatus}`,
    );
  }

  if (queryParams.city && !IsNullOrUndefined(queryParams.city)) {
    reqQueryParams = reqQueryParams.concat(`&city=${queryParams.city}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.dashboard}/get-traffic-light-chart-data-by-id?${reqQueryParams}`,
  );
};

export const APIUpdateOrderStatusPreclosure = async (
  reqObj: UpdateOrderStatusPreclosureReq,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/update-order-status-preclosure`,
    reqObj,
  );
};

export const APISendCustomerBillingFormLink = async (reqObj: {
  orderId: string;
  resend?: boolean;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/send-customer-billing-form-link`,
    reqObj,
  );
};

export const APIDocumentVerify = async (
  reqObj: any,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/document-verify`, reqObj, config);
};

export const APIDocumentAdvanceGSTVerify = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/document-verify/gst-advance`, reqObj);
};

export const APIVerifyCustomerBillingFormLink = async (reqObj: {
  orderId: string;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/verify-customer-billing-form-link`,
    reqObj,
  );
};

export const APISaveCustomerBillingInformation = async (
  reqObj: CustomerBillingInformationReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/save-customer-billing-form`,
    reqObj,
  );
};

export const APIVerifyOTP = async (reqObj: {
  emailAddress: string;
  otp?: number;
  whatsAppOtp?: number;
}): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/user/verify-otp`, reqObj);
};

export const APISaveLedgerDetailsAsDraft = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/save-ledger-details-as-draft`,
    reqObj,
  );
};

export const APIUpdateOrderStatusCommercialHoldToPreclosure = async (
  reqObj: PreClosureOrderStatusCommercialWinReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/update-order-status-commercial-hold-to-preclosure`,
    reqObj,
  );
};

export const APIUplodePurchaseOrderPdf = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.order}/v1.0/upload-media/${id}`,
    data,
  );
};

export const APIGetLedgerForGDN = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/get-site-person-detail?orderId=${orderId}`,
  );
};

export const APIFetchCategoyStructure = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.glassCategoriesSettings}/fetch-category-structure`,
  );
};

export const APICreatePanelOnly = async (
  reqObj: PanelOnlyReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.panelOnly}/create`,
    reqObj,
  );
};

export const APIExportPanelOnly = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.panelOnly}/export`);
};

export const APIFetchCategoryTreeStructureForModel = async (
  id: string = "",
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-category-structure?id=${id}`,
  );
};

export const APIGetPanelOnly = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.panelOnly}/get`);
};

export const APICalculateGlassSolutionFeatures = async (
  reqObj: CreateUpdateGlassSolutionReqPayloadEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/calculate-glass-order-features`,
    reqObj,
  );
};

export const APIChangesOrderPerCentages = async (
  data: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.orderPercentage}/change-order-percentages`,
    data,
  );
};

export const APIGetOrderNumberWithPercentage =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.orderPercentage}/fetch-order-number-DDL-with-percentages`,
    );
  };

export const APIVerifyArchitectEmail = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/verify-architect-email`,
    reqObj,
  );
};

export const APIFetchAllArchitectDetails = async (
  filterReq: GetAllArchitectDetailsReqEntity,
): Promise<AxiosResponse> => {
  let query: any = {
    pageSize: filterReq.pageSize,
    pageNumber: filterReq.pageNumber + 1,
  };

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query["sortColumn"] = filterReq.sortColumn;
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query["sortOrder"] = filterReq.sortOrder;
  }

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query["fromDate"] = filterReq.fromDate;
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query["toDate"] = filterReq.toDate;
  }

  if (
    filterReq.orderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.orderNumber)
  ) {
    query["orderNumber"] = filterReq.orderNumber;
  }

  if (
    filterReq.companyName &&
    !IsStringNullEmptyOrUndefined(filterReq.companyName)
  ) {
    query["companyName"] = filterReq.companyName;
  }

  if (
    filterReq.salesPersonName &&
    !IsStringNullEmptyOrUndefined(filterReq.salesPersonName)
  ) {
    query["salesPersonName"] = filterReq.salesPersonName;
  }

  if (filterReq.status) {
    query["status"] = filterReq.status;
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.architectDetails}/get-all`,
    {
      params: query,
    },
  );
};

export const APIGetArchitectDetailById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.architectDetails}/get-architect-details/${id}`,
  );
};

export const APIExportArchitectDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.architectDetails}/export-architect-details`,
  );
};

export const APIExportArchitectFirmAndArchitectDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.architectDetails}/export-architect-firm-and-architect-details`,
    );
  };

export const APIExportArchitectFirmAndArchitectDetailsForMaster =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.architectDetails}/export-architect-firm-and-architect-details-for-master`,
    );
  };

export const APIApproveArchitectDetails = async (
  reqObj: ApproveArchitectDetailsReqBodyEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.architectDetails}/approve-architect-details`,
    reqObj,
  );
};

export const APIFetchAllOrderPercentageUpdate = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.orderPercentage}/get-all?${query}`,
  );
};

export const APIPFetchAllWhatsAppQueue = async (
  filterReq: FetchAllWhatsAppQueueReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.senderPhoneNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.senderPhoneNumber)
  ) {
    query = query.concat(`&senderPhoneNumber=${filterReq.senderPhoneNumber}`);
  }

  if (
    filterReq.sentStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.sentStatus)
  ) {
    query = query.concat(`&sentStatus=${filterReq.sentStatus}`);
  }

  if (filterReq.status && !IsStringNullEmptyOrUndefined(filterReq.status)) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (filterReq.type && !IsStringNullEmptyOrUndefined(filterReq.type)) {
    query = query.concat(`&type=${filterReq.type}`);
  }

  if (
    filterReq.userFullName &&
    !IsStringNullEmptyOrUndefined(filterReq.userFullName)
  ) {
    query = query.concat(`&userFullName=${filterReq.userFullName}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.whatsapp}/fetch-all-queue?${query}`,
  );
};

export const APIFetchWhatsAppQueueFilters =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.whatsapp}/fetch-queue-ddl`,
    );
  };

export const APIExportWhatsAppQueueHistory =
  async (): Promise<AxiosResponse> => {
    return await axios.get(`${APIURL}/${BaseEndpoints.whatsapp}/export-queue`);
  };
export const APIExportMarch25FollowUp = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.March25Followup}/export`);
};

export const APIImportArchitect = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.campaign}/upload-arcticet-list/${id}`,
    data,
  );
};

export const APICreateCampaign = async (
  data: CampaignReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.campaign}/create-campaign`,
    data,
  );
};

export const APISaveCampaignAsDraft = async (
  data: CampaignReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.campaign}/save-campaign-draft`,
    data,
  );
};

// export const APITrialRunCampaign = async (data: CampaignTrialReqEntity): Promise<AxiosResponse> => {
//   return await axios.post(`${APIURL}/${BaseEndpoints.campaign}/trial-run-campaign`, data);
// };

export const APITrialRunCampaign = async (
  data: FormData,
  uuid: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.campaign}/trial-run-campaign/${uuid}`,
    data,
  );
};

// export const APIFetchAllCampaign = async (
//   filterReq: GetAllCampaignReqEntity
// ): Promise<AxiosResponse> => {
//   let query = "";

//   query = query.concat(`pageSize=${filterReq.pageSize}`);

//   query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

//   return await axios.get(`${APIURL}/${BaseEndpoints.campaign}/get-all?${query}`);
// };

export const APIFetchAllCampaign = async (
  filterReq: GetAllCampaignReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.campaignName &&
    !IsStringNullEmptyOrUndefined(filterReq.campaignName)
  ) {
    query = query.concat(`&campaignName=${filterReq.campaignName}`);
  }

  if (
    filterReq.campaignStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.campaignStatus)
  ) {
    query = query.concat(`&campaignStatus=${filterReq.campaignStatus}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.createdFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createdFromDate)
  ) {
    query = query.concat(`&createdFromDate=${filterReq.createdFromDate}`);
  }

  if (
    filterReq.createdToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createdToDate)
  ) {
    query = query.concat(`&createdToDate=${filterReq.createdToDate}`);
  }

  if (
    filterReq.scheduleFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.scheduleFromDate)
  ) {
    query = query.concat(`&scheduleFromDate=${filterReq.scheduleFromDate}`);
  }

  if (
    filterReq.scheduleToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.scheduleToDate)
  ) {
    query = query.concat(`&scheduleToDate=${filterReq.scheduleToDate}`);
  }

  if (
    filterReq.complatedFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.complatedFromDate)
  ) {
    query = query.concat(`&complatedFromDate=${filterReq.complatedFromDate}`);
  }

  if (
    filterReq.complatedToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.complatedToDate)
  ) {
    query = query.concat(`&complatedToDate=${filterReq.complatedToDate}`);
  }
  return await axios.get(
    `${APIURL}/${BaseEndpoints.campaign}/get-all?${query}`,
  );
};

export const APIFetchArchitectFirmAndArchitectDetails = async (
  filterReq: DirectoryMasterUserAndCompanyPaginateReqEntity,
): Promise<AxiosResponse> => {
  let query: any = {
    pageSize: filterReq.pageSize,
    pageNumber: filterReq.pageNumber + 1,
    searchText: filterReq.searchText,
  };

  // query = query.concat(`pageSize=${filterReq.pageSize}`);

  // query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  // query = query.concat(`&searchText=${filterReq.searchText}`);

  if (filterReq.category && !IsStringNullEmptyOrUndefined(filterReq.category)) {
    // query = query.concat(`&category=${filterReq.category}`);
    query["category"] = filterReq.category;
  }

  if (filterReq.userType && !IsStringNullEmptyOrUndefined(filterReq.userType)) {
    // query = query.concat(`&userType=${filterReq.userType}`);
    query["userType"] = filterReq.userType;
  }

  // console.log(query)
  // const encodedQueryParam = encodeURIComponent(query);
  // console.log(encodedQueryParam)
  // const decodeQueryParams = decodeURIComponent(encodedQueryParam);
  // console.log(decodeQueryParams)
  return await axios.get(
    `${APIURL}/${BaseEndpoints.architectDetails}/get-architect-firm-and-architect-details`,
    {
      params: query,
    },
  );
};

export const APICreateArchitectFirm = async (
  reqObj: AddCompanyDirectoryMasterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.architectDetails}/create-architect-firm`,
    reqObj,
  );
};

export const APIGetArchitectFirmDetailById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.architectDetails}/get-architect-firm-detail-from-master/${id}`,
  );
};

export const APIUpdateArchitectFirm = async (
  id: string,
  reqObj: AddCompanyDirectoryMasterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.architectDetails}/update-architect-firm/${id}`,
    reqObj,
  );
};

export const APIFetchArchitectDetails = async (
  reqObj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.architectDetails}/fetch-architect-details`,
    reqObj,
  );
};

export const APIGetLedgerDetailExcel = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v1.0/export-ledger-csv/${orderId}`,
  );
};

export const APIDownloadViewLedgerDetails = async (
  orderId: string,
  docType: "PDF" | "Excel",
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/ledger-form/download-view-ledger-details-PDF/${orderId}/${docType}`,
  );
};

export const APIDownloadViewLedgerDetailsV2 = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.LedgerForm}/v2.0/ledger-details-v2-pdf/${orderId}`,
  );
};
export const APIViewLedgerDetailsV2 = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.LedgerForm}/v2.0/view-ledger-details/${orderId}`,
  );
};

export const APIDownloadWaltzOrderProjectStatusPDF = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.waltzOder}/v1.0/waltz-order-project-status-pdf/${orderId}`,
  );
};

export const APICreateArchitectUser = async (
  reqObj: DirectoryReqEntityArchitectUser,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.architectDetails}/create-architect-user`,
    reqObj,
  );
};

export const APIGetArchitectUserDetail = async (
  architectUserId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.architectDetails}/get-archiect-user-detail/${architectUserId}`,
  );
};

export const APIUpdateArchitectUser = async (
  id: string,
  reqObj: DirectoryReqEntityArchitectUser,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.architectDetails}/update-architect-user/${id}`,
    reqObj,
  );
};

export const APIArchitectFirmActiveAndDeactive = async (
  architectFirmId: string,
  reqBody: { is_active: boolean },
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.architectDetails}/architect-firm-active-and-deactive/${architectFirmId}`,
    reqBody,
  );
};

export const APIArchitectUserActiveAndDeactive = async (
  architectId: string,
  reqBody: { is_active: boolean },
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.architectDetails}/architect-user-active-and-deactive/${architectId}`,
    reqBody,
  );
};

export const APIUploadEmailWhatsappAttachments = async (
  data: FormData,
  id: string,
  obj:
    | {
      isEdit: boolean;
      paths: string;
    }
    | {},
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      ...obj,
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.campaign}/upload-email-whatsapp-attachments/${id}`,
    data,
  );
};

export const APIDeleteCampaign = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.campaign}/delete/${id}`);
};

export const APIGetCampaignDetailsById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.campaign}/get-campaign-details/${id}`,
  );
};

export const APIGetSummaryDetailsById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.campaign}/campaign-summary-details/${id}`,
  );
};

export const APIDownloadCampaignReport = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.campaign}/download-campaign-report/${id}`,
  );
};

export const APIRunCampaign = async (id: string): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.campaign}/run-campaign/${id}`,
  );
};

export const APIUpdateCampaign = async (
  reqObj: CampaignReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.campaign}/update-campaign-details/${id}`,
    reqObj,
  );
};
export const APISyncAnylticsReport = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.redFlag}/sync-analytic-report`,
  );
};

export const APIGetRedFlagCount = async (
  isEdit: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.redFlag}/get-count/${isEdit}`,
  );
};

export const APIUpdateRedFlag = async (
  reqBody: RedFlagRecordsEntity[],
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.redFlag}/update-red-flag`,
    reqBody,
  );
};

export const APIDownloadRedFlagExcel = async (
  tag: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.redFlag}/download-red-flag-excel/${tag}`,
  );
};

export const APIGetCategoryStructureForAccessories = async (
  selectedFrameColors: {
    selectedFrameColors: string[];
    selectedTreeStructure: string;
    selectedAccessoriesData: string;
  },
  id: string = "",
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.modelSetting}/get-filtered-category-structure-for-accessories?id=${id}`,
    selectedFrameColors,
  );
};

export const APIFetchFilterDDLForCampaign =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.campaign}/get-filter-ddl`,
    );
  };

export const APIFetchMultipleCity = async (
  id: string,
  offices: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.cities}/get-multi-city-ddl`,
    { id: id, offices: offices },
  );
};

export const APIFetchCityForWorkOrderDDL = async (
  id: string,
  status: string[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.cities}/get-city-for-workorder-DDL`,
    { id: id, status: status },
  );
};

export const APIFetchFilterArchitectList = async (
  data: ImportFilterValueEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.campaign}/get-filter-arhitect-list`,
    data,
  );
};

export const APIFetchMultipleState = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.states}/get-multiple-ddl`,
    { officeId: id },
  );
};
export const APIFetchSalesPersonDDL = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.campaign}/get-vendors-sales-persons`,
    { offices: id },
  );
};
export const APIGetTags = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&tagName=${filterReq.searchText}`);

  return await axios.get(`${APIURL}/${BaseEndpoints.tags}/get-all?${query}`);
};

export const APIDeleteTag = async (_id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.tags}/delete/${_id}`);
};

export const APICreateUpdateTag = async (
  reqObj: CreateTagEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.tags}/create-update`,
    reqObj,
  );
};

export const APICreateUpdateAlbum = async (
  reqObj: CreateUpdateAlbumEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.album}/create-update`,
    reqObj,
  );
};

export const APIUploadThumbnailImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.album}/upload-thumbnail-image/${id}`,
    data,
  );
};

// export const APIGetAllAlbums = async (
//   id?: string | null,
//   searchText?: string | null,
// ): Promise<AxiosResponse> => {
//   let query = "";

//   if (id && !IsNullOrUndefined(id) && !IsStringNullEmptyOrUndefined(id)) {
//     query = query.concat(`id=${id}`);
//   }

//   if (
//     searchText &&
//     !IsNullOrUndefined(searchText) &&
//     !IsStringNullEmptyOrUndefined(searchText)
//   ) {
//     query = query.concat(`searchText=${searchText}`);
//   }

//   return await axios.get(
//     `${APIURL}/${BaseEndpoints.album}/get-albums?${query}`,
//   );
// };

export const APIGetAllAlbums = async (
  id?: string | null,
  searchText?: string | null,
): Promise<AxiosResponse> => {
  let query = "";

  if (id && !IsNullOrUndefined(id) && !IsStringNullEmptyOrUndefined(id)) {
    query = query.concat(`id=${id}`);
  }

  if (
    searchText &&
    !IsNullOrUndefined(searchText) &&
    !IsStringNullEmptyOrUndefined(searchText)
  ) {
    query = query.concat(`searchText=${searchText}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.album}/v1.0/get-albums?${query}`,
  );
};

export const APIUploadPhoto = async (
  tagIds: string[],
  id: string,
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      "Custom-Multipart-Header": "true",
      tagIds: JSON.stringify(tagIds),
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.photo}/upload/${id}`,
    data,
  );
};

export const APIGetTagDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.tags}/get-ddl`);
};

export const APIGetAlbumLocation = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.album}/get-location/${id}`);
};

// export const APIGetAlbumPhotos = async (
//   id: string,
//   tagid: string,
//   pageNumber: number,
//   pageSize: number,
// ): Promise<AxiosResponse> => {
//   let query = "";
//   query = query.concat(`pageSize=${pageSize}`);

//   query = query.concat(`&pageNumber=${pageNumber + 1}&`);
//   if (id && !IsNullOrUndefined(id) && !IsStringNullEmptyOrUndefined(id)) {
//     query = query.concat(`id=${id}`);
//   }

//   if (
//     tagid &&
//     !IsNullOrUndefined(tagid) &&
//     !IsStringNullEmptyOrUndefined(tagid)
//   ) {
//     query = query.concat(`tagId=${tagid}`);
//   }
//   return await axios.get(
//     `${APIURL}/${BaseEndpoints.photo}/get-photos-by-albumId?${query}`,
//   );
// };

//V1
export const APIGetAlbumPhotos = async (
  id: string,
  tagid: string,
  pageNumber: number,
  pageSize: number,
): Promise<AxiosResponse> => {
  let query = "";
  query = query.concat(`pageSize=${pageSize}`);

  query = query.concat(`&pageNumber=${pageNumber + 1}&`);
  if (id && !IsNullOrUndefined(id) && !IsStringNullEmptyOrUndefined(id)) {
    query = query.concat(`id=${id}`);
  }

  if (
    tagid &&
    !IsNullOrUndefined(tagid) &&
    !IsStringNullEmptyOrUndefined(tagid)
  ) {
    query = query.concat(`tagId=${tagid}`);
  }
  return await axios.get(
    `${APIURL}/${BaseEndpoints.photo}/v1.0/get-photos-by-albumId?${query}`,
  );
};

export const APIGetParentAlbumDetails = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.album}/get-parent-album-details/${id}`,
  );
};

export const APIDeletePhoto = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.photo}/delete/${id}`);
};

export const APIShowHidePhoto = async (
  reqObj: photoShowHideAPIEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.photo}/hide-show/`,
    reqObj,
  );
};
export const APIDeleteAlbum = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(`${APIURL}/${BaseEndpoints.album}/delete/${id}`);
};

export const APIUpdateTagsOfMultiplePhotos = async (
  reqObj: APIUpdateTagsForMultiplePhotosEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.photo}/update-tags-of-multiple-photos`,
    reqObj,
  );
};

export const APIUpdateTagsAndFileDisplayName = async (
  reqObj: APIUpdateTagsAndFileDisplayNameEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.photo}/update-tag-and-file-displayname`,
    reqObj,
  );
};

export const APIGetAllUserTracking = async (
  filterReq: UserSignInTrackingEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.userName && !IsStringNullEmptyOrUndefined(filterReq.userName)) {
    query = query.concat(`&userName=${filterReq.userName}`);
  }

  if (
    filterReq.emailAddress &&
    !IsStringNullEmptyOrUndefined(filterReq.emailAddress)
  ) {
    query = query.concat(`&emailAddress=${filterReq.emailAddress}`);
  }

  if (filterReq.mobileNo && !IsStringNullEmptyOrUndefined(filterReq.mobileNo)) {
    query = query.concat(`&mobileNo=${filterReq.mobileNo}`);
  }

  if (
    filterReq.officeName &&
    !IsStringNullEmptyOrUndefined(filterReq.officeName)
  ) {
    query = query.concat(`&officeName=${filterReq.officeName}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&createFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&createToDate=${filterReq.createToDate}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.userSignInTrack}/get-all?${query}`,
  );
};

export const APIGetTagDetails = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.tags}/get-tag-details/${id}`,
  );
};

export const APIFetchEventArchitectList = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.campaign}/get-all-event-architect-list`,
    { params: filterReq },
  );
};

export const APIUpdateEventArchitect = async (
  ids: string[] | [],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.campaign}/update-event-architect`,
    { uuids: ids },
  );
};

export const APIExportIndiaDesignArchitectEventList =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.campaign}/export-india-design-architect-event`,
    );
  };
export const APIDownloadsImages = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/downloads-images`,
  );
};

export const APIExportMettings = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/export-meetings`,
  );
};

export const APIEventMergedData = async (
  filterReq?: GetAllMeetingsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";
  if (filterReq) {
    query = query.concat(`pageSize=${filterReq.pageSize}`);

    query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

    // query = query.concat(`&isList=${filterReq.isList}`);
    if (
      filterReq.fromDate &&
      !IsStringNullEmptyOrUndefined(filterReq.fromDate)
    ) {
      query = query.concat(`&fromDate=${filterReq.fromDate}`);
    }

    if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
      query = query.concat(`&toDate=${filterReq.toDate}`);
    }

    if (
      filterReq.firmName &&
      !IsStringNullEmptyOrUndefined(filterReq.firmName)
    ) {
      query = query.concat(`&firmName=${filterReq.firmName}`);
    }

    if (
      filterReq.newOrExisting &&
      !IsStringNullEmptyOrUndefined(filterReq.newOrExisting)
    ) {
      query = query.concat(`&newOrExisting=${filterReq.newOrExisting}`);
    }

    if (
      filterReq.mobileNumber &&
      !IsStringNullEmptyOrUndefined(filterReq.mobileNumber)
    ) {
      query = query.concat(`&mobileNumber=${filterReq.mobileNumber}`);
    }

    if (filterReq.state && !IsStringNullEmptyOrUndefined(filterReq.state)) {
      query = query.concat(`&state=${filterReq.state}`);
    }

    if (filterReq.city && !IsStringNullEmptyOrUndefined(filterReq.city)) {
      query = query.concat(`&city=${filterReq.city}`);
    }

    if (
      filterReq.AssignedToTheUser &&
      !IsStringNullEmptyOrUndefined(filterReq.AssignedToTheUser)
    ) {
      query = query.concat(`&AssignedToTheUser=${filterReq.AssignedToTheUser}`);
    }

    if (
      filterReq.AssignedToOffice &&
      !IsStringNullEmptyOrUndefined(filterReq.AssignedToOffice)
    ) {
      query = query.concat(`&AssignedToOffice=${filterReq.AssignedToOffice}`);
    }

    if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
      query = query.concat(`&name=${filterReq.name}`);
    }
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/get-event-merged-dataset?${query}`,
  );
};
export const APIEventMergedDataV2 = async (
  filterReq?: GetAllMeetingsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";
  if (filterReq) {
    query = query.concat(`pageSize=${filterReq.pageSize}`);

    query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

    // query = query.concat(`&isList=${filterReq.isList}`);
    if (
      filterReq.fromDate &&
      !IsStringNullEmptyOrUndefined(filterReq.fromDate)
    ) {
      query = query.concat(`&fromDate=${filterReq.fromDate}`);
    }

    if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
      query = query.concat(`&toDate=${filterReq.toDate}`);
    }

    if (
      filterReq.firmName &&
      !IsStringNullEmptyOrUndefined(filterReq.firmName)
    ) {
      query = query.concat(`&firmName=${filterReq.firmName}`);
    }

    if (
      filterReq.newOrExisting &&
      !IsStringNullEmptyOrUndefined(filterReq.newOrExisting)
    ) {
      query = query.concat(`&newOrExisting=${filterReq.newOrExisting}`);
    }

    if (
      filterReq.mobileNumber &&
      !IsStringNullEmptyOrUndefined(filterReq.mobileNumber)
    ) {
      query = query.concat(`&mobileNumber=${filterReq.mobileNumber}`);
    }

    if (filterReq.state && !IsStringNullEmptyOrUndefined(filterReq.state)) {
      query = query.concat(`&state=${filterReq.state}`);
    }

    if (filterReq.city && !IsStringNullEmptyOrUndefined(filterReq.city)) {
      query = query.concat(`&city=${filterReq.city}`);
    }

    if (
      filterReq.AssignedToTheUser &&
      !IsStringNullEmptyOrUndefined(filterReq.AssignedToTheUser)
    ) {
      query = query.concat(`&AssignedToTheUser=${filterReq.AssignedToTheUser}`);
    }

    if (
      filterReq.AssignedToOffice &&
      !IsStringNullEmptyOrUndefined(filterReq.AssignedToOffice)
    ) {
      query = query.concat(`&AssignedToOffice=${filterReq.AssignedToOffice}`);
    }

    if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
      query = query.concat(`&name=${filterReq.name}`);
    }
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/v2/get-event-merged-dataset?${query}`,
  );
};
export const APIGetMargedEventMergedDataV2 = async (
  filterReq?: GetAllMeetingsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";
  if (filterReq) {
    query = query.concat(`pageSize=${filterReq.pageSize}`);

    query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

    // query = query.concat(`&isList=${filterReq.isList}`);
    if (
      filterReq.fromDate &&
      !IsStringNullEmptyOrUndefined(filterReq.fromDate)
    ) {
      query = query.concat(`&fromDate=${filterReq.fromDate}`);
    }

    if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
      query = query.concat(`&toDate=${filterReq.toDate}`);
    }

    if (
      filterReq.firmName &&
      !IsStringNullEmptyOrUndefined(filterReq.firmName)
    ) {
      query = query.concat(`&firmName=${filterReq.firmName}`);
    }

    if (
      filterReq.newOrExisting &&
      !IsStringNullEmptyOrUndefined(filterReq.newOrExisting)
    ) {
      query = query.concat(`&newOrExisting=${filterReq.newOrExisting}`);
    }

    if (
      filterReq.mobileNumber &&
      !IsStringNullEmptyOrUndefined(filterReq.mobileNumber)
    ) {
      query = query.concat(`&mobileNumber=${filterReq.mobileNumber}`);
    }

    if (filterReq.country) {
      query = query.concat(`&country=${filterReq.country}`);
    }

    if (filterReq.state && !IsStringNullEmptyOrUndefined(filterReq.state)) {
      query = query.concat(`&state=${filterReq.state}`);
    }

    if (filterReq.city && !IsStringNullEmptyOrUndefined(filterReq.city)) {
      query = query.concat(`&city=${filterReq.city}`);
    }

    if (
      filterReq.assignToUser &&
      !IsStringNullEmptyOrUndefined(filterReq.assignToUser)
    ) {
      query = query.concat(`&assignToUser=${filterReq.assignToUser}`);
    }
    if (
      filterReq.guestType &&
      !IsStringNullEmptyOrUndefined(filterReq.guestType)
    ) {
      query = query.concat(`&guestType=${filterReq.guestType}`);
    }

    if (
      filterReq.assignToOffice &&
      !IsStringNullEmptyOrUndefined(filterReq.assignToOffice)
    ) {
      query = query.concat(`&assignToOffice=${filterReq.assignToOffice}`);
    }

    if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
      query = query.concat(`&name=${filterReq.name}`);
    }

    if (filterReq.sortColumn && !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
    ) {
      query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
    }

    if (filterReq.sortOrder && !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
    ) {
      query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
    }
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/v2/get-all-meetings?${query}`,
  );
};

export const APIFetchAllMeetingsDetails = async (
  filterReq: GetAllMeetingsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (
    filterReq.attendOfficeName &&
    !IsStringNullEmptyOrUndefined(filterReq.attendOfficeName)
  ) {
    query = query.concat(`&attendOfficeName=${filterReq.attendOfficeName}`);
  }

  if (
    filterReq.attendUserName &&
    !IsStringNullEmptyOrUndefined(filterReq.attendUserName)
  ) {
    query = query.concat(`&attendUserName=${filterReq.attendUserName}`);
  }

  if (filterReq.mobileNo && !IsStringNullEmptyOrUndefined(filterReq.mobileNo)) {
    query = query.concat(`&mobileNo=${filterReq.mobileNo}`);
  }

  if (
    filterReq.assignToOffice &&
    !IsStringNullEmptyOrUndefined(filterReq.assignToOffice)
  ) {
    query = query.concat(`&assignToOffice=${filterReq.assignToOffice}`);
  }

  if (
    filterReq.assignToUser &&
    !IsStringNullEmptyOrUndefined(filterReq.assignToUser)
  ) {
    query = query.concat(`&assignToUser=${filterReq.assignToUser}`);
  }

  if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
    query = query.concat(`&name=${filterReq.name}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/get-all-meetings?${query}`,
  );
};

export const APIhideShowAlbum = async (
  reqObj: HideShowAlbum,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.album}/hide-show`, reqObj);
};

export const APIUpdateAlbumAccessibility = async (
  reqObj: AlbumAccessibility,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.album}/update-album-accessibility`,
    reqObj,
  );
};

export const APIExportIndiaDesignVisitors =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.indiaDesign}/export-visitors`,
    );
  };

export const APIExportIndiaDesignInvitations =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.indiaDesign}/export-invitations`,
    );
  };

export const APIFetchAllIndiaDesignVisitors = async (
  reqbody: ComnonIndiaDesignFilterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.indiaDesign}/fetch-all-visitors`,
    reqbody,
  );
};

export const APIFetchAllIndiaDesignInvitations = async (
  reqbody: ComnonIndiaDesignFilterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.indiaDesign}/fetch-all-invitations`,
    reqbody,
  );
};

export const APIIDFetchEventYearDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.indiaDesign}/event-year-DDL`,
  );
};

export const APIFetchIDAssignedUsers = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.indiaDesign}/fetch-assigned-users`,
  );
};

export const APIFetchIDAssignedUserOffices =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.indiaDesign}/fetch-assigned-user-offices`,
    );
  };

export const APIFetchOfficesFromInvitation =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.indiaDesign}/fetch-offices-from-invitation`,
    );
  };

export const APIFetchAvailalbleInvitationCounts =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.indiaDesign}/fetch-availalble-invitation-counts`,
    );
  };

export const APICreateIDInvitationLink = async (
  mobileNumber: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.indiaDesign}/create-invitation-link/${mobileNumber}`,
  );
};

export const APIDownloadsLeadsOrSharedExcel = async (
  type: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/exportReferralExcel-v2`,
  );
};

export const APIFetchLeadsOrSharedDetails = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/getReferralDetails?id=${id}`,
  );
};

export const APIGetLeadsAndSharedDetails = async (
  filterReq: GetAllLeadsSharedDetailsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
    query = query.concat(`&name=${filterReq.name}`);
  }

  if (
    filterReq.mobileNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.mobileNumber)
  ) {
    query = query.concat(`&mobileNumber=${filterReq.mobileNumber}`);
  }

  if (
    filterReq.attendByOfficeName &&
    !IsStringNullEmptyOrUndefined(filterReq.attendByOfficeName)
  ) {
    query = query.concat(`&attendByOfficeName=${filterReq.attendByOfficeName}`);
  }

  if (
    filterReq.attendByTheUser &&
    !IsStringNullEmptyOrUndefined(filterReq.attendByTheUser)
  ) {
    query = query.concat(`&attendByTheUser=${filterReq.attendByTheUser}`);
  }

  if (
    filterReq.assignedOffice &&
    !IsStringNullEmptyOrUndefined(filterReq.assignedOffice)
  ) {
    query = query.concat(`&assignedOffice=${filterReq.assignedOffice}`);
  }

  if (
    filterReq.assignedUser &&
    !IsStringNullEmptyOrUndefined(filterReq.assignedUser)
  ) {
    query = query.concat(`&assignedUser=${filterReq.assignedUser}`);
  }

  if (filterReq.type && !IsStringNullEmptyOrUndefined(filterReq.type)) {
    query = query.concat(`&type=${filterReq.type}`);
  }

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.leadType && !IsStringNullEmptyOrUndefined(filterReq.leadType)) {
    query = query.concat(`&leadType=${filterReq.leadType}`);
  }

  if (
    filterReq.leadResourceType &&
    !IsStringNullEmptyOrUndefined(filterReq.leadResourceType)
  ) {
    query = query.concat(`&leadResourceType=${filterReq.leadResourceType}`);
  }

  if (
    filterReq.attendingEvent &&
    !IsStringNullEmptyOrUndefined(filterReq.attendingEvent)
  ) {
    query = query.concat(`&attendingEvent=${filterReq.attendingEvent}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/referrals/get-all-referrals-v2?${query}`,
  );
};

export const APIGetListOfNotes = async (obj: {
  meetingId: string;
  leadId: string;
  eventId: string;
}): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/getVisitNotesWeb`,
    {
      params: { ...obj, sortBy: 0 },
    },
  );
};

export const APICreateTraderBySocial = async (
  reqPayload: TraderContactEntity,
  isForSocial: boolean,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.jbConnect}/v1.0/create-trader-by-social?isForSocial=${isForSocial}`,
    reqPayload,
  );
};

export const APIGetTradersBySocialDetails = async (
  filterReq: GetAllTraderBySocialDetailsReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.searchByName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByName)
  ) {
    query = query.concat(`&searchByName=${filterReq.searchByName}`);
  }

  if (
    filterReq.searchByFirmName &&
    !IsStringNullEmptyOrUndefined(filterReq.searchByFirmName)
  ) {
    query = query.concat(`&searchByFirmName=${filterReq.searchByFirmName}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/get-trader-by-social?${query}`,
  );
};

export const APIFetchAccessoryOnlyCategoryStructure =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.accessoryOnly}/fetch-accessory-only-category-structure`,
    );
  };

export const APIExportAccessoryOnly = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.accessoryOnly}/exportAccessoryOnly`,
  );
};

export const APICreateUpdateAccessoryOnly = async (
  reqObj: AccessoryOnlyReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.accessoryOnly}/create-update`,
    reqObj,
  );
};

export const APIFetchAccessoryOnlyCategoryConfig = async (reqObj: {
  orderId: string;
  solutionId?: string;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.accessoryOnly}/fetch-accessory-only-category-config`,
    reqObj,
  );
};

export const APICsStcikerPDF = async (
  orderId: string,
  keyName: string,
): Promise<AxiosResponse> => {
  const query = `keyName=${keyName}`;
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/cs-sticker-pdf/${orderId}?${query}`,
  );
};

export const APIGetAlbumsDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.album}/get-albums-ddl`);
};

export const APIMoveAlbumsImages = async (
  reqObj: APIMoveAlbumsImagesReqBody,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.album}/move-albums-images`,
    reqObj,
  );
};

export const APICalculateAccessoryOnlySolutionFeatures = async (
  body: CreateUpdateGlassSolutionReqPayloadEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/calculate-accessory-only-order-features`,
    body,
  );
};

export const APIDownloadLeadsPDF = async (
  id: string,
  meetingId: string = "",
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/downloads-leads-pdf?id=${id}&meetingId=${meetingId}`,
  );
};

export const APIFetchAllB2B = async (
  filterReq: GetAllB2BReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.fromDate && !IsStringNullEmptyOrUndefined(filterReq.fromDate)) {
    query = query.concat(`&fromDate=${filterReq.fromDate}`);
  }

  if (filterReq.toDate && !IsStringNullEmptyOrUndefined(filterReq.toDate)) {
    query = query.concat(`&toDate=${filterReq.toDate}`);
  }

  if (filterReq.firmName && !IsStringNullEmptyOrUndefined(filterReq.firmName)) {
    query = query.concat(`&firmName=${filterReq.firmName}`);
  }

  if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
    query = query.concat(`&name=${filterReq.name}`);
  }

  if (
    filterReq.AssignedToTheUser &&
    !IsStringNullEmptyOrUndefined(filterReq.AssignedToTheUser)
  ) {
    query = query.concat(`&AssignedToTheUser=${filterReq.AssignedToTheUser}`);
  }

  if (
    filterReq.AssignedToOffice &&
    !IsStringNullEmptyOrUndefined(filterReq.AssignedToOffice)
  ) {
    query = query.concat(`&AssignedToOffice=${filterReq.AssignedToOffice}`);
  }

  if (filterReq.city && !IsStringNullEmptyOrUndefined(filterReq.city)) {
    query = query.concat(`&city=${filterReq.city}`);
  }

  if (filterReq.country && !IsStringNullEmptyOrUndefined(filterReq.country)) {
    query = query.concat(`&country=${filterReq.country}`);
  }

  if (filterReq.state && !IsStringNullEmptyOrUndefined(filterReq.state)) {
    query = query.concat(`&state=${filterReq.state}`);
  }

  // if (filterReq.searchByLocation && !IsStringNullEmptyOrUndefined(filterReq.searchByLocation)) {
  //     query = query.concat(`&searchByLocation=${filterReq.searchByLocation}`);
  // }

  if (
    filterReq.mobileNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.mobileNumber)
  ) {
    query = query.concat(`&mobileNumber=${filterReq.mobileNumber}`);
  }

  if (filterReq.linkSent && !IsStringNullEmptyOrUndefined(filterReq.linkSent)) {
    query = query.concat(`&linkSent=${filterReq.linkSent}`);
  }

  if (
    filterReq.linkSubmitted &&
    !IsStringNullEmptyOrUndefined(filterReq.linkSubmitted)
  ) {
    query = query.concat(`&linkSubmitted=${filterReq.linkSubmitted}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.b2b}/get-all-b2b?${query}`);
};
export const APISentMessageToTraderForQualified = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.jbConnect}/send-message-to-trader-for-qualified/${id}`,
  );
};

export const APIDownloadExcelForTrader = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/download-excel-for-trader-detail?id=${id}`,
  );
};

export const APIGenerateWorkOrder = async (
  reqBody: GenerateWorkOrderReq,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/generate-work-order`,
    reqBody,
  );
};

export const APIFetchExecutionOrderDetails = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionPlanning}/fetch-execution-order-details/${orderId}`,
  );
};

export const APIUploadDrawingTemporaryFiles = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/upload-temporary-drawing`,
    data,
  );
};

export const APIGetWorkOrderDetails = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/get-work-order-details`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIExportAllWOs = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/get-all-work-order-details-excel`,
  );
};

export const APIExportWorkOrderDetailsExcel = async (reqBody: {
  id: string;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/get-work-order-details-excel`,
    reqBody,
  );
};

export const APIFetchWorkOrderGetById = async (
  workOrderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.workOrder}/${workOrderId}`);
};

export const APIMarkWoAsPlannedForDispatched = async (
  reqBody: PlanDispatchRequestEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/mark-wo-as-planned-for-dispatched`,
    reqBody,
  );
};

export const APIUpdateForMakeWOSolutionAsReady = async (
  workOrderId: string,
  solutionIds: string[],
  solutionDetails: MarkWOSolutionAsReadyPackageDetailEntity[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/mark-wo-solution-as-ready`,
    {
      woId: workOrderId,
      woSolutionIds: solutionIds,
      woSolutionDetails: solutionDetails,
    },
  );
};

export const APIUpdateAllocatedSolutionPackageCounts = async (
  workOrderId: string,
  solutionDetails: MarkWOSolutionAsReadyPackageDetailEntity[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/update-allocated-solution-package-counts`,
    {
      woId: workOrderId,
      woSolutionDetails: solutionDetails,
    },
  );
};
export const APIUpdateFullDispatchValue = async (
  reqObj: UpdateFullDispatchValue,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/work-order-status-in-dispatched/${id}`,
    reqObj,
  );
};

export const APIUploadDispatchImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.workOrder}/upload-dispatched/${id}`,
    data,
  );
};

export const APIGetWorkOrderDetailsByStatus = async (
  status: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/get-work-order-details-by-status`,
    {
      status: status,
    },
  );
};
export const APIExportB2B = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.b2b}/export-b2b`);
};

export const APIDownloadsB2BImages = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.b2b}/downloads-b2b-images`);
};

export const APISendMessage = async (
  reqObj: SendMessage,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.jbConnect}/sendVisitNotesMessage`,
    reqObj,
  );
};

export const APIFetchMeetingConfiguration = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/get-meeting-configuration?id=${id}`,
  );
};

export const APIForStartMeetingForLead = async (
  visitId: string,
  typeId: string,
  type: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.jbConnect}/startMeeting`,
    {
      params: {
        visitAtId: visitId,
        typeId,
        type,
      },
    },
  );
};

export const APIForSendVisitNoteForMeeting = async (
  id: string,
  message: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.jbConnect}/sendVisitNotesMessage`,
    {
      message,
      meetingId: id,
    },
  );
};

export const APIUploadVisitNoteImage = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      fileType: 1,
      meetingId: id,
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.jbConnect}/uploadVisitNotesFile`,
    data,
  );
};

export const APIUplodeOfficeDocument = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.office}/upload-file/${id}`,
    data,
  );
};

export const APIFetchOfficeFiles = async (
  filterReq: PaginateReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&id=${id}`);

  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/documents/get-all?${query}`,
  );
};
export const APIForVerifyWorkOrderForMakeHandover = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v1.0/verify-work-orders-for-make-handover/${id}`,
  );
};

export const APIDeleteWorkOrder = async (
  woNumber: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.workOrder}/delete/${woNumber}`,
  );
};

export const APICreateDeliveryAdvice = async (
  reqBody: CreateDeliveryAdviceReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/create-delivery-advice`,
    reqBody,
  );
};

export const APIUploadLoadingImageForDispatch = async (
  data: FormData,
  uuid: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/upload-loading-files/${uuid}`,
    data,
  );
};

export const APIUploadInvoiceFile = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/upload-invoice-for-wo`,
    data,
  );
};

export const APIUpdateDeliveryDetail = async (
  reqBody: UpdateDeliveryAdviceReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/update-delivery-details`,
    {
      ...reqBody,
      truckNumber: reqBody.truckNo,
      driverMobileNo: reqBody.driverMobileNumber,
    },
  );
};

export const APIUpdateInvoiceDetails = async (
  reqBody: UpdateInvoiceDetailsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/update-invoice-details`,
    reqBody,
  );
};

export const APIFetchAllMeetingConfigurationDetails = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.meetingConfigurationSeeting}/get-all?${query}`,
  );
};

export const APICreateUpdateMeetingConfiguration = async (
  reqObj: CreateUpdateMeetingConfiguration,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.meetingConfigurationSeeting}/create-update`,
    reqObj,
  );
};

export const APIDeleteMeetingConfiguration = async (
  reqObj: string[],
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.meetingConfigurationSeeting}/delete`,
    { data: reqObj },
  );
};

export const APIExportBICProjectManagerDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.productionPlanning}/export-BIC-project-manager-details`,
    );
  };
export const APIExportPMBICLists = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionPlanning}/v1.0/export-PM-BIC-lists`,
  );
};

export const APIGetBICProjectManagerDetails = async (
  filterReq: ProjectManagerBICListreqFilterEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/list-BIC-project-manager-details`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIGetDeliveryAdviceDetails = async (
  filterReq: DeliveryAdviceListReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (filterReq.woType && filterReq.woType.length > 0) {
    query = query.concat(`&woType=${filterReq.woType.join(",")}`);
  }

  if (
    filterReq.dispatchFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.dispatchFromDate)
  ) {
    query = query.concat(`&dispatchFromDate=${filterReq.dispatchFromDate}`);
  }

  if (
    filterReq.dispatchToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.dispatchToDate)
  ) {
    query = query.concat(`&dispatchToDate=${filterReq.dispatchToDate}`);
  }

  if (
    filterReq.serialNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.serialNumber)
  ) {
    query = query.concat(`&serialNumber=${filterReq.serialNumber}`);
  }

  if (
    filterReq.workOrderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.workOrderNumber)
  ) {
    query = query.concat(`&workOrderNumber=${filterReq.workOrderNumber}`);
  }

  if (
    filterReq.workOrderValue &&
    !IsStringNullEmptyOrUndefined(filterReq.workOrderValue)
  ) {
    query = query.concat(`&workOrderValue=${filterReq.workOrderValue}`);
  }

  if (
    filterReq.deliveryFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.deliveryFromDate)
  ) {
    query = query.concat(`&deliveryFromDate=${filterReq.deliveryFromDate}`);
  }

  if (
    filterReq.deliveryToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.deliveryToDate)
  ) {
    query = query.concat(`&deliveryToDate=${filterReq.deliveryToDate}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(
      `&sortColumn=${filterReq.sortColumn}`
    );
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(
      `&sortOrder=${filterReq.sortOrder}`
    );
  }

  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/get-all-delivery-advice?${query}`,
  );
};

export const APIExportDeliveryAdviceDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(`${APIURL}/${BaseEndpoints.deliveryAdvice}/export-delivery-advice-details
 `);
  };

export const APIDownloadGDNWorkOrderPDF = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v2.0/create/goods-delivery-note-new-pdf/${id}`,
  );
};

export const APIFetchDeliverAdviceForMakeMDA =
  async (): Promise<AxiosResponse> => {
    return await axios.get(`${APIURL}/${BaseEndpoints.deliveryAdvice}/get-delivery-advice-for-make-mda
 `);
  };

export const APICreateMasterMasterDeliverAdvice = async (reqBody: {
  deliveryAdviceIds: string[];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/create-master-delivery-advice`,
    reqBody,
  );
};

export const APIGetMasterDeliveryAdviceDetails = async (
  filterReq: MasterDeliveryAdviceListReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);
  query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  query = query.concat(`&sortOrder=${filterReq.sortOrder}`);

  if (
    filterReq.createdFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createdFromDate)
  ) {
    query = query.concat(`&createdFromDate=${filterReq.createdFromDate}`);
  }

  if (
    filterReq.driverName &&
    !IsStringNullEmptyOrUndefined(filterReq.driverName)
  ) {
    query = query.concat(`&driverName=${filterReq.driverName}`);
  }

  if (
    filterReq.transporterName &&
    !IsStringNullEmptyOrUndefined(filterReq.transporterName)
  ) {
    query = query.concat(`&transporterName=${filterReq.transporterName}`);
  }

  if (
    filterReq.driverMobileNo &&
    !IsStringNullEmptyOrUndefined(filterReq.driverMobileNo)
  ) {
    query = query.concat(`&driverMobileNo=${filterReq.driverMobileNo}`);
  }

  if (
    filterReq.truckNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.truckNumber)
  ) {
    query = query.concat(`&truckNumber=${filterReq.truckNumber}`);
  }

  if (
    filterReq.createdToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createdToDate)
  ) {
    query = query.concat(`&createdToDate=${filterReq.createdToDate}`);
  }

  if (
    filterReq.MDASerialNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.MDASerialNumber)
  ) {
    query = query.concat(`&MDASerialNumber=${filterReq.MDASerialNumber}`);
  }

  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/get-all-master-delivery-advice?${query}`,
  );
};

export const APIDownloadPreviewDAAndMDAPDF = async (
  uuid: string,
  isInvoice: boolean = false,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/preview-da-and-mda/${uuid}?isInvoice=${isInvoice}`,
  );
};

export const APISubmitMasterdeliveryAdvice = async (reqBody: {
  uuid: string;
  isDraft: boolean;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/submit-master-delivery-advice`,
    {
      ...reqBody,
    },
  );
};

export const APIFetchViewMDADetailsById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/view-master-delivery-advice-details/${id}`,
  );
};

export const APIExportMasterDeliveryAdviceDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(`${APIURL}/${BaseEndpoints.deliveryAdvice}/export-master-delivery-advice
 `);
  };

export const APIMakeWOAsDelivered = async (
  id: string,
  reqBody: MakeWOAsDeliveredReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/make-wo-as-delivered/${id}`,
    {
      ...reqBody,
    },
  );
};

export const APIUploadDeliveryFileForWO = async (
  id: string,
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.workOrder}/upload-delivered-file-for-wo/${id}`,
    data,
  );
};

export const APISplitWorkOrders = async (
  wo_id: string,
  solutionIds_list1: string[],
  solutionIds_list2: string[],
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.splitWorkOrder}/create`, {
    wo_id,
    allocatedSolutions_id_list_1: solutionIds_list1,
    allocatedSolutions_id_list_2: solutionIds_list2,
  });
};

export const APIGetAssociatedUsersList = async (
  roleId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.role}/users-list/${roleId}`,
  );
};

export const APIFetchDraftMDADetails = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.deliveryAdvice}/get-draft-mda
 `);
};

export const APIFetchingDraftMDADetailForEdit = async (
  uuid: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/get-draft-mda-details/${uuid}`,
  );
};

export const APIRemoveLoadingFileInDA = async (
  uuid: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/remove-loading-files/${uuid}`,
  );
};

export const APIDownloadDraftMDAPDF = async (
  uuid: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/get-draft-master-da-pdf/${uuid}`,
  );
};

export const APIFetchingGenerateOrderSummary = async (
  reqBody: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.verifyOrder}/fetch-generate-order-summary`,
    reqBody,
  );
};

export const APIFetchingOrderVersionsForSolutionCompare = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.verifyOrder}/get-order-versions/${orderId}`,
  );
};

export const APIFetchingCompareSolutionDetail = async (
  oldOrderId: string,
  newOrderId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.verifyOrder}/fetch-compare-solution-detail`,
    {
      oldOrderId: oldOrderId,
      newOrderId: newOrderId,
    },
  );
};

export const APIFetchingOrderSolutionComparisonPdf = async (
  reqObj: OrderComparisonsPdfEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.verifyOrder}/get-solution-comparison`,
    reqObj,
  );
};

export const APIDownloadDraftOrderPDF = async (
  reqObj: GenerateOrderReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.verifyOrder}/verify-draft-order-pdf`,
    reqObj,
  );
};

export const APIMeetingsFetchOfficeAndUsers =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.jbConnect}/get-offices-users-ddl`,
    );
  };

export const APIUplodeUserProfilePicture = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.user}/upload-user-profile-picture/${id}`,
    data,
  );
};

export const APIUploadUserAttachment = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN)}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.user}/upload-user-attachment`,
    data,
  );
};

export const APIFetchUserAttachments = async (
  userId: string,
  pageSize: number,
  pageNumber: number,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.user}/fetch-user-attachment/${userId}?pageSize=${pageSize}&pageNumber=${pageNumber + 1}`,
  );
};

export const APISaveAdditionalOffersForOffice = async (
  data: SaveAdditionalOffersReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.office}/save-models-additonal-dealer-discount`,
    data,
  );
};

export const APISaveAdditionalOffersForOfficePanelOnly = async (
  data: SaveAdditionalOffersForPanelOnlyReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.office}/save-panel-only-additonal-dealer-discount`,
    data,
  );
};

export const APIFetchingModelStructureForOffice = async (
  officeId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/get-office-additional-detail/${officeId}`,
  );
};

export const APIFetchingPanelOnlyStructureForOffice = async (
  officeId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/get-office-additional-detail-for-panel-only/${officeId}`,
  );
};

export const APIVerifyModelForOfficeAdditionalMapping = async (
  ids: string[],
  officeId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.office}/verify-model-for-office-additional-mapping`,
    { ids, officeId },
  );
};
export const APIVerifyPanelForOfficeAdditionalMapping = async (
  panelStructure: AdditionalPanelOnlyDetailEntity[],
  officeId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.office}/verify-panel-for-office-additional-mapping`,
    { panelStructure, officeId },
  );
};

export const APIGetArchitectFirmOfAssignedSalseUserDDl = async (reqBody: {
  userId: string[];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.dashboard}/get-architect-firm-of-assigned-sales-user-ddl`,
    reqBody,
  );
};

export const APIGetStateCityAssginedDDL = async (reqBody: {
  officeId: string[];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.dashboard}/get-state-city-of-assigned-office-ddl`,
    reqBody,
  );
};

export const APIGetFeedbackMattersFilterData = async (
  reqBody: DashboardFiltersEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.dashboard}/get-feedback-matters-filter-data
 `,
    reqBody,
  );
};
export const APIFetchDMBICLists = async (
  filterReq: ProjectManagerBICListreqFilterEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/fetch-DM-BIC-lists`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIReassignmentOfSMAndDM = async (
  reqBody: reassignmentOfSMAndDMReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/reassignment-of-sm-dm
   `,
    reqBody,
  );
};

export const APIExportDMBICLists = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionPlanning}/export-DM-BIC-lists`,
  );
};

export const APIGetDMBICListsCount = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionPlanning}/get-DM-BIC-lists-count`,
  );
};

export const APICreateDrawing = async (
  reqObj: DrawingReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.drawingSettings}/create`,
    reqObj,
  );
};

export const APIUpdateDrawing = async (
  reqObj: DrawingReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.drawingSettings}/update/${id}`,
    reqObj,
  );
};

export const APIFetchDetailsDrawing = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingSettings}/get-all?${query}`,
  );
};

export const APIDeleteDrawing = async (id: string): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.drawingSettings}/delete/${id}`,
  );
};

export const APIFetchingDrawingDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.drawingSettings}/get-ddl`);
};

export const APIUploadDrawingSet = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.drawingPlan}/upload-draft-drawing-plan`,
    data,
  );
};

export const APIUploadSplitDrawingSet = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.drawingPlan}/upload-split-pdf-for-drawing-plan/${id}`,
    data,
  );
};

export const APIUploadSplitDrawingSetForOrder = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/upload-drawing-split-pdf/${id}`,
    data,
  );
};

export const APIFetchingDraftDrawingDetail = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingPlan}/get-draft-drawing-plan/${id}`,
  );
};

export const APIFetchingFloorDrawingDetail = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingPlan}/get-floor-plan-for-orders/${orderId}`,
  );
};

export const APIFetchingExistingFloorPlans = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingPlan}/get-existing-floor-plan/${orderId}`,
  );
};

export const APICheckSolutionForDrawingPlan = async (
  solutionId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingPlan}/check-solution-for-drawing-plan/${solutionId}`,
  );
};
export const APIRemoveProfilePhoto = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.user}/upload-user-profile-picture/${id}`,
  );
};

export const APIGetSystemDDLForDrawing = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.systemSetting}/get-system-ddl-for-drawing`,
  );
};

export const APIUploadEditDrawings = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/upload-edit-drawing/${id}`,
    data,
  );
};

export const APIDownloadFeedbackTrustMattersPDF = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/feedback_trust_matters_combine_pdf/${orderId}`,
  );
};

export const APIFetchProjectDirectoryDetails = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v1.0/fetch-project-directory-details/${orderId}`,
  );
};

export const APIFetchProcoreDocumentFolders = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.order}/v1.0/fetch-procore-document-folders/${orderId}`,
  );
};

export const APIVerifyWaltzSolutionForDrawingPlan = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/verify-waltz-solution-for-drawing-plan/${orderId}`,
  );
};
export const APIUpdateDocumentation = async (
  body: any,
  id: string | null,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.documentation}/update-documentation/${id}`,
    body,
  );
};

export const APIFindOneDocumentation = async (
  req: any,
): Promise<AxiosResponse> => {
  let query = "";

  if (req.id && !IsStringNullEmptyOrUndefined(req.id)) {
    query = query.concat(`&id=${req.id}`);
  }

  if (req.path && !IsStringNullEmptyOrUndefined(req.path)) {
    query = query.concat(`&path=${req.path}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.documentation}/get-documentation?${query}`,
  );
};

export const APIGetAllDocumentation = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.documentation}/get-all-documentation`,
  );
};

export const APIRolesExistUsers = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.role}/get-all-roles-exists-users`,
  );
};

export const APIUplodeESignatureFile = async (
  data: FormData,
  id: string,
  fieldName: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      fieldName: fieldName,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.user}/upload-user-ESignature/${id}`,
    data,
  );
};
export const APIExportProjectDirectoryDetailsExcel = async (
  reqBody: FetchSolutionDetailsRequestBodyEntity,
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/export-project-directory-details-excel/${orderId}`,
    reqBody,
  );
};
export const APICreateUserStateMapping = async (
  body: CreateUserStateMappingReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.socials}/create`, body);
};

export const APIUpdateUserStateMapping = async (
  id: string,
  body: CreateUserStateMappingReqEntity,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.socials}/update/${id}`,
    body,
  );
};

export const APIGetUnmappedStates = async (
  page: number = 1,
  limit: number = 10,
  sortBy: string = "name",
  sortOrder: string = "asc",
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.socials}/get-unmapped-states?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
  );
};

export const APIGetAllStateUserMappings = async (
  page: number = 1,
  limit: number = 10,
  sortBy: string = "createdAt",
  sortOrder: string = "desc",
  searchText: string,
  emailSearchText: string,
): Promise<AxiosResponse> => {
  let query = "";

  if (searchText && !IsStringNullEmptyOrUndefined(searchText)) {
    query = query.concat(`&name=${searchText}`);
  }

  if (emailSearchText && !IsStringNullEmptyOrUndefined(emailSearchText)) {
    query = query.concat(`&email=${emailSearchText}`);
  }
  return await axios.get(
    `${APIURL}/${BaseEndpoints.socials}/get-all?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}&${query}`,
  );
};

export const APIGetAllLeads = async (
  filterReq: GetAllLeadsRequest,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.limit || 10}`);
  query = query.concat(`&pageNumber=${filterReq.page || 1}`);

  if (filterReq.sortBy && !IsStringNullEmptyOrUndefined(filterReq.sortBy)) {
    query = query.concat(`&sortBy=${filterReq.sortBy}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.startDate &&
    !IsStringNullEmptyOrUndefined(filterReq.startDate)
  ) {
    query = query.concat(`&startDate=${filterReq.startDate}`);
  }

  if (filterReq.endDate && !IsStringNullEmptyOrUndefined(filterReq.endDate)) {
    query = query.concat(`&endDate=${filterReq.endDate}`);
  }

  if (filterReq.name && !IsStringNullEmptyOrUndefined(filterReq.name)) {
    query = query.concat(`&name=${filterReq.name}`);
  }

  if (filterReq.profile && !IsStringNullEmptyOrUndefined(filterReq.profile)) {
    query = query.concat(`&profile=${filterReq.profile}`);
  }

  if (
    filterReq.architectFirmName &&
    !IsStringNullEmptyOrUndefined(filterReq.architectFirmName)
  ) {
    query = query.concat(`&architectFirmName=${filterReq.architectFirmName}`);
  }

  if (filterReq.mobileNo && !IsStringNullEmptyOrUndefined(filterReq.mobileNo)) {
    query = query.concat(`&mobileNo=${filterReq.mobileNo}`);
  }

  if (filterReq.emailId && !IsStringNullEmptyOrUndefined(filterReq.emailId)) {
    query = query.concat(`&email=${filterReq.emailId}`);
  }

  if (filterReq.state && !IsStringNullEmptyOrUndefined(filterReq.state)) {
    query = query.concat(`&state=${filterReq.state}`);
  }

  if (filterReq.country && !IsStringNullEmptyOrUndefined(filterReq.country)) {
    query = query.concat(`&country=${filterReq.country}`);
  }

  if (filterReq.city && !IsStringNullEmptyOrUndefined(filterReq.city)) {
    query = query.concat(`&city=${filterReq.city}`);
  }

  if (filterReq.source && !IsStringNullEmptyOrUndefined(filterReq.source)) {
    query = query.concat(`&source=${filterReq.source}`);
  }

  if (filterReq.status && !IsStringNullEmptyOrUndefined(filterReq.status)) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (
    filterReq.assignedTo &&
    !IsStringNullEmptyOrUndefined(filterReq.assignedTo)
  ) {
    query = query.concat(`&assignedTo=${filterReq.assignedTo}`);
  }

  if (filterReq.campaign && !IsStringNullEmptyOrUndefined(filterReq.campaign)) {
    query = query.concat(`&campaign=${filterReq.campaign}`);
  }

  if (
    filterReq.orderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.orderNumber)
  ) {
    query = query.concat(`&orderNumber=${filterReq.orderNumber}`);
  }
  if (
    filterReq.orderStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.orderStatus)
  ) {
    query = query.concat(`&orderStatus=${filterReq.orderStatus}`);
  }
  if (
    filterReq.assignOrderTo &&
    !IsStringNullEmptyOrUndefined(filterReq.assignOrderTo)
  ) {
    query = query.concat(`&assignOrderTo=${filterReq.assignOrderTo}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.leads}/get-all?${query}`);
};

export const APICreateLead = async (
  body: CreateLeadRequest,
): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.leads}/create`, body);
};

export const APIUpdateLead = async (
  id: string,
  body: UpdateLeadRequest,
): Promise<AxiosResponse> => {
  return await axios.put(`${APIURL}/${BaseEndpoints.leads}/${id}`, body);
};

export const APIConvertLeadToOrder = async (
  id: string,
  body: ConvertToOrderRequest,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.leads}/${id}/convert-to-order`,
    body,
  );
};

// Get single lead by ID
export const APIGetLeadById = async (id: string): Promise<AxiosResponse> => {
  try {
    const response = await axios.get(`${APIURL}/${BaseEndpoints.leads}/${id}`);
    return response;
  } catch (error: any) {
    throw error;
  }
};

// Disqualify a lead
export const APIDisqualifyLead = async (
  id: string,
  body: DisqualifyLeadRequest,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.leads}/${id}/disqualify`,
    body,
  );
};

// Assign lead to a user
export const APIAssignLead = async (
  id: string,
  body: AssignLeadRequest,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.leads}/${id}/assign`,
    body,
  );
};

// Export leads data
export const APIExportLeads = async (
  params: ExportLeadsRequest = {},
): Promise<AxiosResponse> => {
  const { search, status, assignedTo, state, city, source } = params;

  let queryParams = "";
  const queryArray: string[] = [];

  if (search) queryArray.push(`search=${encodeURIComponent(search)}`);
  if (status) queryArray.push(`status=${encodeURIComponent(status)}`);
  if (assignedTo)
    queryArray.push(`assignedTo=${encodeURIComponent(assignedTo)}`);
  if (state) queryArray.push(`state=${encodeURIComponent(state)}`);
  if (city) queryArray.push(`city=${encodeURIComponent(city)}`);
  if (source) queryArray.push(`source=${encodeURIComponent(source)}`);

  if (queryArray.length > 0) {
    queryParams = `?${queryArray.join("&")}`;
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.leads}/export${queryParams}`,
  );
};

// Upload attachments for a lead
export const APIUploadLeadAttachments = async (
  id: string,
  formData: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.leads}/${id}/upload-attachments`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

// get user by state id
// export const APIFetchUserByStateId = async (
//   stateId: string
// ): Promise<AxiosResponse> => {
//   return await axios.get(
//     `${APIURL}/${BaseEndpoints.socials}/get-users-by-state/${stateId}`
//   );
// };

export const APIForDownloadDrawingPlanPDF = async (
  data: FormData,
  orderId: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.drawingPlan}/download-drawing-plan?id=${orderId}`,
    data,
  );
};

export const APIForUploadDrawingForOrder = async (
  data: FormData,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/upload-drawing-set`,
    data,
  );
};

export const APIDownloadDrawingPlanPDFForOrder = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/combine-drawing-floor-pdf/${orderId}`,
  );
};

export const APIUplodeSystemIcon = async (
  data: FormData,
  id: string,
  fieldName: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
      fieldName: fieldName,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.systemSetting}/upload-system/${id}`,
    data,
  );
};

export const APIExportHighlightsDetail = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingPlan}/export-highlights-details`,
  );
};

export const APISubmitExistingDrawingSet = async (
  obj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.drawingPlan}/submit-existing-drawing-set`,
    obj,
  );
};

export const APIForFetchPendingMappingRecordsForOrders = async (
  status: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.RedRibbon}/get-pending-PDF-pins-orders/${status}`,
  );
};

export const APIForFetchNotFeasibleOrders =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-not-feasible-orders`,
    );
  };

export const APIForFetchShopDrawingAwaitingOrders =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-shop-drawing-awaiting-orders`,
    );
  };

export const APIForFetchShopDrawingApprovalPendingOrders =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-shop-drawing-approval-pending-orders`,
    );
  };

export const APIForFetchLocationHistoryStatusDetailsOrders =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-location-history-status-details`,
    );
  };

export const APIForFetchingShopDrawingAwaitingDetails = async (
  orderId: string,
  tabView: string,
  isFromSDApprove: boolean = false,
  isFromNotFeasible: boolean = false,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/fetch-user-wise-location-details`,
    {
      orderId,
      tabView,
      isFromNotFeasible,
      isFromSDApprove,
    },
  );
};

export const APIUploadShopDrawings = async (
  data: FormData,
  orderReferenceNumber: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/upload-shop-drawings/${orderReferenceNumber}`,
    data,
  );
};

export const APIForFetchingShopDrawingPDF = async (id: string) => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/fetch-shop-drawings-by-ID/${id}`,
  );
};

export const APIForSubmitLinkedShopDrawings = async (
  data: SubmitLinkedShopDrawingEntity,
) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/submit-shop-drawing-mapping`,
    data,
  );
};

export const APIForPublishShopDrawings = async (sdId: string) => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/publish-shop-drawings-by-ID/${sdId}`,
  );
};

export const APIForDownloadMeasurementSheetForPreWorkOrder = async (
  orderId: string,
  solutionId: string,
  isSubFrameOrTrack: boolean,
) => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-pre-wo-measurement-sheet-pdf/${orderId}/${solutionId}/${isSubFrameOrTrack}`,
  );
};

export const APIForCombinedDownloadMeasurementSheetForPreWorkOrder = async (
  orderId: string,
  solutionIds: string[] | [],
) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-combined-measurement-sheet-pdf-for-pre-wo`,
    {
      orderId,
      solutionIds,
    },
  );
};

export const APIForSubmitRevisionRequiredSolution = async (obj: any) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/submit-sd-revision-required`,
    obj,
  );
};

export const APIForDownloadShopDrawingPDF = async (
  orderId: string,
  solutionId: string,
  isSubFrameOrTrack: boolean,
  sd_pageId?: string,
  locationTypeFilter: boolean = false,
) => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-waltz-shop-drawing-pdf/${orderId}/${solutionId}`,
    {
      params: {
        isSubFrameOrTrack,
        sd_page_id: sd_pageId,
        locationTypeFilter,
      },
    },
  );
};

export const APIForDownloadProductionDrawingPDF = async (
  workOrderId: string,
  solutionId: string,
  locationType: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-production-drawing-pdf/${workOrderId}/${solutionId}`,
    {
      params: {
        locationType,
      },
    },
  );
};

export const APIForDownloadAllShopDrawingPDF = async (
  orderId: string,
  solutionIds: string[],
  allSolutionDetail: { locationId: string; locationType: string }[] | [] = [],
) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-waltz-all-shop-drawing-pdf`,
    {
      orderId,
      solutionIds,
      allSolutionDetail,
    },
  );
};

export const APIForDownloadAllProductionDrawingPDF = async (
  workOrderId: string,
  allSolutionDetail: { locationId: string; locationType: string }[] | [] = [],
) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-all-production-drawing-pdf`,
    {
      workOrderId,
      allSolutionDetail,
    },
  );
};

export const APIForDownloadTypicalDrawingPDF = async (
  orderId: string,
  allSolutionDetail: { locationId: string; locationType: string }[] | [] = [],
) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.download}/v1.0/download-typical-pdf`,
    {
      orderId,
      allSolutions: allSolutionDetail,
    },
  );
};

export const APIForFetchingSolutionListForSDApprove = async (
  orderId: string,
  solutionsDetail: SD_StampApproveSolutionEntity[],
) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/fetch-solution-list-for-sd-approve`,
    {
      orderId,
      solutionsDetail,
    },
  );
};

export const APIForMakeLocationMarkAsFeasible = async (
  orderId: string,
  solutionsDetail: MarkAsFeasibleSolutionReqEntity[],
) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/submit-mark-as-feasible`,
    {
      orderId,
      solutionsDetail,
    },
  );
};

export const APIForFetchLinkedFloorPlan = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.drawingPlan}/export-linked-floor-plan`,
  );
};

export const APIForPublishAndGenerateWO = async (
  obj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/publish-and-generate-WOs`,
    obj,
  );
};

export const APIForConfirmationOfWOCreation = async (
  obj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/confirmation-of-wo-creation`,
    obj,
  );
};

export const APIForDownloadSDFromWONumber = async (
  woNumber: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/download-shop-drawing-pdf-from-wo/${woNumber}`,
    {
      params: {
        isRedirect: false,
      },
    },
  );
};

export const APIForSubmitMeasurementQuery = async (obj: any) => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/submit-ms-queries`,
    obj,
  );
};
export const APIForFetchCampaigns = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.leads}/get-all-campaign`);
};

export const APIForFetchSocialLeadDraftOrders =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-social-lead-draft-orders`,
    );
  };

export const APIToFetchAllSocialUser = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.socials}/get-all-users`);
};

export const APIToDownloadStateToUserMappingExport =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.socials}/export-state-to-user-mapping`,
    );
  };

export const APIToSyncMetaFormData = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.metaforms}/get-meta-data`);
};

// export const APIRedRibbonFetchCountsV1 = async (): Promise<any> => {
//   // return await axios.get(`${APIURL}/${BaseEndpoints.RedRibbon}/v1.0/fetch-counts`);
//   return await fetch(`${APIURL}/${BaseEndpoints.RedRibbon}/v1.0/fetch-counts`);
// };

export const APIRedRibbonFetchCountsV1 = async (): Promise<Response> => {
  const token = getLocalStorageItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN);

  const url = `${APIURL}/${BaseEndpoints.RedRibbon}/v1.0/fetch-counts`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "text/plain",
      Authorization: token ? `Bearer ${token}` : "",
    },
    cache: "no-cache",
    mode: "cors",
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

export const APIToCreateTransporter = async (
  data: TransporterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.transporterSetting}/create-transporter`,
    data,
  );
};

export const APIToFetchingTransporterDetails = async (
  data: FilterTransporterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.transporterSetting}/get-transporter-details`,
    { ...data, pageNumber: data.pageNumber + 1 },
  );
};

export const APIToUpdateTransporterDetails = async (
  data: TransporterReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.transporterSetting}/update-transporter/${id}`,
    data,
  );
};

export const APIToFetchingTransporterDetailById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.transporterSetting}/fetch-transporter-detail/${id}`,
  );
};

export const APIToFetchingTransporterDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.transporterSetting}/get-transporter-ddl`,
  );
};

export const APIToDeleteTransporter = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.transporterSetting}/delete-transporter/${id}`,
  );
};

export const APIToFetchingInsuranceAgentsDetails = async (
  data: FilterAgentReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/get-insurance-agent-details`,
    { ...data, pageNumber: data.pageNumber + 1 },
  );
};

export const APIToCreateInsuranceAgent = async (
  data: InsuranceAgentReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/create-insurance-agent`,
    data,
  );
};

export const APIToFetchingInsuranceAgentDetailsById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/fetch-insurance-agent-detail/${id}`,
  );
};

export const APIToUpdateInsuranceAgentDetails = async (
  data: InsuranceAgentReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/update-insurance-agent/${id}`,
    data,
  );
};

export const APIToDeleteInsuranceAgent = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/delete-insurance-agent/${id}`,
  );
};

export const APIToFetchInsuranceAgentsDDL =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.insuranceAgent}/get-insurance-agent-ddl`,
    );
  };

export const APIToUploadInsuranceAgentFiles = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/upload-insurance-agent-file/${id}`,
    data,
  );
};

export const APIToUploadTransporterFiles = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.transporterSetting}/upload-transporter-file/${id}`,
    data,
  );
};

export const APIFetchAllInvoiceTermsAndCondition = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText}`);

  return await axios.get(
    `${APIURL}/${BaseEndpoints.invoiceTearmsAndConditionsSettings}/get-all?${query}`,
  );
};

export const APICreateUpdateInvoiceTermsAndCondition = async (
  reqObj: CreateUpdateInvoiceTermsAndCondition,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.invoiceTearmsAndConditionsSettings}/create-update`,
    reqObj,
  );
};

export const APIDeleteInvoiceTermsAndCondition = async (
  reqObj: string[],
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.invoiceTearmsAndConditionsSettings}/delete`,
    { data: reqObj },
  );
};

export const APIToCreateInsurancePolicy = async (
  data: InsurancePolicyReqFormEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/create-insurance`,
    data,
  );
};

export const APIToUpdateInsurancePolicy = async (
  data: InsurancePolicyReqFormEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/update-insurance-details/${id}`,
    data,
  );
};

export const APIToFetchingInsurancePolicyDetails = async (
  data: InsurancePolicyReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/get-insurance-details`,
    { ...data, pageNumber: data.pageNumber + 1 },
  );
};

export const APIToDeleteInsurancePolicy = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/delete-insurance/${id}`,
  );
};

export const APIToFetchingInsurancePolicyById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/fetch-insurance-detail/${id}`,
  );
};

export const APIToUploadInsurancePolicyFiles = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/upload-insurance-file/${id}`,
    data,
  );
};

export const APIForDownloadDrawingFromURL = async (
  PDFUrl: string,
): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${PDFUrl}`);
};

export const APIToUploadRevisionRequiredFile = async (
  data: FormData,
  orderId: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/upload-revision-required-files/${orderId}`,
    data,
  );
};

export const APIFetchAllEmailQueue = async (
  filterReq: FetchAllEmailQueueReqEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.recipientEmail &&
    !IsStringNullEmptyOrUndefined(filterReq.recipientEmail)
  ) {
    query = query.concat(`&recipientEmail=${filterReq.recipientEmail}`);
  }

  if (
    filterReq.sentStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.sentStatus)
  ) {
    query = query.concat(`&sentStatus=${filterReq.sentStatus}`);
  }

  if (filterReq.status && !IsStringNullEmptyOrUndefined(filterReq.status)) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  if (filterReq.type && !IsStringNullEmptyOrUndefined(filterReq.type)) {
    query = query.concat(`&type=${filterReq.type}`);
  }

  if (filterReq.subject && !IsStringNullEmptyOrUndefined(filterReq.subject)) {
    query = query.concat(`&subject=${filterReq.subject}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(
      `&sortColumn=${filterReq.sortColumn}`
    );
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(
      `&sortOrder=${filterReq.sortOrder}`
    );
  }


  return await axios.get(
    `${APIURL}/${BaseEndpoints.email}/fetch-all-queue?${query}`,
  );
};

export const APIExportEmailQueueHistory = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.email}/export-queue`);
};

export const APIFetchEmailQueueDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.email}/fetch-email-queue-ddl`,
  );
};

export const APIFetchAllCountries = async (
  filterReq: GetAllStatesResEntity,
): Promise<AxiosResponse> => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.searchText &&
    !IsStringNullEmptyOrUndefined(filterReq.searchText)
  ) {
    query = query.concat(`&searchText=${filterReq.searchText}`);
  }

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.usedInModule &&
    !IsStringNullEmptyOrUndefined(filterReq.usedInModule)
  ) {
    query = query.concat(`&usedInModule=${filterReq.usedInModule}`);
  }

  if (
    filterReq.usedReference &&
    !IsStringNullEmptyOrUndefined(filterReq.usedReference)
  ) {
    query = query.concat(`&usedReference=${filterReq.usedReference}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.countries}/get-all?${query}`,
  );
};

export const APIUpdateStatus = async (
  req: CountryStateCityToggleChangeStatusReqEntity,
  id: string,
) => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.countries}/update-status/${id}`,
    req,
  );
};

export const APIFetchCountriesCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.countries}/get-country-csv`,
  );
};

export const APIGetAutoCompleteCity = async (
  reqBody: AutoCompleteCityReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.cities}/get-autoComplete-city`,
    reqBody,
  );
};

export const APIGetAutoCompleteAddress = async (
  reqBody: AutoCompleteAddressReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.mapbox}/get-autoComplete-address`,
    reqBody,
  );
};

export const APIGetCityIdByMapBoxId = async (
  mapBoxId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.cities}/get-cities-details-by-mapboxId/${mapBoxId}`,
  );
};

export const APIExportAddress = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.cities}/export-address`);
};

export const APIGetAddressMapboxDetails = async (
  reqBody: AddressMapboxDetailsReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.mapbox}/get-address-mapbox-details`,
    reqBody,
  );
};

export const APIValidatePincodeWithCity = async (
  reqBody: {
    cityId: number;
    pinCode: string;
  },
  config?: AxiosRequestConfig,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.GoogleUtilities}/validate-pincode-with-city`,
    reqBody,
    config,
  );
};

export const APIToUploadChunkRecords = async (
  formData: FormData,
  uuid: string,
  page: string,
  mimeType: string,
  options: {
    fileName: string;
    uploadId: string;
    totalChunks: string;
  },
) => {
  const instance = axios.create({
    headers: {
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,

      FileName: options.fileName,
      uploadid: options.uploadId,
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.jbUploader}/upload-chunk-files?uuid=${uuid}&page=${page}&mimeType=${mimeType}&total_chunks=${options.totalChunks}`,
    formData,
  );
};

export const APIUploadEditDrawingV2 = async (
  woId: string,
  data: { deletedIds: string[]; drawings: UploadedDrawingFileEntity[] },
) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionPlanning}/upload-edit-drawing-v2/${woId}`,
    data,
  );
};

export const APIToCreateDuplicateOrderById = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.order}/v1.0/create-duplicate-order?orderId=${orderId}`,
  );
};

export const APIWebAppHandoverPendingOrderDetails =
  async (): Promise<AxiosResponse> => {
    return await axios.get(
      `${APIURL}/${BaseEndpoints.RedRibbon}/get-handover-pending-order-details`,
    );
  };

export const APIToFetchLocationStatusDetail = async (
  status: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.RedRibbon}/get-location-history-status-details?status=${status}`,
  );
};

export const APIToRevertSolutionStatus = async (
  orderId: string,
  locations: { solutionId: string; solutionType: string }[] | [],
  selectedStatus: string,
) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.preWorkOrder}/revert-solution-status`,
    {
      orderId,
      locations,
      selectedStatus,
    },
  );
};

export const APISendAnalyticsExportEmail = async (payload: Object) => {
  return axios.post<APIResponseEntity>(
    `${APIURL}/${BaseEndpoints.analytics}/request-analtics-export`,
    payload,
  );
};
export const APIDownloadSubCategoryCataloguePDF = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.download}/dynamic-glass-catalogues/?subCategoryId=${id}`,
  );
};

export const APIUploadOfficeImages = async (
  formData: FormData,
  officeId: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.office}/upload-image/${officeId}`,
    formData,
  );
};

export const APIUploadOfficeMapImages = async (
  formData: FormData,
  officeId: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });

  return await instance.post(
    `${APIURL}/${BaseEndpoints.office}/upload-map-images/${officeId}`,
    formData,
  );
};

export const APIfetchOfficeImages = async (
  officId: string,
): Promise<AxiosResponse> => {
  return axios.get(
    `${APIURL}/${BaseEndpoints.office}/uploaded-images/${officId}`,
  );
};

export const APIDownloadCreditNote = async (id: string): Promise<AxiosResponse> => {
  let queryParams: string = `&id=${id}`;
  return await axios.get(`${APIURL}/${BaseEndpoints.creditNote}/download-credit-note?${queryParams}`);
};

export const APIToCreateAndFetchWOInvoiceDetails = async (
  workOrderDetails: GenerateInvoiceForWorkOrderReqEntity,
) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.eInvoice}/generate-invoice`,
    workOrderDetails,
  );
};

export const APIToCreateAndFetchWOInvoiceEWayBillDetails = async (
  workOrderDetails: GenerateEWayBillForWorkOrderInvoiceReqEntity,
) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.eInvoice}/generate-e-way-bill`,
    workOrderDetails,
  );
};

export const APIDownloadInvoice = async (
  id: string,
): Promise<AxiosResponse> => {
  let queryParams: string = `&id=${id}`;

  return await axios.get(
    `${APIURL}/${BaseEndpoints.eInvoice}/download-invoice?${queryParams}`,
  );
};

export const APIDownloadEWaybill = async (
  id: string,
  type: string,
): Promise<AxiosResponse> => {
  let queryParams: string = `&id=${id}`;

  if (type && !IsStringNullEmptyOrUndefined(type)) {
    queryParams = queryParams.concat(`&type=${type}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.eInvoice}/download-eWaybill?${queryParams}`,
  );
};

export const APIFetchAllInvoices = async (filterReq: any) => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.orderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.orderNumber)
  ) {
    query = query.concat(`&orderNumber=${filterReq.orderNumber}`);
  }

  if (
    filterReq.projectName &&
    !IsStringNullEmptyOrUndefined(filterReq.projectName)
  ) {
    query = query.concat(`&projectName=${filterReq.projectName}`);
  }

  if (filterReq.woNumber && !IsStringNullEmptyOrUndefined(filterReq.woNumber)) {
    query = query.concat(`&woNumber=${filterReq.woNumber}`);
  }

  if (filterReq.woType && filterReq.woType.length > 0) {
    query = query.concat(`&woType=${filterReq.woType.join(",")}`);
  }

  if (
    filterReq.salesHead &&
    !IsStringNullEmptyOrUndefined(filterReq.salesHead)
  ) {
    query = query.concat(`&salesHead=${filterReq.salesHead}`);
  }

  if (
    filterReq.officeName &&
    !IsStringNullEmptyOrUndefined(filterReq.officeName)
  ) {
    query = query.concat(`&officeName=${filterReq.officeName}`);
  }

  if (
    filterReq.transporterName &&
    !IsStringNullEmptyOrUndefined(filterReq.transporterName)
  ) {
    query = query.concat(`&transporterName=${filterReq.transporterName}`);
  }

  if (
    filterReq.city && typeof (Number) &&
    !IsNullOrUndefined(filterReq.city)
  ) {
    query = query.concat(`&city=${filterReq.city}`);
  }

  if (
    filterReq.state &&
    typeof Number &&
    !IsStringNullEmptyOrUndefined(filterReq.state)
  ) {
    query = query.concat(`&state=${filterReq.state}`);
  }

  if (
    filterReq.workOrderStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.workOrderStatus)
  ) {
    query = query.concat(`&workOrderStatus=${filterReq.workOrderStatus}`);
  }

  if (
    filterReq.eWayBillNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.eWayBillNumber)
  ) {
    query = query.concat(`&eWayBillNumber=${filterReq.eWayBillNumber}`);
  }

  if (
    filterReq.policyNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.policyNumber)
  ) {
    query = query.concat(`&policyNumber=${filterReq.policyNumber}`);
  }

  if (
    filterReq.invoiceNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.invoiceNumber)
  ) {
    query = query.concat(`&invoiceNumber=${filterReq.invoiceNumber}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&invoiceDateFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&invoiceDateToDate=${filterReq.createToDate}`);
  }

  if (
    filterReq.eWayStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.eWayStatus)
  ) {
    query = query.concat(`&eWayStatus=${filterReq.eWayStatus}`);
  }

  if (
    filterReq.irnStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.irnStatus)
  ) {
    query = query.concat(`&irnStatus=${filterReq.irnStatus}`);
  }

  if (
    filterReq.invoiceNo &&
    !IsStringNullEmptyOrUndefined(filterReq.invoiceNo)
  ) {
    query = query.concat(`&invoiceNo=${filterReq.invoiceNo}`);
  }

  if (filterReq.irn && !IsStringNullEmptyOrUndefined(filterReq.irn)) {
    query = query.concat(`&irn=${filterReq.irn}`);
  }

  return await axios.get(
    `${APIURL}/${BaseEndpoints.eInvoice}/get-all-invoice?${query}`,
  );
};

export const APIUpdateDeliveryDetailV2 = async (obj: DeliveryAdviceDetailV2ReqEntity) => {
  return await axios.post(`${APIURL}/${BaseEndpoints.deliveryAdvice}/v2.0/update-delivery-detail`, obj);
}

export const APIGetWOPackingCounts = async (
  workOrderIds: string[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/v2.0/get-wo-packing-counts`,
    { workOrderIds },
  );
};

export const APIGetWOSolutionPackingDetails = async (
  workOrderId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/v2.0/get-wo-solution-packing-details`,
    { workOrderId },
  );
};

export const APIToFetchOfficeDDLForMDA = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/get-office-ddl-for-mda`,
  );
};

export const APIToAddDriverDetailsInTransporter = async (
  data: AddDriverDetailsInTransporterContactDetailReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.transporterSetting}/add-driver-details-in-transporter`,
    data,
  );
};

export const APIToUpdateDriverDetailsInTransporter = async (
  data: UpdateDriverMobileNumberInTransporterReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.transporterSetting}/update-driver-details-in-transporter`,
    data,
  );
};

export const APIGenerateInvoice = async (
  obj: GenerateInvoiceForWorkOrderReqV2Entity,
  handlers: {
    onStart?: (data: any) => void;
    onProgress?: (data: any) => void;
    onErrorEvent?: (data: any) => void;
    onCompleted?: (data: any) => void;
    onHttpError?: (message: string) => void;
  },
): Promise<void> => {
  const response = await fetch(
    `${APIURL}/${BaseEndpoints.eInvoice}/generate-invoice`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
        authorization: `Bearer ${getLocalStorageItem(
          StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
        )}`,
      },
      body: JSON.stringify(obj),
    },
  );

  if (!response.ok) {
    let errorMessage = `HTTP error: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.message || errorJson?.errorMsg || errorMessage;
    } catch (error) { }

    if (handlers.onHttpError) {
      handlers.onHttpError(errorMessage);
    }
    return;
  }

  if (!response.body) {
    if (handlers.onHttpError) {
      handlers.onHttpError("Response body not found");
    }
    return;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  const processEventBlock = (block: string) => {
    const lines = block.split("\n");
    let eventType = "";
    let dataString = "";

    for (const line of lines) {
      if (line.startsWith("event:")) {
        eventType = line.replace("event:", "").trim();
      } else if (line.startsWith("data:")) {
        dataString += line.replace("data:", "").trim();
      }
    }

    if (!eventType || !dataString) {
      return;
    }

    let parsedData: any;

    try {
      parsedData = JSON.parse(dataString);
    } catch (error) {
      console.error("Failed to parse event data", dataString);
      return;
    }

    switch (eventType) {
      case InvoiceSendEventEnumEntity.START:
        if (handlers.onStart) {
          handlers.onStart(parsedData);
        }
        break;

      case InvoiceSendEventEnumEntity.PROGRESS:
        if (handlers.onProgress) {
          handlers.onProgress(parsedData);
        }
        break;

      case InvoiceSendEventEnumEntity.ERROR:
        if (handlers.onErrorEvent) {
          handlers.onErrorEvent(parsedData);
        }
        break;

      case InvoiceSendEventEnumEntity.COMPLETED:
        if (handlers.onCompleted) {
          handlers.onCompleted(parsedData);
        }
        break;

      default:
        console.warn("Unknown event type", eventType);
        break;
    }
  };

  try {
    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      buffer += decoder.decode(value, { stream: true });

      const eventBlocks = buffer.split("\n\n");
      buffer = eventBlocks.pop() || "";

      for (const block of eventBlocks) {
        processEventBlock(block);
      }
    }

    if (buffer.trim() !== "") {
      processEventBlock(buffer);
    }
  } catch (error: any) {
    if (handlers.onHttpError) {
      handlers.onHttpError(error?.message || "Stream reading failed");
    }
  } finally {
    reader.releaseLock();
  }
};

export const APIToUpdateInvoiceAndEWayDetailForDA = async (obj: {
  uuid: string;
  workOrderIds: string[] | [];
}) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/v2.0/update-invoice-and-eWay-detail-in-da`,
    obj,
  );
};
export const APIExportInvoiceDetailV2 = async () => {
  return await axios.get(`${APIURL}/${BaseEndpoints.eInvoice}/v2/export-invoice-details`);
};

export const APIExportCreditNoteDetails = async () => {
  return await axios.get(`${APIURL}/${BaseEndpoints.creditNote}/export-credit-note-details`);
};

export const APIFetchInvoiceTermsCsvDetails = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.invoiceTearmsAndConditionsSettings}/get-invoiceterms-csv`,
  );
};

export const APIToDeleteWorkOrderFromDA = async (
  uuid: string,
  woId: string,
) => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/v2.0/remove-work-order-from-da`,
    {
      uuid,
      woId,
    },
  );
};

export const APIExportInvoiceTermsConditionDetails = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.invoiceTearmsAndConditionsSettings}/export-invoicetermscondition`,
  );
};

export const APIExportTransporter = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.transporterSetting}/export-transporter`,
  );
};

export const APIExportInsuranceAgents = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.insuranceAgent}/export-insuranceAgent`,
  );
};

export const APIExportConsumedAmountByInvoiceDetail = async (id: string) => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/export-consumed-amount-by-invoice-detail/${id}`,
  );
};

export const APIExportInsurancePolicy = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.insuranceSettings}/export-insurancePolicy`,
  );
};

export const APIExportInvoiceDetail = async () => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.eInvoice}/export-invoice-details`,
  );
};

export const APIGetAddressProviderDetails = async (
  reqBody: {
    searchText: string;
    stateId?: number | null;
    countryId?: number | null;
  },
  config?: AxiosRequestConfig,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.addressesProvider}/fetch-address-provider-details`,
    reqBody,
    config,
  );
};

export const APIExportOfficeCoverageList = async (
  officeId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/export-office-coverage-list/${officeId}`,
  );
};

export const APIGenerateMDAForTheJBEmpOffice = async (
  uuid: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.deliveryAdvice}/v2.0/submit-jb-emp-mda`,
    {
      uuid,
    },
  );
};

export const APIupdateOrderStatusToInActive = async (
  orderIds: string[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/order-utility/update-order-status-inActive`,
    {
      orderIds: orderIds,
    },
  );
};

export const APIGetWorkOrderDetailsV2 = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/get-work-order-details`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIFetchWorkOrderTrackerFilter = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-work-order-tracker-filter`,
    filterReq,
  );
};

export const APIFetchWorkOrderTrackerDetail = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-work-order-tracker-detail`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIExportWorkOrderTracker = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/export-work-order-tracker`,
    filterReq,
  );
};

export const APIFetchWorkOrderTrackerLocationDetail = async (
  workOrderId: string,
  isAtIppWorkCenter: boolean = false,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-work-order-tracker-location-detail/${workOrderId}`,
    { params: isAtIppWorkCenter ? { isAtIppWorkCenter: true } : {} },
  );
};

export const APIFetchWorkOrderHoldReasons = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-work-order-hold-reasons`,
  );
};

export const APIUpdateWorkOrderProductionFloorHold = async (
  workOrderId: string,
  reasonId: string,
  status: string,
  solutionId?: string,
  solutionType?: string,
  holdDueToWorkCenterId?: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/update-work-order-production-floor-hold`,
    solutionId && solutionType
      ? { workOrderId, reasonId, status, solutionId, solutionType, holdDueToWorkCenterId }
      : { workOrderId, reasonId, status, holdDueToWorkCenterId },
  );
};

/* ---------- location sales hold (WO Tracker) ---------- */

export const APIFetchSalesHoldReasons = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-sales-hold-reasons`,
  );
};

export const APIApplyLocationSalesHold = async (
  workOrderId: string,
  locations: { solutionId: string; solutionType: string; solutionNo?: number }[],
  reasonId: string,
  remark: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/apply-location-sales-hold`,
    { workOrderId, locations, reasonId, remark },
  );
};

export const APIReleaseLocationSalesHold = async (
  workOrderId: string,
  locations: { solutionId: string; solutionType: string; solutionNo?: number }[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/release-location-sales-hold`,
    { workOrderId, locations },
  );
};

export const APIFetchLocationHoldHistory = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-location-hold-history/${workOrderId}/${solutionId}/${encodeURIComponent(solutionType)}`,
  );
};

export const APIFetchLocationTrackerFilter = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-location-tracker-filter`,
    filterReq,
  );
};

export const APIFetchProjectTrackerFilter = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/fetch-project-tracker-filter`,
    filterReq,
  );
};

export const APIFetchProjectTrackerDetail = async (
  filterReq: ProjectTrackerDetailReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/fetch-project-tracker-detail`,
    filterReq,
  );
};

export const APIFetchProjectTrackerLocationDetail = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.projectTracker}/fetch-project-tracker-location-detail/${orderId}`,
  );
};

export const APICreateProjectTrackerDocumentFlag = async (
  reqBody: ProjectTrackerDocumentFlagReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/create-project-tracker-document-flag`,
    reqBody,
  );
};

export const APIFetchProjectTrackerDocumentFlags = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.projectTracker}/fetch-project-tracker-document-flags/${orderId}`,
  );
};

export const APICloseProjectTrackerDocumentFlag = async (
  reqBody: ProjectTrackerDocumentFlagCloseReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/close-project-tracker-document-flag`,
    reqBody,
  );
};

export const APIFetchProjectTrackerFlagList = async (
  reqBody: ProjectTrackerFlagListReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/fetch-project-tracker-flag-list`,
    reqBody,
  );
};

export const APIExportProjectTrackerFlags = async (
  reqBody: ProjectTrackerFlagExportReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/export-project-tracker-flags`,
    reqBody,
  );
};

export const APIReplyProjectTrackerDocumentFlag = async (
  reqBody: ProjectTrackerDocumentFlagReplyReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/reply-project-tracker-document-flag`,
    reqBody,
  );
};

export const APICreateProjectTrackerNextAction = async (
  reqBody: ProjectTrackerNextActionReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/create-project-tracker-next-action`,
    reqBody,
  );
};

export const APIFetchProjectTrackerNextActions = async (
  orderId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.projectTracker}/fetch-project-tracker-next-actions/${orderId}`,
  );
};

export const APIExportProjectTracker = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.projectTracker}/export-project-tracker`,
    filterReq,
  );
};

export const APIFetchLocationTrackerDetail = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-location-tracker-detail`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIFetchLocationTrackerSolutionDetail = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-location-tracker-solution-detail`,
    { workOrderId, solutionId, solutionType },
  );
};

export const APIUpdateLocationTrackerPackageCounts = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
  packageCounts: { panelCount: number; boxCount: number; glassCount: number; reason: string },
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/update-location-tracker-package-counts`,
    { workOrderId, solutionId, solutionType, ...packageCounts },
  );
};

export const APIMoveSolutionWorkflowStep = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
  targetStepCode: string,
  fromStepCode: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/move-solution-workflow-step`,
    { workOrderId, solutionId, solutionType, targetStepCode, fromStepCode },
  );
};

export const APIRevertSolutionWorkflowStep = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
  targetStepCodes: string[],
  note: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/revert-solution-workflow-step`,
    { workOrderId, solutionId, solutionType, targetStepCodes, note },
  );
};

export const APICreatePaintJob = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
  items: { part: string; qty: number; paint: string; paintColor: string; remarks: string }[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/create-paint-job`,
    { workOrderId, solutionId, solutionType, items },
  );
};

export const APIFetchPaintJobFilter = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/fetch-paint-job-filter`,
    filterReq,
  );
};

export const APIFetchPaintJobDetail = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/fetch-paint-job-detail`,
    { ...filterReq, pageNumber: filterReq.pageNumber + 1 },
  );
};

export const APIApprovePaintJob = async (
  paintJobId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/approve-paint-job`,
    { paintJobId },
  );
};

export const APIRejectPaintJob = async (
  paintJobId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/reject-paint-job`,
    { paintJobId },
  );
};

export const APIDownloadPaintJobSlip = async (
  paintJobId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/download-paint-job-slip`,
    { paintJobId },
  );
};


export const APISavePaintJobDetail = async (
  paintJobId: string,
  key: string,
  value: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/save-promise-date-writeup-sop`,
    { paintJobId, key, value },
  );
};

export const APIUpdatePaintJobStatus = async (
  paintJobId: string,
  holdStatus: string = '',
  reasonId: string = '',
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/update-paint-job-status`,
    { paintJobId, reasonId, holdStatus },
  );
};

export const APIExportPaintJob = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.paintJobTracking}/export-paint-job`,
    filterReq,
  );
};

export const APIExportLocationTracker = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/export-location-tracker`,
    filterReq,
  );
};

export const APIFetchLocationTrackerWcPerformance = async (
  filterReq: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-location-tracker-wc-performance`,
    filterReq,
  );
};

export const APIAddWorkOrderProductionPromiseDate = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
  promiseDate: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/add-work-order-production-promise-date`,
    { workOrderId, solutionId, solutionType, promiseDate },
  );
};

export const APIAddWorkOrderProductionNote = async (
  workOrderId: string,
  solutionId: string,
  solutionType: string,
  note: string,
  attachments: File[],
): Promise<AxiosResponse> => {
  const data = new FormData();
  data.append("workOrderId", workOrderId);
  data.append("solutionId", solutionId);
  data.append("solutionType", solutionType);
  data.append("note", note);
  attachments.forEach((file) => data.append("attachments", file));

  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
    // the shared error interceptor does not run on this instance, so a 4xx
    // must resolve here for the caller to show the API message
    validateStatus: () => true,
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/add-work-order-production-note`,
    data,
  );
};

export const APICreateWorkOrderPromiseDateRequest = async (
  workOrderId: string,
  orderReferenceNumber: string,
  requestedDate: string,
  requestedNote: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/create-work-order-promise-date-request`,
    { workOrderId, orderReferenceNumber, requestedDate, requestedNote },
  );
};

export const APIUpdateWorkOrderPromiseDateRequestStatus = async (
  workOrderId: string,
  promiseDateRequestId: string,
  status: string,
  finalPromiseDate: string = "",
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/update-work-order-promise-date-request-status`,
    { workOrderId, promiseDateRequestId, status, finalPromiseDate },
  );
};

export const APIDownloadCSSticker = async (
  woNumber: string,
  workOrderId: string,
  solutionId: string = "",
  solutionType: string = "",
): Promise<AxiosResponse> => {
  const reqBody: DownloadCSStickerReqEntity = { woNumber, workOrderId };

  // sent together or not at all - the backend rejects one without the other
  if (solutionId && solutionType) {
    reqBody.solutionId = solutionId;
    reqBody.solutionType = solutionType;
  }

  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/download-CS-sticker`,
    reqBody,
  );
};

export const APIDownloadWaltzPackingList = async (
  workOrderId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/download-waltz-packing-list`,
    { workOrderId },
  );
};

export const APIDownloadBOMPDF = async (
  orderNumber: string,
  solutionId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.productionTracker}/download-bom-pdf`,
    { orderNumber, solutionId },
  );
};


export const APIUpdateWOStatusFromHoldStage = async (
  woId: string,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/update-wo-status-from-hold-stage`,
    { woId },
  );
};

export const APIToRetryCreditNote = async (woId: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.eInvoice}/retry-credit-note`, {
    woId
  });
}


export const APIToGenerateErrorWorkOrder = async (data: FormData, errorId: string): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN
      )}`,
    },
  });
  return await instance.post(`${APIURL}/${BaseEndpoints.observationError}/v2/generate-error-work-order/${errorId}`, data);
};

export const APIToSaveProductionTeamDetails = async (payload: ObservationSaveProductionTeamDetailsEntity, errorId: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.observationError}/v2/save-production-team-details/${errorId}`, payload);
};

export const APIRejectApprovalWO = async (data: { comment: string, errorId: string }): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.observationError}/v2/reject-approval-wo`, data);
}

export const APIToSendOTPForTheConfirmationWO = async (data: { errorId: string }): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.observationError}/v2/send-otp-for-the-confirmation-wo`, data);
}


export const APIToVerifyOTPAndGenerateExOrErWo = async (data: { errorId: string; otp: string }): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.observationError}/v2/verify-otp-and-generate-wo`, data);
}

export const APIToDownloadProductionErrorReportPDF = async (errorId: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.observationError}/v2/download-error-report-pdf/${errorId}`);
}

export const APIFetchAllCreditNotes = async (filterReq: any) => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  if (
    filterReq.sortColumn &&
    !IsStringNullEmptyOrUndefined(filterReq.sortColumn)
  ) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (
    filterReq.sortOrder &&
    !IsStringNullEmptyOrUndefined(filterReq.sortOrder)
  ) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (
    filterReq.orderNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.orderNumber)
  ) {
    query = query.concat(`&orderNumber=${filterReq.orderNumber}`);
  }

  if (
    filterReq.projectName &&
    !IsStringNullEmptyOrUndefined(filterReq.projectName)
  ) {
    query = query.concat(`&projectName=${filterReq.projectName}`);
  }

  if (
    filterReq.woNumber &&
    !IsStringNullEmptyOrUndefined(filterReq.woNumber)
  ) {
    query = query.concat(`&woNumber=${filterReq.woNumber}`);
  }

  if (filterReq.woType && filterReq.woType.length > 0) {
    query = query.concat(`&woType=${filterReq.woType.join(",")}`);
  }

  if (
    filterReq.salesHead &&
    !IsStringNullEmptyOrUndefined(filterReq.salesHead)
  ) {
    query = query.concat(`&salesHead=${filterReq.salesHead}`);
  }

  if (
    filterReq.officeName &&
    !IsStringNullEmptyOrUndefined(filterReq.officeName)
  ) {
    query = query.concat(`&officeName=${filterReq.officeName}`);
  }

  if (
    filterReq.city && typeof (Number) &&
    !IsNullOrUndefined(filterReq.city)
  ) {
    query = query.concat(`&city=${filterReq.city}`);
  }

  if (
    filterReq.state && typeof (Number) &&
    !IsStringNullEmptyOrUndefined(filterReq.state)
  ) {
    query = query.concat(`&state=${filterReq.state}`);
  }

  if (
    filterReq.workOrderStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.workOrderStatus)
  ) {
    query = query.concat(`&workOrderStatus=${filterReq.workOrderStatus}`);
  }

  if (
    filterReq.createFromDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createFromDate)
  ) {
    query = query.concat(`&creditNoteFromDate=${filterReq.createFromDate}`);
  }

  if (
    filterReq.createToDate &&
    !IsStringNullEmptyOrUndefined(filterReq.createToDate)
  ) {
    query = query.concat(`&creditNoteToDate=${filterReq.createToDate}`);
  }

  if (
    filterReq.cdnStatus &&
    !IsStringNullEmptyOrUndefined(filterReq.cdnStatus)
  ) {
    query = query.concat(`&cdnStatus=${filterReq.cdnStatus}`);
  }

  if (
    filterReq.creditNoteNo &&
    !IsStringNullEmptyOrUndefined(filterReq.creditNoteNo)
  ) {
    query = query.concat(`&creditNoteNo=${filterReq.creditNoteNo}`);
  }

  if (
    filterReq.cdn && !IsStringNullEmptyOrUndefined(filterReq.cdn)
  ) {
    query = query.concat(`&cdn=${filterReq.cdn}`);
  }

  return await axios.get(`${APIURL}/${BaseEndpoints.creditNote}/get-all-credit-note?${query}`)
}

export const APIFetchCreditNoteErrors = async (workOrderId: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.creditNote}/get-credit-note-errors/${workOrderId}`);
};

export const APIToFetchInvoiceDetail = async (
  invoiceId: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.eInvoice}/get-invoice-details-by-id/${invoiceId}`,
  );
};

export const APIToCancelInvoiceAndEWayBill = async (
  obj: any,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.eInvoice}/cancel-invoice-and-e-way-bill`,
    obj,
  );
};

export const APIDownloadHNSCodeGSTMapping = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.HsnCodeGstMapping}/download-hsn-code-gst-mapping/${id}`,
  );
};

export const APIToExportOrderStatusHistory = async (orderId: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.order}/download-order-status-history/${orderId}`);
}

export const APIToImpersonate = async (userid: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.Impersonate}/${userid}`)
}

export const APIToStopImpersonate = async (sessionId: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.Impersonate}/stop`, { sessionId })
}

export const APIToGetSelectedRoleUsersDDL = async (financialYearId?: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-selected-role-users-ddl`, {
    params: {
      financialYearId: financialYearId || undefined,
    },
  });
};

export const APIToGetFinancialYearDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.eInvoice}/get-financial-year-ddl`);
};

export const APIToCreateUserWiseVision = async (
  data: FormData,
  orderId: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.user}/create-user-wise-vision`,
    data,
  );
};

export const APIToUpdateUserWiseVision = async (
  data: FormData,
  id: string,
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.put(
    `${APIURL}/${BaseEndpoints.user}/update-user-wise-vision/${id}`,
    data,
  );
};

export const APIDeleteUserWiseVision = async (data: {
  userId: string;
  financialYearId: string;
}): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.user}/delete-user-wise-vision`,
    { data },
  );
};


export const APIToGetViewRecordsUserWiseVision = async (id: string) => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-user-view-vision/${id}`);
}

export const APIToGetAllVision = async (filterReq: any,): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: { Authorization: `Bearer ${getLocalStorageItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN,)}`, },
  });

  return await instance.get(
    `${APIURL}/${BaseEndpoints.user}/get-all-vision`,
    {
      params: {
        officeIds: filterReq.officeIds || undefined,
        userIds: filterReq.userIds || undefined,
        financialYearIds: filterReq.financialYearIds || undefined,
        userName: filterReq.userName || undefined,
        officeName: filterReq.officeName || undefined,
        roleName: filterReq.roleName || undefined,
        pageSize: filterReq.pageSize,
        pageNumber: filterReq.pageNumber,
        sortColumn: filterReq.sortColumn,
        sortOrder: filterReq.sortOrder,
      },
    },
  );
};

export const APIToExportUserVision = async (data: {
  financialYear: string;
  roleCategory: string;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.user}/export-user-wise-vision`,
    data,
  );
};

export const APIToExportSingleUserVision = async (data: {
  financialYear: string;
  roleCategory: string;
  userId: string;
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.user}/export-single-user-wise-vision`,
    data,
  );
};

export const APIGetOfficeUserDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-office-user-ddl`
  );
};

export const APIToCreateTBSItem = async (
  formData: FormData
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN
      )}`,
    },
  });

  return instance.post(
    `${APIURL}/${BaseEndpoints.TBS}/upload`,
    formData
  );
};

export const APISaveModelSelection = async (
  tbsId: string,
  reqBody: SaveModelSelectionReqEntity
): Promise<AxiosResponse> => {
  return axios.post(
    `${APIURL}/${BaseEndpoints.TBS}/model-section/${tbsId}`, reqBody
  )
};

export const APIGetUserReassignDDL = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.user}/get-user-for-reassign-ddl`,
    {
      params: {
        id
      }
    }
  );
};

export const APIFetchReassignmenthistoryCsvDetails = async (): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.user}/export-re-assigned-history`);
};

export const APIReassignProjectsToSalesHead = async (
  id: string,
  reqBody: {
    newSalesHeadId: string;
    orderIds: string[];
  }
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.user}/reassign-projects-to-sales-head/${id}`,
    reqBody
  );
};

export const APIToVerifyOfficeSMAndTechnician = async (orderId: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.order}/v1.0/verify-order-for-sm-and-technician/${orderId}`)
}

export const APIToUploadProductionDrawing = async (
  data: FormData,
  workOrderId: string,
  isReplace: boolean = false
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return await instance.post(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/upload-production-drawing-to-marked-as-in-production/${workOrderId}${isReplace ? "?isReplace=true" : ""}`,
    data,
  );
};


export const APIToFetchDraftProductionDrawing = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.workOrder}/v2.0/fetch-draft-production-drawing-detail/${id}`);
}

export const APIToFetchProductionDrawingById = async (id: string): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/fetch-production-drawing-by-id/${id}`,
  );
};

export const APIToSubmitProductionDrawingMapping = async (data: {
  productionDrawingId: string;
  mapping: {
    singlePDFPagesId: string;
    notes: string;
    locations: {
      solutionId: string;
      solutionType: string;
    }[];
  }[];
}): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/submit-production-drawing-mapping`,
    data,
  );
};

export const APIToPublishProductionDrawing = async (productionDrawingId: string): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/publish-production-drawing`,
    { productionDrawingId },
  );
}

export const APIMarkWorkOrderAsInProduction = async (workOrderId: string): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/marked-work-order-as-in-production/${workOrderId}`,
    {},
  );
}
export const APIToGetAllOfficeAddresses = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/get-all-office-addresses`,
  );
}

export const APItoGetAllOfficeRegions = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.office}/get-all-office-regions`,
  );
}

export const APIToGetGeolocationDetails = async (reqBody: GeolocationDetailsReqEntity): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.addressesProvider}/v1.0/get-geolocation-details?latitude=${reqBody.latitude}&longitude=${reqBody.longitude}`
  );
}

export const APIExportDraftWOs = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.DraftWorkOrder}/export-excel`);
};

export const APISingleExportDraftWO = async (orderReferenceNumber: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.DraftWorkOrder}/export-single-excel/${orderReferenceNumber}`);
};

export const APIDraftOrderListing = async (
  reqBody: FetchDraftWorkOrdersReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.DraftWorkOrder}/get-all`,
    reqBody,
  );
};

export const APIFetchWorkOrderDetails = async (orderReferenceNumber: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.DraftWorkOrder}/get-draft-WO-details/${orderReferenceNumber}`);
};
export const APIToGetProductionTeam = async (
  data: PaginateReqEntity
): Promise<AxiosResponse> => {

  const reqBody: PaginateReqEntity = {
    ...data,
    pageNumber: data.pageNumber + 1
  };

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ErrorProductionTeam}/`,
    reqBody
  );
};

export const APIGetCategoryDDL = async (tbsType: TBSTypeEnumEntity): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/category-ddl`, {
    params: {
      tbsType,
    },
  });
};

export const APIToGetTBSCategories = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.TBSCategory}/get-all`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateTBSCategory = async (
  reqObj: CreateUpdateTBSCategory
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.TBSCategory}/create-update`,
    reqObj,
  );
};

export const APIToUpdateTBSCategory = async (
  id: string,
  reqObj: CreateUpdateTBSCategory,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.TBSCategory}/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteTBSCategory = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.TBSCategory}/delete/${id}`,
  );
};

export const APIGetTBSDetails = async (tbsId: string): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/get-data/${tbsId}`);
}

export const APISaveDispatchDetails = async (
  tbsId: string,
  reqBody: FormData
): Promise<AxiosResponse> => {
  const instance = axios.create({
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN
      )}`,
    },
  });
  return instance.post(
    `${APIURL}/${BaseEndpoints.TBS}/dispatch-details/${tbsId}`,
    reqBody
  );
};
export const APIUserResignation = async (id: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.user}/user-resignation/${id}`);
};

export const APIToGetDepartmentSupplyDetail = async (
  data: PaginateReqEntity,
  type: string
): Promise<AxiosResponse> => {

  const reqBody: PaginateReqEntity = {
    ...data,
    pageNumber: data.pageNumber + 1
  };

  return await axios.post(
    `${APIURL}/${BaseEndpoints.DepartmentSupply}/get-all/${type}`,
    reqBody
  );
};

export const APIToDeleteProductionTeam = async (id: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.ErrorProductionTeam}/delete/${id}`)
}
export const APIToDeleteDepartmentSupply = async (id: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.DepartmentSupply}/delete/${id}`)
}

export const APIToCreateOrUpdateProductionTeam = async (
  data: any,
  id?: string
): Promise<AxiosResponse> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ErrorProductionTeam}/create-or-update${id ? `?id=${id}` : ""}`,
    data
  );
};

export const APIToCreateOrUpdateDepartmentSupply = async (
  data: any,
  id?: string,
): Promise<AxiosResponse> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.DepartmentSupply}/create-or-update/${id ? `?id=${id}` : ""}`,
    data
  );
};

export const APIToExportProductionTeam = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.ErrorProductionTeam}/export-csv`);
}

export const APIToExportDepartmentSupply = async (type: string): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.DepartmentSupply}/export-csv/${type}`);
}

export const APIToProductionTeamDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.ErrorProductionTeam}/ddl`)
}

export const APIToDepartmentSupplyDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APIURL}/${BaseEndpoints.DepartmentSupply}/ddl`)
}

export const APIToStoreTrustSealUserDetail = async (orderId: string): Promise<AxiosResponse> => {
  return await axios.post(`${APIURL}/${BaseEndpoints.trustSeal}/store-scan-info`, { orderId })
}

export const APIToFetchTrustSeal = async (data: FilterTrustSealDetailEntity) => {
  return await axios.post(`${APIURL}/${BaseEndpoints.trustSeal}/get-all-trust-seal-user`, data)
}

export const APIToExportTrustSeal = async () => {
  return await axios.get(`${APIURL}/${BaseEndpoints.trustSeal}/export-trust-seal-user`);
}

export const APIToSendWhatsappOTPForTheTrustSeal = async ({ mobileNo, trustSealUserId }: { trustSealUserId: string, mobileNo: string }) => {
  return await axios.post(`${APIURL}/${BaseEndpoints.trustSeal}/send-otp`, {
    trustSealUserId,
    mobileNo
  })
}

export const APIToVerifyTrustSealWhatsappOTP = async ({ trustSealUserId, OTP }: { trustSealUserId: string, OTP: string }) => {
  return await axios.post(`${APIURL}/${BaseEndpoints.trustSeal}/verify-otp`, { trustSealUserId, otp: OTP })
}

export const APIGetTBSOrderDetailsDDl = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/get-tbs-order-details`);
}

export const APISaveAssignLocations = async (reqBody: SaveAssignLocationsReqEntity): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/location-details`, reqBody);
}

export const APIForVerifyTbs = async (reqBody: VerificationReqEntity): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/verify-tbs`, reqBody);
}

export const APIGenerateTbsNo = async (id: string): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/generate-tbsNo`, { tbsId: id });
}

export const APIIssueMaterial = async (reqBody: IssueMaterialReq): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/issue-material`, reqBody);
}

export const APIGetTbsOrderSolution = async (id: string): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/get-tbs-order-solution-details/${id}`);
}

export const APIGetTBSStats = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/stats`);
}

export const APIGetAllTBSData = async (reqBody: SendForTBSFilterReq): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/`, {
    ...reqBody,
    pageNumber: reqBody.pageNumber + 1,
  });
}

export const APIGetTBSOfficeDDL = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/getOfficeDDL`);
}

export const APIGetTbsStoreList = async (reqBody: TBSStoreFilterReq): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/store-listing-data`, {
    ...reqBody,
    pageNumber: reqBody.pageNumber + 1,
  });
}

export const APIExportSendTBSData = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/export`);
}

export const APIGetTbsDDl = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/office-user-ddl`)
}

export const APIExportTbsStoreItem = async (): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/export-tbs-store`);
}

export const APIGetHandleFabricationCodes = async (tbsId: string): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/handle-fabrication-codes/${tbsId}`);
}

export const APISaveHandleFabricationCodes = async (reqBody: SaveHandleFabricationCodesReq): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/handle-fabrication-codes`, reqBody);
}

/** Uploads the photos the receiver picked (verify form / return after receipt) and returns their urls. */
export const APIUploadReceiverImages = async (tbsId: string, files: File[]): Promise<AxiosResponse> => {
  const formData = new FormData();
  files.forEach((file) => formData.append("images", file));
  // its own instance like every other multipart upload here: the shared axios one forces "application/json" on every request
  // (request interceptor), which turns the photos into JSON and the server then finds no file
  const instance = axios.create({
    headers: {
      "content-type": "multipart/form-data",
      "Custom-Multipart-Header": "true",
      Authorization: `Bearer ${getLocalStorageItem(
        StorageKeyEnum.JB_GLASS_AUTH_TOKEN,
      )}`,
    },
  });
  return instance.post(`${APIURL}/${BaseEndpoints.TBS}/upload-receiver-images/${tbsId}`, formData);
}

export const APIReturnExtraItems = async (reqBody: ReturnExtraItemsReq): Promise<AxiosResponse> => {
  return axios.post(`${APIURL}/${BaseEndpoints.TBS}/return-extra-items`, reqBody);
}

export const APIGetTBSSticker = async (tbsId: string): Promise<AxiosResponse> => {
  return axios.get(`${APIURL}/${BaseEndpoints.TBS}/tbsSticker/${tbsId}`);
}
export const APIHSNWiseExportInvoice = async (
  reqObj: { startDate: string | null; endDate: string | null },
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.eInvoice}/invoice-wise-HSN-export`,
    reqObj,
  );
};

export const APIHSNWiseExportCreditNote = async (
  reqObj: { startDate: string | null; endDate: string | null },
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.creditNote}/credit-note-wise-HSN-export`,
    reqObj,
  );
};

export const APIToGetDepartmentMaster = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/department`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateDepartmentMaster = async (
  reqObj: CreateUpdateDepartmentMaster
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/department/create-update`,
    reqObj,
  );
};

export const APIToUpdateDepartmentMaster = async (
  id: string,
  reqObj: CreateUpdateDepartmentMaster,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/department/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteDepartmentMaster = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/department/delete/${id}`,
  );
};

export const APIToExportDepartmentMaster = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/department/export-csv`);
};

export const APIToGetWorkOrderHoldReason = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-order-hold-reason`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateWorkOrderHoldReason = async (
  reqObj: CreateUpdateWorkOrderHoldReason
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-order-hold-reason/create-update`,
    reqObj,
  );
};

export const APIToUpdateWorkOrderHoldReason = async (
  id: string,
  reqObj: CreateUpdateWorkOrderHoldReason,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-order-hold-reason/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteWorkOrderHoldReason = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-order-hold-reason/delete/${id}`,
  );
};

export const APIToExportWorkOrderHoldReason = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-order-hold-reason/export-csv`);
};

export const APIToGetSalesHeadHoldReason = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/sales-head-hold-reason`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateSalesHeadHoldReason = async (
  reqObj: CreateUpdateSalesHeadHoldReason
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/sales-head-hold-reason/create-update`,
    reqObj,
  );
};

export const APIToUpdateSalesHeadHoldReason = async (
  id: string,
  reqObj: CreateUpdateSalesHeadHoldReason,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/sales-head-hold-reason/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteSalesHeadHoldReason = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/sales-head-hold-reason/delete/${id}`,
  );
};

export const APIToExportSalesHeadHoldReason = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/sales-head-hold-reason/export-csv`);
};

export const APIToGetMasterTrack = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/master-tracker`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateMasterTrack = async (
  reqObj: CreateUpdateMasterTrack
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/master-tracker/create-update`,
    reqObj,
  );
};


export const APIToUpdateMasterTrack = async (
  id: string,
  reqObj: CreateUpdateMasterTrack,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/master-tracker/create-update?id=${id}`,
    reqObj,
  );
};


export const APIToDeleteMasterTrack = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/master-tracker/delete/${id}`,
  );
};

export const APIToExportMasterTrack = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/master-tracker/export-csv`);
};

export const APIToGetWorkCenter = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-center`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateWorkCenter = async (
  reqObj: CreateUpdateWorkCenter
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-center/create-update`,
    reqObj,
  );
};

export const APIToUpdateWorkCenter = async (
  id: string,
  reqObj: CreateUpdateWorkCenter,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-center/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteWorkCenter = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-center/delete/${id}`,
  );
};

export const APIToExportWorkCenter = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-center/export`);
};

export const APIToGetWorkCenterDDL = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-center/department-master-ddl`);
};

export const APIToGetWorkStation = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateWorkStation = async (
  reqObj: CreateUpdateWorkStation
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/create-update`,
    reqObj,
  );
};

export const APIToUpdateWorkStation = async (
  id: string,
  reqObj: CreateUpdateWorkStation,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteWorkStation = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/delete/${id}`,
  );
};

export const APIToExportWorkStation = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/export-csv`);
};

export const APIToGetWorkStationDDL = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/work-center-ddl`);
};

export const APIGetWorkCenterStationDDL = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/ddl`);
};

export const APIUserWorkStationMapping = async (
  reqObj: UserWorkStationMappingReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/user-workstation-mapping`,
    reqObj,
  );
};

export const APIGetUserWorkStationMapping = async (
  userId: string
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/get-user-workstation-mapping?id=${userId}`);
};

export const APIToGetNamedTrack = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {

  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/name-tracker`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateNamedTrack = async (
  reqObj: CreateUpdateNamedTrack
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/name-tracker/create-update`,
    reqObj,
  );
};

export const APIToUpdateNamedTrack = async (
  id: string,
  reqObj: CreateUpdateNamedTrack,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/name-tracker/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteNamedTrack = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/name-tracker/delete/${id}`,
  );
};

export const APIToExportNamedTrack = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/name-tracker/export-csv`);
};

export const APIToGetNamedTrackDDL = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/name-tracker/ddl`);
};

/* =====================================================================
   Workflow Routes module — work centres DDL & routes
   ===================================================================== */

const buildPaginateQuery = (filterReq: PaginateReqEntity): string => {
  let query = "";

  query = query.concat(`pageSize=${filterReq.pageSize}`);

  query = query.concat(`&pageNumber=${filterReq.pageNumber + 1}`);

  query = query.concat(`&searchText=${filterReq.searchText ?? ""}`);

  if (filterReq.sortColumn && !IsStringNullEmptyOrUndefined(filterReq.sortColumn)) {
    query = query.concat(`&sortColumn=${filterReq.sortColumn}`);
  }

  if (filterReq.sortOrder && !IsStringNullEmptyOrUndefined(filterReq.sortOrder)) {
    query = query.concat(`&sortOrder=${filterReq.sortOrder}`);
  }

  if (filterReq.status && !IsStringNullEmptyOrUndefined(filterReq.status)) {
    query = query.concat(`&status=${filterReq.status}`);
  }

  return query;
};

/* ---------- work centers DDL (read-only building blocks) ---------- */

export const APIGetWorkCentersDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/get-work-centers-ddl`,
  );
};

export const APIToGetWorkCenterFilterDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.ProductionMasters}/work-station/selected-work-center-ddl`,
  );
};
/* ---------- named tracks DDL (read-only, groups the work center dropdown) ---------- */

export const APIGetNameTrackersDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/get-name-trackers-ddl`,
  );
};

/* ---------- workflow routes ---------- */

export const APICreateWorkflowRoute = async (
  reqObj: WorkflowRouteReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/create`,
    reqObj,
  );
};

export const APIUpdateWorkflowRoute = async (
  reqObj: WorkflowRouteReqEntity,
  id: string,
): Promise<AxiosResponse> => {
  return await axios.put(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/update/${id}`,
    reqObj,
  );
};

export const APIFetchDetailsWorkflowRoute = async (
  filterReq: PaginateReqEntity,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/get-all?${buildPaginateQuery(filterReq)}`,
  );
};

export const APIFetchWorkflowRouteById = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/${id}`,
  );
};

export const APIDeleteWorkflowRoute = async (
  id: string,
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/delete/${id}`,
  );
};

export const APIGetWorkflowRoutesDDL = async (): Promise<AxiosResponse> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/get-ddl`,
  );
};

export const APIValidateProductionDrawingWorkflowRoutes = async (
  workOrderId: string,
  locations: { solutionId: string; solutionType: string }[],
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/v2.0/validate-production-drawing-workflow-routes`,
    { workOrderId, locations },
  );
};
export const APIToExportWorkflowRoutes = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.workflowRouteSetting}/export`,
  );
};

export const APIFetchLocationTrackerPromiseKept = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.productionTracker}/fetch-promise-kept-percentage`
  );
};

export const APIToCreateEWayBillForRejectedInvoiceDistance = async (
  workOrderDetails: GenerateEWayBillForWorkOrderInvoiceDistanceReqEntity,
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.eInvoice}/generate-e-way-bill`,
    workOrderDetails,
  );
};

export const APITocreateWorkOrderNote = async (
  workOrderId: string,
  note: string
): Promise<AxiosResponse> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.workOrder}/add-notes/${workOrderId}`,
    { note }
  );
};

export const APIToGetCSMasterTypes = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.csMasterTypes}`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateCSMasterTypes = async (
  reqObj: CreateUpdateCSMasterTypesReq
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.csMasterTypes}/create-update`,
    reqObj,
  );
};

export const APIToUpdateCSMasterTypes = async (
  id: string,
  reqObj: CreateUpdateCSMasterTypesReq,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.csMasterTypes}/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToDeleteCSMasterTypes = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.csMasterTypes}/delete/${id}`,
  );
};

export const APIToExportCSMasterTypes = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.csMasterTypes}/export-csv`
  );
};

export const APIToExportBOMModelWiseMappings = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/export-csv`
  );
};

export const APIToGetBOMFormulaVariables = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/get-formula-variables`
  );
};

export const APIToGetBOMModelWiseMappings = async (
  reqObj: BOMModelWiseMappingListReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToGetBOMCSCodesDDL = async (
  reqObj?: BOMModelCascadeEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/get-cs-codes-ddl`,
    reqObj || {}
  );
};

export const APIToGetBOMReferenceModulesDDL = async (
  reqObj: BOMReferenceModulesDDLReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/get-reference-modules-ddl`,
    reqObj || { moduleTypes: [] }
  );
};

export const APIToGetBOMOrientationDDL = async (
  reqObj: BOMOrientationDDLReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/get-orientation-ddl`,
    reqObj,
  );
};

export const APIToCreateBOMModelWiseMapping = async (
  reqObj: BOMModelWiseMappingCreateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/create-update`,
    reqObj,
  );
};

export const APIToUpdateBOMModelWiseMapping = async (
  id: string,
  reqObj: BOMModelWiseMappingUpdateReqEntity,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/create-update?id=${id}`,
    reqObj,
  );
};

export const APIToGetBOMCopyItems = async (
  reqObj: BOMModelCascadeEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/get-copy-items`,
    reqObj,
  );
};

export const APIToCopyBOMModelWiseMappings = async (
  reqObj: BOMModelWiseMappingCopyReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/copy`,
    reqObj,
  );
};

export const APIToDeleteBOMModelWiseMapping = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomModelWiseMapping}/delete/${id}`,
  );
};

export const APIToGetRMProjectionList = async (
  reqObj: RMProjectionListReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.rmProjection}/get-all`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToGetRMProjectionDetails = async (
  reqObj: RMProjectionDetailsReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.rmProjection}/details`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToExportRMProjection = async (
  reqObj: RMProjectionListExportReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.rmProjection}/export`,
    reqObj,
  );
};

export const APIToExportRMProjectionDetails = async (
  reqObj: RMProjectionDetailsExportReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.rmProjection}/details/export`,
    reqObj,
  );
};

export const APIToGetBOMUOM = async (
  reqObj: PaginateReqEntity
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomMappingUom}`,
    {
      ...reqObj,
      pageNumber: reqObj.pageNumber + 1,
    },
  );
};

export const APIToCreateBOMUOM = async (
  reqObj: CreateUpdateBOMUOMReq
): Promise<AxiosResponse<APIResponseEntity>> => {
  const payload = {
    name: reqObj.name,
    isActive: reqObj.isActive,
  };
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomMappingUom}/create-update`,
    payload,
  );
};

export const APIToUpdateBOMUOM = async (
  id: string,
  reqObj: CreateUpdateBOMUOMReq,
): Promise<AxiosResponse<APIResponseEntity>> => {
  const payload = {
    name: reqObj.name,
    isActive: reqObj.isActive,
  };
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomMappingUom}/create-update?id=${id}`,
    payload,
  );
};

export const APIToDeleteBOMUOM = async (
  id: string,
): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.post(
    `${APIURL}/${BaseEndpoints.bomMappingUom}/delete/${id}`,
  );
};

export const APIToGetBomMappingUOMDDL = async (): Promise<AxiosResponse<APIResponseEntity>> => {
  return await axios.get(
    `${APIURL}/${BaseEndpoints.bomMappingUom}/get-ddl`
  );
};

